var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// react-imports.ts
import React from "react";

// src/Actions/index.tsx
import clsx3 from "clsx";
import { forwardRef as forwardRef2 } from "react";

// ../../node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

// ../../node_modules/@radix-ui/react-slot/dist/index.mjs
import { forwardRef as $9IrjX$forwardRef, Children as $9IrjX$Children, isValidElement as $9IrjX$isValidElement, createElement as $9IrjX$createElement, cloneElement as $9IrjX$cloneElement, Fragment as $9IrjX$Fragment } from "react";

// ../../node_modules/@radix-ui/react-compose-refs/dist/index.mjs
import { useCallback as $3vqmr$useCallback } from "react";
function $6ed0406888f73fc4$var$setRef(ref, value) {
  if (typeof ref === "function")
    ref(value);
  else if (ref !== null && ref !== void 0)
    ref.current = value;
}
function $6ed0406888f73fc4$export$43e446d32b3d21af(...refs) {
  return (node) => refs.forEach((ref) => $6ed0406888f73fc4$var$setRef(ref, node));
}

// ../../node_modules/@radix-ui/react-slot/dist/index.mjs
var $5e63c961fc1ce211$export$8c6ed5c666ac1360 = /* @__PURE__ */ $9IrjX$forwardRef((props, forwardedRef) => {
  const _a = props, { children } = _a, slotProps = __objRest(_a, ["children"]);
  const childrenArray = $9IrjX$Children.toArray(children);
  const slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable);
  if (slottable) {
    const newElement = slottable.props.children;
    const newChildren = childrenArray.map((child) => {
      if (child === slottable) {
        if ($9IrjX$Children.count(newElement) > 1)
          return $9IrjX$Children.only(null);
        return /* @__PURE__ */ $9IrjX$isValidElement(newElement) ? newElement.props.children : null;
      } else
        return child;
    });
    return /* @__PURE__ */ $9IrjX$createElement($5e63c961fc1ce211$var$SlotClone, _extends({}, slotProps, {
      ref: forwardedRef
    }), /* @__PURE__ */ $9IrjX$isValidElement(newElement) ? /* @__PURE__ */ $9IrjX$cloneElement(newElement, void 0, newChildren) : null);
  }
  return /* @__PURE__ */ $9IrjX$createElement($5e63c961fc1ce211$var$SlotClone, _extends({}, slotProps, {
    ref: forwardedRef
  }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360.displayName = "Slot";
var $5e63c961fc1ce211$var$SlotClone = /* @__PURE__ */ $9IrjX$forwardRef((props, forwardedRef) => {
  const _a = props, { children } = _a, slotProps = __objRest(_a, ["children"]);
  if (/* @__PURE__ */ $9IrjX$isValidElement(children))
    return /* @__PURE__ */ $9IrjX$cloneElement(children, __spreadProps(__spreadValues({}, $5e63c961fc1ce211$var$mergeProps(slotProps, children.props)), {
      ref: forwardedRef ? $6ed0406888f73fc4$export$43e446d32b3d21af(forwardedRef, children.ref) : children.ref
    }));
  return $9IrjX$Children.count(children) > 1 ? $9IrjX$Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
var $5e63c961fc1ce211$export$d9f1ccf0bdb05d45 = ({ children }) => {
  return /* @__PURE__ */ $9IrjX$createElement($9IrjX$Fragment, null, children);
};
function $5e63c961fc1ce211$var$isSlottable(child) {
  return /* @__PURE__ */ $9IrjX$isValidElement(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45;
}
function $5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
  const overrideProps = __spreadValues({}, childProps);
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) {
      if (slotPropValue && childPropValue)
        overrideProps[propName] = (...args) => {
          childPropValue(...args);
          slotPropValue(...args);
        };
      else if (slotPropValue)
        overrideProps[propName] = slotPropValue;
    } else if (propName === "style")
      overrideProps[propName] = __spreadValues(__spreadValues({}, slotPropValue), childPropValue);
    else if (propName === "className")
      overrideProps[propName] = [
        slotPropValue,
        childPropValue
      ].filter(Boolean).join(" ");
  }
  return __spreadValues(__spreadValues({}, slotProps), overrideProps);
}

// src/Button/index.tsx
import { cva } from "class-variance-authority";
import * as React2 from "react";

// src/utils.ts
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// src/Button/index.tsx
var buttonVariants = cva("inline-flex items-center justify-center rounded-xl text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-20 border border-transparent", {
  variants: {
    variant: {
      default: "bg-primary text-primary-foreground shadow hover:opacity-90",
      secondary: "bg-secondary text-secondary-foreground shadow-sm hover:opacity-90",
      tertiary: "bg-tertiary text-tertiary-foreground shadow-sm hover:opacity-90",
      constructive: "bg-constructive text-constructive-foreground shadow-sm hover:bg-constructive/90",
      destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
      warning: "bg-warning text-warning-foreground shadow-sm hover:bg-warning/90",
      outline: "border-input bg-transparent shadow-sm hover:bg-accent hover:text-accent-foreground",
      ghost: "hover:bg-accent hover:text-accent-foreground",
      link: "text-primary underline-offset-4 hover:underline",
      raised: "control-gradient z-[40]"
    },
    size: {
      default: "h-11 px-4 py-2",
      xs: "h-6 rounded-xl px-3 text-xs",
      sm: "h-8 rounded-xl px-3 text-xs",
      lg: "h-10 rounded-xl px-8",
      icon: "h-11 w-11"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "default"
  }
});
var Button = React2.forwardRef((_a, ref) => {
  var _b = _a, { className, variant, size: size2, asChild = false, type = "button" } = _b, props = __objRest(_b, ["className", "variant", "size", "asChild", "type"]);
  const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : "button";
  return /* @__PURE__ */ React2.createElement(Comp, __spreadValues({
    type,
    className: cn(buttonVariants({ variant, size: size2, className })),
    ref
  }, props));
});
Button.displayName = "Button";

// src/Spinner/index.tsx
import clsx2 from "clsx";

// src/types/shared.ts
var Progress = /* @__PURE__ */ ((Progress2) => {
  Progress2["complete"] = "complete";
  Progress2["current"] = "current";
  Progress2["upcoming"] = "upcoming";
  Progress2["followUp"] = "followUp";
  return Progress2;
})(Progress || {});
var Size = /* @__PURE__ */ ((Size2) => {
  Size2["xs"] = "xs";
  Size2["sm"] = "sm";
  Size2["md"] = "md";
  Size2["lg"] = "lg";
  Size2["xl"] = "xl";
  Size2["2xl"] = "2xl";
  return Size2;
})(Size || {});

// src/Spinner/index.tsx
var sizes = {
  xs: "w-4 h-4",
  sm: "w-6 h-6",
  md: "w-8 h-8",
  lg: "w-10 h-10",
  xl: "w-12 h-12",
  "2xl": "w-14 h-14"
};
function Spinner({ className, containerClassName, style, centered, size: size2 = "md" /* md */ }) {
  const element = /* @__PURE__ */ React.createElement("svg", {
    role: "status",
    style,
    className: clsx2("inline mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-tertiary dark:fill-tertiary", sizes[size2], className),
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
    fill: "currentColor"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
    fill: "currentFill"
  }));
  if (centered) {
    return /* @__PURE__ */ React.createElement("div", {
      className: clsx2("flex w-full justify-center py-4", containerClassName)
    }, element);
  }
  return element;
}

// src/Actions/index.tsx
var Actions = forwardRef2(({
  variant,
  condensed = false,
  closeDisabled,
  closeLabel = "Close",
  onClose,
  primaryDisabled,
  primaryLabel,
  onPrimary,
  loading
}, ref) => {
  const buttons = [];
  if (onPrimary) {
    buttons.push(/* @__PURE__ */ React.createElement(Button, {
      key: primaryLabel,
      variant,
      className: "w-full justify-center sm:col-start-2 sm:text-sm",
      disabled: primaryDisabled || loading,
      onClick: () => {
        onPrimary();
        onClose(false);
      }
    }, loading && /* @__PURE__ */ React.createElement(Spinner, {
      className: "my-0.5",
      size: "xs"
    }), !loading && primaryLabel));
  }
  buttons.push(/* @__PURE__ */ React.createElement(Button, {
    key: closeLabel,
    variant: !!onPrimary ? "outline" : variant,
    disabled: closeDisabled || loading,
    className: "mt-3 w-full justify-center sm:mt-0 sm:col-start-1 sm:text-sm",
    onClick: () => onClose(false),
    ref
  }, closeLabel));
  return /* @__PURE__ */ React.createElement("div", {
    className: clsx3({
      "flex justify-center items-center gap-2": !!onPrimary,
      "mt-5 sm:mt-6": !condensed
    })
  }, buttons);
});
Actions.displayName = "Actions";

// src/Alert/index.tsx
import { useTranslation } from "@sg/i18n";
import * as React3 from "react";
function BaseAlert({ Icon: Icon2, className, message, action, onClick }) {
  const { t } = useTranslation();
  return /* @__PURE__ */ React3.createElement(Alert, {
    className: cn(className, "bg-[#3D424A]/90 text-white")
  }, /* @__PURE__ */ React3.createElement("div", {
    className: "flex justify-between items-center"
  }, /* @__PURE__ */ React3.createElement("div", {
    className: "flex items-center justify-start gap-3"
  }, /* @__PURE__ */ React3.createElement("div", {
    className: "w-10 h-10"
  }, /* @__PURE__ */ React3.createElement(Icon2, null)), /* @__PURE__ */ React3.createElement(AlertDescription, null, message)), onClick && /* @__PURE__ */ React3.createElement(Button, {
    variant: "ghost",
    size: "sm",
    className: "h-5 opacity-50 hover:bg-transparent",
    onClick
  }, /* @__PURE__ */ React3.createElement("span", {
    className: "underline"
  }, action || t("details")), /* @__PURE__ */ React3.createElement("span", {
    className: "pl-1",
    "aria-hidden": "true"
  }, /* @__PURE__ */ React3.createElement("svg", {
    width: "18",
    height: "14",
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React3.createElement("path", {
    opacity: "0.5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4697 0.46967C10.7626 0.176777 11.2374 0.176777 11.5303 0.46967L17.5303 6.46967C17.8232 6.76256 17.8232 7.23744 17.5303 7.53033L11.5303 13.5303C11.2374 13.8232 10.7626 13.8232 10.4697 13.5303C10.1768 13.2374 10.1768 12.7626 10.4697 12.4697L15.1893 7.75H1C0.585786 7.75 0.25 7.41421 0.25 7C0.25 6.58579 0.585786 6.25 1 6.25H15.1893L10.4697 1.53033C10.1768 1.23744 10.1768 0.762563 10.4697 0.46967Z",
    fill: "white"
  }))))));
}
function AlertInfo({ message, action, onClick, className }) {
  return /* @__PURE__ */ React3.createElement(BaseAlert, {
    Icon: AlertIconInfo,
    message,
    action,
    onClick,
    className
  });
}
function AlertWarning({ message, action, onClick, className }) {
  return /* @__PURE__ */ React3.createElement(BaseAlert, {
    Icon: AlertIconWarning,
    message,
    action,
    onClick,
    className
  });
}
function AlertError({ message, action, onClick, className }) {
  return /* @__PURE__ */ React3.createElement(BaseAlert, {
    Icon: AlertIconError,
    message,
    action,
    onClick,
    className
  });
}
function AlertSuccess({ message, action, onClick, className }) {
  return /* @__PURE__ */ React3.createElement(BaseAlert, {
    Icon: AlertIconSuccess,
    message,
    action,
    onClick,
    className
  });
}
var Alert = React3.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React3.createElement("div", __spreadValues({
    ref,
    className: cn("relative w-full rounded-lg border px-5 py-4 text-sm [&>svg+div]:translate-y-[-3px] [&>svg]:left-4 [&>svg]:text-foreground [&>svg~*]:pl-7 min-h-[72px]", className),
    role: "alert"
  }, props));
});
Alert.displayName = "Alert";
var AlertTitle = React3.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React3.createElement("h5", __spreadValues({
    ref,
    className: cn("mb-1 font-medium leading-none tracking-tight", className)
  }, props));
});
AlertTitle.displayName = "AlertTitle";
var AlertDescription = React3.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React3.createElement("div", __spreadValues({
    ref,
    className: cn("text-sm [&_p]:leading-relaxed font-bold", className)
  }, props));
});
AlertDescription.displayName = "AlertDescription";
function AlertIconError() {
  return /* @__PURE__ */ React3.createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React3.createElement("path", {
    d: "M36.6663 19.9997C36.6663 29.2044 29.2044 36.6663 19.9997 36.6663C10.7949 36.6663 3.33301 29.2044 3.33301 19.9997C3.33301 10.7949 10.7949 3.33301 19.9997 3.33301C29.2044 3.33301 36.6663 10.7949 36.6663 19.9997Z",
    fill: "#CE0000"
  }), /* @__PURE__ */ React3.createElement("path", {
    d: "M14.9491 14.9491C15.4373 14.461 16.2287 14.461 16.7169 14.9491L19.9997 18.2319L23.2825 14.9492C23.7706 14.461 24.5621 14.461 25.0502 14.9492C25.5384 15.4373 25.5384 16.2288 25.0502 16.7169L21.7675 19.9997L25.0502 23.2824C25.5383 23.7706 25.5383 24.562 25.0502 25.0502C24.562 25.5383 23.7706 25.5383 23.2824 25.0502L19.9997 21.7675L16.7169 25.0502C16.2288 25.5384 15.4373 25.5384 14.9492 25.0502C14.461 24.5621 14.461 23.7706 14.9492 23.2825L18.2319 19.9997L14.9491 16.7169C14.461 16.2287 14.461 15.4373 14.9491 14.9491Z",
    fill: "white"
  }));
}
function AlertIconInfo() {
  return /* @__PURE__ */ React3.createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React3.createElement("path", {
    d: "M36.6663 19.9997C36.6663 29.2044 29.2044 36.6663 19.9997 36.6663C10.7949 36.6663 3.33301 29.2044 3.33301 19.9997C3.33301 10.7949 10.7949 3.33301 19.9997 3.33301C29.2044 3.33301 36.6663 10.7949 36.6663 19.9997Z",
    fill: "#1A73E8"
  }), /* @__PURE__ */ React3.createElement("path", {
    d: "M19.9997 29.5837C20.69 29.5837 21.2497 29.024 21.2497 28.3337V18.3337C21.2497 17.6433 20.69 17.0837 19.9997 17.0837C19.3093 17.0837 18.7497 17.6433 18.7497 18.3337V28.3337C18.7497 29.024 19.3093 29.5837 19.9997 29.5837Z",
    fill: "white"
  }), /* @__PURE__ */ React3.createElement("path", {
    d: "M19.9997 11.667C20.9201 11.667 21.6663 12.4132 21.6663 13.3337C21.6663 14.2541 20.9201 15.0003 19.9997 15.0003C19.0792 15.0003 18.333 14.2541 18.333 13.3337C18.333 12.4132 19.0792 11.667 19.9997 11.667Z",
    fill: "white"
  }));
}
function AlertIconSuccess() {
  return /* @__PURE__ */ React3.createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React3.createElement("path", {
    d: "M36.6663 19.9997C36.6663 29.2044 29.2044 36.6663 19.9997 36.6663C10.7949 36.6663 3.33301 29.2044 3.33301 19.9997C3.33301 10.7949 10.7949 3.33301 19.9997 3.33301C29.2044 3.33301 36.6663 10.7949 36.6663 19.9997Z",
    fill: "#2FCB2F"
  }), /* @__PURE__ */ React3.createElement("path", {
    d: "M26.7175 14.9491C27.2057 15.4373 27.2057 16.2287 26.7175 16.7169L18.3842 25.0502C17.8961 25.5384 17.1046 25.5384 16.6164 25.0502L13.2831 21.7169C12.795 21.2287 12.795 20.4373 13.2831 19.9491C13.7713 19.461 14.5627 19.461 15.0509 19.9491L17.5003 22.3986L21.225 18.6738L24.9498 14.9491C25.4379 14.461 26.2294 14.461 26.7175 14.9491Z",
    fill: "white"
  }));
}
function AlertIconWarning() {
  return /* @__PURE__ */ React3.createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React3.createElement("path", {
    d: "M36.6663 19.9997C36.6663 29.2044 29.2044 36.6663 19.9997 36.6663C10.7949 36.6663 3.33301 29.2044 3.33301 19.9997C3.33301 10.7949 10.7949 3.33301 19.9997 3.33301C29.2044 3.33301 36.6663 10.7949 36.6663 19.9997Z",
    fill: "#F97316"
  }), /* @__PURE__ */ React3.createElement("path", {
    d: "M20.0003 11.6663C19.31 11.6663 18.7503 12.226 18.7503 12.9163L18.7503 22.9163C18.7503 23.6067 19.31 24.1663 20.0003 24.1663C20.6907 24.1663 21.2503 23.6067 21.2503 22.9163L21.2503 12.9163C21.2503 12.226 20.6907 11.6663 20.0003 11.6663Z",
    fill: "white"
  }), /* @__PURE__ */ React3.createElement("path", {
    d: "M20.0003 29.583C19.0799 29.583 18.3337 28.8368 18.3337 27.9163C18.3337 26.9959 19.0799 26.2497 20.0003 26.2497C20.9208 26.2497 21.667 26.9959 21.667 27.9163C21.667 28.8368 20.9208 29.583 20.0003 29.583Z",
    fill: "white"
  }));
}

// src/Avatar/index.tsx
import clsx4 from "clsx";
import { useMemo } from "react";
var sizes2 = {
  xs: "w-6 h-6",
  sm: "w-8 h-8",
  md: "w-10 h-10",
  lg: "w-12 h-12",
  xl: "w-14 h-14",
  "2xl": "w-16 h-16"
};
var fontSizes = {
  xs: "text-xs",
  sm: "text-sm",
  md: "text-base",
  lg: "text-lg",
  xl: "text-xl",
  "2xl": "text-xl"
};
var getInitials = (fullName = "") => {
  const allNames = fullName.trim().split(" ");
  const initials = allNames.reduce((acc, curr, index) => {
    if (index === 0 || index === allNames.length - 1) {
      acc = `${acc}${curr.charAt(0).toUpperCase()}`;
    }
    return acc;
  }, "");
  return initials;
};
function Avatar({ name, icon, className, labelClassName, size: size2 = "md" /* md */ }) {
  const initials = useMemo(() => getInitials(name), [name]);
  return /* @__PURE__ */ React.createElement("span", {
    className: clsx4("inline-flex items-center justify-center rounded-full bg-tertiary", sizes2[size2], className)
  }, /* @__PURE__ */ React.createElement("span", {
    className: clsx4("font-medium leading-none text-white", fontSizes[size2], labelClassName)
  }, icon || initials));
}

// src/Badge/index.tsx
import { cva as cva2 } from "class-variance-authority";
import * as React4 from "react";
var badgeVariants = cva2("inline-flex items-center rounded-xl border px-2.5 py-0.5 text-xs leading-5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2", {
  variants: {
    variant: {
      default: "border-transparent bg-primary text-primary-foreground shadow",
      secondary: "border-transparent bg-tertiary text-tertiary-foreground",
      constructive: "border-transparent bg-constructive text-constructive-foreground shadow hover:bg-constructive/80",
      destructive: "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
      outline: "bg-[#3D424A]/50 text-foreground"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
function Badge(_a) {
  var _b = _a, { className, variant } = _b, props = __objRest(_b, ["className", "variant"]);
  return /* @__PURE__ */ React4.createElement("div", __spreadValues({
    className: cn(badgeVariants({ variant }), className)
  }, props));
}

// src/ButtonGroup/index.tsx
import clsx7 from "clsx";
import { Children, cloneElement, isValidElement, useMemo as useMemo2 } from "react";

// src/Form/FormHelpLabel.tsx
import clsx5 from "clsx";
function FormHelpLabel({ id, error, errorLabel, helpLabel, className }) {
  const hasError = error && errorLabel;
  return hasError || helpLabel ? /* @__PURE__ */ React.createElement("p", {
    id,
    className: clsx5("mt-2 text-sm", {
      "text-destructive": hasError,
      "foreground-muted": !!helpLabel && !hasError
    }, className)
  }, error ? errorLabel : helpLabel) : /* @__PURE__ */ React.createElement(React.Fragment, null);
}

// src/Form/FormLabel.tsx
import { useTranslation as useTranslation2 } from "@sg/i18n";
import clsx6 from "clsx";
function FormLabel({ label, name, optional, className }) {
  const { t } = useTranslation2();
  return label || optional ? /* @__PURE__ */ React.createElement("div", {
    className: "flex justify-between items-center"
  }, /* @__PURE__ */ React.createElement("label", {
    id: name,
    htmlFor: name,
    className: clsx6("block text-sm font-medium foreground-secondary", className)
  }, label, " ", optional && /* @__PURE__ */ React.createElement(React.Fragment, null, " ", `(${t("Optional")})`))) : /* @__PURE__ */ React.createElement(React.Fragment, null);
}

// src/ButtonGroup/index.tsx
function getButtonItemClass(idx, count, buttonClassName) {
  let cls = "focus:z-[1] ";
  if (idx === 0) {
    cls += "rounded-l-md relative rounded-r-none";
  } else if (idx === count - 1) {
    cls += "-ml-px relative rounded-r-md rounded-l-none";
  } else {
    cls += "-ml-px relative rounded-none";
  }
  if (buttonClassName) {
    cls += ` ${buttonClassName}`;
  }
  return cls;
}
function ButtonGroup({ children }) {
  const groupItems = useMemo2(() => {
    const count = Children.count(children);
    const childrenArr = Children.toArray(children);
    return childrenArr.map((child, idx) => {
      if (isValidElement(child)) {
        return cloneElement(child, __spreadProps(__spreadValues({}, child.props), {
          className: clsx7(child.props.className, getButtonItemClass(idx, count))
        }));
      }
      return child;
    });
  }, [children]);
  return /* @__PURE__ */ React.createElement("span", {
    className: "relative z-0 inline-flex shadow-sm rounded-md"
  }, groupItems);
}
function ButtonGroupControlled({
  className,
  buttonClassName,
  label,
  selected,
  onChange,
  disabled,
  items,
  size: size2
}) {
  return /* @__PURE__ */ React.createElement("div", null, label && /* @__PURE__ */ React.createElement(FormLabel, {
    label
  }), /* @__PURE__ */ React.createElement("span", {
    className: clsx7("relative z-0 inline-flex shadow-sm rounded-md", className, {
      "mt-[4px]": !!label,
      "opacity-60 pointer-events-none": disabled
    })
  }, items.map((item, idx) => {
    const { label: label2, id } = item;
    const isSelected = id === selected;
    return /* @__PURE__ */ React.createElement(Button, {
      size: size2,
      id,
      key: id,
      variant: isSelected ? item.variant || "tertiary" : "outline",
      className: getButtonItemClass(idx, items.length, buttonClassName),
      onClick: () => {
        onChange(isSelected ? null : id);
      }
    }, label2);
  })));
}

// src/Card/index.tsx
import clsx8 from "clsx";
var TitleLabel = ({ title, className }) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("h3", {
    className: cn("text-sm m-4 mb-2 leading-3", className)
  }, title));
};
function Card({ className, contentClassName, children, title, titleClassName, titleActions }) {
  return /* @__PURE__ */ React.createElement("div", {
    className: clsx8("flex flex-col overflow-hidden bg-gradient-card shadow-inner rounded-xl", className)
  }, /* @__PURE__ */ React.createElement("div", {
    className: "flex items-center justify-between gap-2"
  }, title && /* @__PURE__ */ React.createElement(TitleLabel, {
    title,
    className: titleClassName
  }), titleActions), /* @__PURE__ */ React.createElement("div", {
    className: clsx8("p-3 text-foreground", contentClassName)
  }, children));
}

// src/Carousel/index.tsx
import useEmblaCarousel from "embla-carousel-react";
import * as React5 from "react";
var CarouselContext = React5.createContext(null);
function useCarousel() {
  const context = React5.useContext(CarouselContext);
  if (!context) {
    throw new Error("useCarousel must be used within a <Carousel />");
  }
  return context;
}
var Carousel = React5.forwardRef((_a, ref) => {
  var _b = _a, { orientation = "horizontal", opts, setApi, plugins, className, children } = _b, props = __objRest(_b, ["orientation", "opts", "setApi", "plugins", "className", "children"]);
  const [carouselRef, api] = useEmblaCarousel(__spreadProps(__spreadValues({}, opts), {
    axis: orientation === "horizontal" ? "x" : "y"
  }), plugins);
  const [canScrollPrev, setCanScrollPrev] = React5.useState(false);
  const [canScrollNext, setCanScrollNext] = React5.useState(false);
  const onSelect = React5.useCallback((api2) => {
    if (!api2) {
      return;
    }
    setCanScrollPrev(api2.canScrollPrev());
    setCanScrollNext(api2.canScrollNext());
  }, []);
  const scrollPrev = React5.useCallback(() => {
    api == null ? void 0 : api.scrollPrev();
  }, [api]);
  const scrollNext = React5.useCallback(() => {
    api == null ? void 0 : api.scrollNext();
  }, [api]);
  const handleKeyDown = React5.useCallback((event) => {
    if (event.key === "ArrowLeft") {
      event.preventDefault();
      scrollPrev();
    } else if (event.key === "ArrowRight") {
      event.preventDefault();
      scrollNext();
    }
  }, [scrollPrev, scrollNext]);
  React5.useEffect(() => {
    if (!api || !setApi) {
      return;
    }
    setApi(api);
  }, [api, setApi]);
  React5.useEffect(() => {
    if (!api) {
      return;
    }
    onSelect(api);
    api.on("reInit", onSelect);
    api.on("select", onSelect);
    return () => {
      api == null ? void 0 : api.off("select", onSelect);
    };
  }, [api, onSelect]);
  return /* @__PURE__ */ React5.createElement(CarouselContext.Provider, {
    value: {
      carouselRef,
      api,
      opts,
      orientation: orientation || ((opts == null ? void 0 : opts.axis) === "y" ? "vertical" : "horizontal"),
      scrollPrev,
      scrollNext,
      canScrollPrev,
      canScrollNext
    }
  }, /* @__PURE__ */ React5.createElement("div", __spreadValues({
    ref,
    onKeyDownCapture: handleKeyDown,
    className: cn("relative", className),
    role: "region",
    "aria-roledescription": "carousel"
  }, props), children));
});
Carousel.displayName = "Carousel";
var CarouselContent = React5.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  const { carouselRef, orientation } = useCarousel();
  return /* @__PURE__ */ React5.createElement("div", {
    ref: carouselRef,
    className: "overflow-hidden"
  }, /* @__PURE__ */ React5.createElement("div", __spreadValues({
    ref,
    className: cn("flex", orientation === "horizontal" ? "-ml-4" : "-mt-4 flex-col", className)
  }, props)));
});
CarouselContent.displayName = "CarouselContent";
var CarouselItem = React5.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  const { orientation } = useCarousel();
  return /* @__PURE__ */ React5.createElement("div", __spreadValues({
    ref,
    role: "group",
    "aria-roledescription": "slide",
    className: cn("min-w-0 shrink-0 grow-0 basis-full", orientation === "horizontal" ? "pl-4" : "pt-4", className)
  }, props));
});
CarouselItem.displayName = "CarouselItem";
var CarouselPrevious = React5.forwardRef((p, ref) => {
  const { orientation, scrollPrev, canScrollPrev } = useCarousel();
  const _a = p, { className, variant = "outline", size: size2 = "icon" } = _a, props = __objRest(_a, ["className", "variant", "size"]);
  return /* @__PURE__ */ React5.createElement(Button, __spreadValues({
    ref,
    variant,
    size: size2,
    className: cn("absolute  h-8 w-8 rounded-full", orientation === "horizontal" ? "-left-12 top-1/2 -translate-y-1/2" : "-top-12 left-1/2 -translate-x-1/2 rotate-90", className),
    disabled: !canScrollPrev,
    onClick: scrollPrev
  }, props), /* @__PURE__ */ React5.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React5.createElement("path", {
    d: "M12.9697 8.46967C13.2626 8.17678 13.7374 8.17678 14.0303 8.46967C14.3232 8.76256 14.3232 9.23744 14.0303 9.53033L11.5607 12L14.0303 14.4697C14.3232 14.7626 14.3232 15.2374 14.0303 15.5303C13.7374 15.8232 13.2626 15.8232 12.9697 15.5303L9.96967 12.5303C9.67678 12.2374 9.67678 11.7626 9.96967 11.4697L12.9697 8.46967Z",
    fill: "white"
  })), /* @__PURE__ */ React5.createElement("span", {
    className: "sr-only"
  }, "Previous slide"));
});
CarouselPrevious.displayName = "CarouselPrevious";
var CarouselNext = React5.forwardRef((p, ref) => {
  const { orientation, scrollNext, canScrollNext } = useCarousel();
  const _a = p, { className, variant = "outline", size: size2 = "icon" } = _a, props = __objRest(_a, ["className", "variant", "size"]);
  return /* @__PURE__ */ React5.createElement(Button, __spreadValues({
    ref,
    variant,
    size: size2,
    className: cn("absolute h-8 w-8 rounded-full", orientation === "horizontal" ? "-right-12 top-1/2 -translate-y-1/2" : "-bottom-12 left-1/2 -translate-x-1/2 rotate-90", className),
    disabled: !canScrollNext,
    onClick: scrollNext
  }, props), /* @__PURE__ */ React5.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React5.createElement("path", {
    d: "M11.0303 8.46967C10.7374 8.17678 10.2626 8.17678 9.96967 8.46967C9.67678 8.76256 9.67678 9.23744 9.96967 9.53033L12.4393 12L9.96967 14.4697C9.67678 14.7626 9.67678 15.2374 9.96967 15.5303C10.2626 15.8232 10.7374 15.8232 11.0303 15.5303L14.0303 12.5303C14.3232 12.2374 14.3232 11.7626 14.0303 11.4697L11.0303 8.46967Z",
    fill: "white"
  })), /* @__PURE__ */ React5.createElement("span", {
    className: "sr-only"
  }, "Next slide"));
});
CarouselNext.displayName = "CarouselNext";

// src/Checkbox/index.tsx
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { IconCheck } from "@tabler/icons-react";

// src/Skeleton/Skeleton.tsx
import clsx9 from "clsx";
function Skeleton({ className, containerClassName, size: size2 = "md" /* md */ }) {
  const sizes3 = {
    xs: "h-1",
    sm: "h-2",
    md: "h-3",
    lg: "h-4",
    xl: "h-5",
    "2xl": "h-6"
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: clsx9("animate-pulse", containerClassName)
  }, /* @__PURE__ */ React.createElement("div", {
    className: clsx9("bg-slate-700 dark:bg-slate-300 rounded", className, sizes3[size2])
  }));
}

// src/Skeleton/SkeletonAvatar.tsx
import clsx10 from "clsx";
function SkeletonAvatar({ className, size: size2 = "md" /* md */ }) {
  const sizes3 = {
    xs: "w-6 h-6",
    sm: "w-8 h-8",
    md: "w-10 h-10",
    lg: "w-12 h-12",
    xl: "w-14 h-14",
    "2xl": "w-16 h-16"
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: "animate-pulse"
  }, /* @__PURE__ */ React.createElement("div", {
    className: clsx10("rounded-full bg-slate-700 dark:bg-slate-300", className, sizes3[size2])
  }));
}

// src/Skeleton/SkeletonTextInput.tsx
function SkeletonTextInput() {
  return /* @__PURE__ */ React.createElement("div", {
    className: "flex-row space-y-2 mt-1"
  }, /* @__PURE__ */ React.createElement(Skeleton, {
    className: "w-20"
  }), /* @__PURE__ */ React.createElement(Skeleton, {
    className: "!h-[38px]"
  }));
}

// src/Skeleton/SkeletonTextInputArea.tsx
function SkeletonTextInputArea() {
  return /* @__PURE__ */ React.createElement("div", {
    className: "flex-row space-y-2 mt-1"
  }, /* @__PURE__ */ React.createElement(Skeleton, {
    className: "w-20"
  }), /* @__PURE__ */ React.createElement(Skeleton, {
    className: "!h-[58px]"
  }));
}

// src/Checkbox/index.tsx
import React6 from "react";
var BaseCheckbox = React6.forwardRef((_a, ref) => {
  var _b = _a, { className, loading } = _b, props = __objRest(_b, ["className", "loading"]);
  return /* @__PURE__ */ React6.createElement(React6.Fragment, null, loading && /* @__PURE__ */ React6.createElement(Skeleton, {
    size: "lg",
    className: "w-4"
  }), !loading && /* @__PURE__ */ React6.createElement(CheckboxPrimitive.Root, __spreadValues({
    ref,
    className: cn("peer h-5 w-5 shrink-0 rounded-md focus-visible:outline-none disabled:cursor-not-allowed disabled:bg-white/10 bg-white/20 hover:bg-white/30 data-[state=checked]:text-primary-white", className)
  }, props), /* @__PURE__ */ React6.createElement(CheckboxPrimitive.Indicator, {
    className: cn("flex items-center justify-center text-current")
  }, /* @__PURE__ */ React6.createElement(IconCheck, {
    className: "h-[14px] w-[14px]"
  }))));
});
BaseCheckbox.displayName = CheckboxPrimitive.Root.displayName;
function Checkbox(_a) {
  var _b = _a, { label, name } = _b, props = __objRest(_b, ["label", "name"]);
  if (!label)
    return /* @__PURE__ */ React6.createElement(BaseCheckbox, __spreadValues({}, props));
  return /* @__PURE__ */ React6.createElement("div", {
    className: "relative flex items-start"
  }, /* @__PURE__ */ React6.createElement("div", {
    className: "flex items-center h-5"
  }, /* @__PURE__ */ React6.createElement(BaseCheckbox, __spreadValues({}, props))), label && /* @__PURE__ */ React6.createElement("div", {
    className: "ml-2 text-sm"
  }, /* @__PURE__ */ React6.createElement("label", {
    htmlFor: name,
    className: "font-medium text-gray-500"
  }, label), /* @__PURE__ */ React6.createElement("span", {
    id: `${name}-description`,
    className: "text-gray-500"
  }, /* @__PURE__ */ React6.createElement("span", {
    className: "sr-only"
  }, label))));
}

// src/DataTable/index.tsx
import {
  flexRender,
  getCoreRowModel,
  getExpandedRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable
} from "@tanstack/react-table";
import { useTranslation as useTranslation6 } from "@sg/i18n";
import clsx17 from "clsx";
import { json2csv } from "json-2-csv";
import get from "lodash/get";
import uniqBy from "lodash/uniqBy";
import { downloadFile } from "@sg/utils";
import { IconX as IconX2 } from "@tabler/icons-react";
import { Fragment as Fragment2, forwardRef as forwardRef13, useEffect as useEffect3, useImperativeHandle, useMemo as useMemo4, useRef, useState as useState5 } from "react";
import { usePrevious, useUpdateEffect } from "react-use";

// src/Icons/BaseIcons.tsx
function FolderOpenIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.35791 12.7787C2.74772 13.7201 2.99956 15.0291 3.50323 17.647C3.8658 19.5316 4.04709 20.4738 4.67523 21.0991C4.8382 21.2614 5.02054 21.4052 5.2186 21.5277C5.98195 21.9999 6.99539 21.9999 9.02227 21.9999H15.9777C18.0046 21.9999 19.0181 21.9999 19.7814 21.5277C19.9795 21.4052 20.1618 21.2614 20.3248 21.0991C20.9529 20.4738 21.1342 19.5316 21.4968 17.647C22.0004 15.0291 22.2523 13.7201 21.6421 12.7787C21.4864 12.5384 21.2943 12.321 21.0721 12.1332C20.2011 11.3975 18.7933 11.3975 15.9777 11.3975H9.02227C6.20667 11.3975 4.79888 11.3975 3.92792 12.1332C3.70566 12.321 3.51363 12.5384 3.35791 12.7787ZM9.69518 17.1806C9.69518 16.7814 10.0376 16.4577 10.4601 16.4577H14.5398C14.9622 16.4577 15.3047 16.7814 15.3047 17.1806C15.3047 17.5798 14.9622 17.9035 14.5398 17.9035H10.4601C10.0376 17.9035 9.69518 17.5798 9.69518 17.1806Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M3.5762 12.4846C3.68271 12.3586 3.80034 12.241 3.92792 12.1332C4.79888 11.3975 6.20667 11.3975 9.02227 11.3975H15.9777C18.7933 11.3975 20.2011 11.3975 21.0721 12.1332C21.2 12.2413 21.3179 12.3592 21.4247 12.4857V9.75579C21.4247 8.84687 21.4247 8.09279 21.3394 7.49156C21.2494 6.85704 21.0531 6.29458 20.5839 5.83245C20.5074 5.75707 20.4266 5.68552 20.342 5.61807C19.8302 5.21023 19.2167 5.04345 18.5222 4.96608C17.8531 4.89155 17.0102 4.89157 15.9769 4.89158L15.6242 4.89158C14.6421 4.89158 14.29 4.88587 13.9711 4.80533C13.7837 4.75802 13.604 4.69195 13.4352 4.60878C13.151 4.46867 12.9033 4.25762 12.2077 3.64132L11.7336 3.22128C11.5345 3.04489 11.3987 2.9245 11.2531 2.81755C10.6284 2.35879 9.86779 2.08132 9.07145 2.01534C8.88602 1.99998 8.6968 1.99999 8.41356 2.00002L8.29714 2.00001C7.65647 1.9999 7.23365 1.99983 6.86652 2.0612C5.26167 2.32947 3.96392 3.45143 3.64782 4.93575C3.57591 5.27344 3.57602 5.66035 3.57619 6.21853L3.5762 12.4846Z",
    fill: "white"
  }));
}
function SettingsIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28596 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M13.25 16C13.25 15.5858 13.5858 15.25 14 15.25H19C19.4142 15.25 19.75 15.5858 19.75 16C19.75 16.4142 19.4142 16.75 19 16.75H14C13.5858 16.75 13.25 16.4142 13.25 16Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M10 7.25C10.4142 7.25 10.75 7.58579 10.75 8C10.75 8.41421 10.4142 8.75 10 8.75L5 8.75C4.58579 8.75 4.25 8.41421 4.25 8C4.25 7.58579 4.58579 7.25 5 7.25L10 7.25Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M4.25 16C4.25 15.5858 4.58579 15.25 5 15.25H6C6.41421 15.25 6.75 15.5858 6.75 16C6.75 16.4142 6.41421 16.75 6 16.75H5C4.58579 16.75 4.25 16.4142 4.25 16Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M19 7.25C19.4142 7.25 19.75 7.58579 19.75 8C19.75 8.41421 19.4142 8.75 19 8.75H18C17.5858 8.75 17.25 8.41421 17.25 8C17.25 7.58579 17.5858 7.25 18 7.25L19 7.25Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 16C7.25 17.5188 8.48122 18.75 10 18.75C11.5188 18.75 12.75 17.5188 12.75 16C12.75 14.4812 11.5188 13.25 10 13.25C8.48122 13.25 7.25 14.4812 7.25 16ZM8.75 16C8.75 16.6904 9.30964 17.25 10 17.25C10.6904 17.25 11.25 16.6904 11.25 16C11.25 15.3096 10.6904 14.75 10 14.75C9.30964 14.75 8.75 15.3096 8.75 16Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 10.75C15.5188 10.75 16.75 9.51878 16.75 8C16.75 6.48122 15.5188 5.25 14 5.25C12.4812 5.25 11.25 6.48122 11.25 8C11.25 9.51878 12.4812 10.75 14 10.75ZM14 9.25C14.6904 9.25 15.25 8.69036 15.25 8C15.25 7.30964 14.6904 6.75 14 6.75C13.3096 6.75 12.75 7.30964 12.75 8C12.75 8.69036 13.3096 9.25 14 9.25Z",
    fill: "white"
  }));
}
function EyeIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M2 12C2 13.6394 2.42496 14.1915 3.27489 15.2957C4.97196 17.5004 7.81811 20 12 20C16.1819 20 19.028 17.5004 20.7251 15.2957C21.575 14.1915 22 13.6394 22 12C22 10.3606 21.575 9.80853 20.7251 8.70433C19.028 6.49956 16.1819 4 12 4C7.81811 4 4.97196 6.49956 3.27489 8.70433C2.42496 9.80853 2 10.3606 2 12Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 12C8.25 9.92893 9.92893 8.25 12 8.25C14.0711 8.25 15.75 9.92893 15.75 12C15.75 14.0711 14.0711 15.75 12 15.75C9.92893 15.75 8.25 14.0711 8.25 12ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z",
    fill: "white"
  }));
}
function EyeClosedIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91858 6.60514C2.70062 6.09833 2.11327 5.86373 1.60603 6.08111C1.0984 6.29867 0.863613 6.88739 1.08117 7.39502L1.0816 7.39602L1.08267 7.3985L1.08566 7.40539L1.09505 7.42667C1.10282 7.44415 1.11363 7.46814 1.12752 7.4982C1.15529 7.55832 1.19539 7.64283 1.2481 7.74825C1.35345 7.95894 1.5096 8.25405 1.71879 8.60549C2.12772 9.2925 2.74529 10.2048 3.59029 11.1245L2.79285 11.922C2.40232 12.3125 2.40232 12.9457 2.79285 13.3362C3.18337 13.7267 3.81654 13.7267 4.20706 13.3362L5.04746 12.4958C5.61245 12.952 6.24405 13.3819 6.94417 13.7524L6.16177 14.9549C5.86056 15.4178 5.99165 16.0372 6.45457 16.3384C6.91748 16.6397 7.53693 16.5086 7.83814 16.0456L8.82334 14.5315C9.50014 14.7391 10.2253 14.8869 11 14.9561V16.5003C11 17.0525 11.4477 17.5003 12 17.5003V13.0003C9.25227 13.0003 7.18102 11.8017 5.69633 10.4114C5.68823 10.4036 5.68003 10.3958 5.67173 10.3883C5.47324 10.2014 5.28532 10.011 5.10775 9.81981C4.35439 9.0085 3.80137 8.19404 3.43737 7.58253C3.25594 7.27771 3.12302 7.02595 3.03696 6.85383C2.99397 6.76784 2.96278 6.70196 2.94319 6.65954C2.93339 6.63834 2.92651 6.62302 2.9225 6.61401L2.91858 6.60514ZM1.08117 7.39502L1.99995 7.00026C1.08081 7.39418 1.08117 7.39502 1.08117 7.39502Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M15.2209 12.3984C14.2784 12.7694 13.209 13.0002 12 13.0002V17.5002C12.5523 17.5002 13 17.0525 13 16.5002V14.9559C13.772 14.8867 14.4974 14.7392 15.1764 14.5311L16.1618 16.0456C16.463 16.5085 17.0825 16.6396 17.5454 16.3384C18.0083 16.0372 18.1394 15.4177 17.8382 14.9548L17.0558 13.7524C17.757 13.3816 18.3885 12.9517 18.9527 12.496L19.7929 13.3361C20.1834 13.7267 20.8166 13.7267 21.2071 13.3361C21.5976 12.9456 21.5976 12.3124 21.2071 11.9219L20.4097 11.1245C21.1521 10.3164 21.7181 9.51502 22.1207 8.86887C22.384 8.44627 22.5799 8.08609 22.7116 7.82793C22.7775 7.69874 22.8274 7.59476 22.8619 7.5209C22.8791 7.48397 22.8924 7.45453 22.902 7.4332L22.9134 7.40736L22.917 7.39913L22.9191 7.39411C23.1367 6.88648 22.9015 6.2986 22.3939 6.08105C21.8864 5.86355 21.2985 6.09892 21.0809 6.60627L21.0759 6.61747C21.0706 6.62926 21.0617 6.6489 21.0492 6.6758C21.0241 6.72962 20.9844 6.81235 20.9299 6.91928C20.8207 7.13337 20.6526 7.4431 20.4233 7.81119C19.9628 8.55023 19.2652 9.50857 18.3156 10.3999C17.4746 11.1893 16.4469 11.9158 15.2209 12.3984Z",
    fill: "white"
  }));
}
function CheckboxOnIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M16.0303 8.96967C16.3232 9.26256 16.3232 9.73744 16.0303 10.0303L11.0303 15.0303C10.7374 15.3232 10.2626 15.3232 9.96967 15.0303L7.96967 13.0303C7.67678 12.7374 7.67678 12.2626 7.96967 11.9697C8.26256 11.6768 8.73744 11.6768 9.03033 11.9697L10.5 13.4393L14.9697 8.96967C15.2626 8.67678 15.7374 8.67678 16.0303 8.96967Z",
    fill: "white"
  }));
}
function CheckboxOffIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22Z",
    fill: "white"
  }));
}
function ArrowUpIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M21.9995 12C21.9995 6.47715 17.5224 2 11.9995 2C6.47666 2 1.99951 6.47715 1.99951 12C1.99951 17.5228 6.47666 22 11.9995 22C17.5224 22 21.9995 17.5228 21.9995 12Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M8.46967 12.9697C8.17678 13.2626 8.17678 13.7374 8.46967 14.0303C8.76256 14.3232 9.23744 14.3232 9.53033 14.0303L12 11.5607L14.4697 14.0303C14.7626 14.3232 15.2374 14.3232 15.5303 14.0303C15.8232 13.7374 15.8232 13.2626 15.5303 12.9697L12.5303 9.96967C12.2374 9.67678 11.7626 9.67678 11.4697 9.96967L8.46967 12.9697Z",
    fill: "white"
  }));
}
function ArrowDownIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M15.5303 11.0303C15.8232 10.7374 15.8232 10.2626 15.5303 9.96967C15.2374 9.67678 14.7626 9.67678 14.4697 9.96967L12 12.4393L9.53033 9.96967C9.23744 9.67678 8.76256 9.67678 8.46967 9.96967C8.17678 10.2626 8.17678 10.7374 8.46967 11.0303L11.4697 14.0303C11.7626 14.3232 12.2374 14.3232 12.5303 14.0303L15.5303 11.0303Z",
    fill: "white"
  }));
}
function ArrowLeftIcon({ className }) {
  return /* @__PURE__ */ React.createElement("svg", {
    className,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M12.9697 8.46967C13.2626 8.17678 13.7374 8.17678 14.0303 8.46967C14.3232 8.76256 14.3232 9.23744 14.0303 9.53033L11.5607 12L14.0303 14.4697C14.3232 14.7626 14.3232 15.2374 14.0303 15.5303C13.7374 15.8232 13.2626 15.8232 12.9697 15.5303L9.96967 12.5303C9.67678 12.2374 9.67678 11.7626 9.96967 11.4697L12.9697 8.46967Z",
    fill: "white"
  }));
}
function ArrowRightIcon({ className }) {
  return /* @__PURE__ */ React.createElement("svg", {
    className,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M11.0303 8.46967C10.7374 8.17678 10.2626 8.17678 9.96967 8.46967C9.67678 8.76256 9.67678 9.23744 9.96967 9.53033L12.4393 12L9.96967 14.4697C9.67678 14.7626 9.67678 15.2374 9.96967 15.5303C10.2626 15.8232 10.7374 15.8232 11.0303 15.5303L14.0303 12.5303C14.3232 12.2374 14.3232 11.7626 14.0303 11.4697L11.0303 8.46967Z",
    fill: "white"
  }));
}
function SearchIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M20.3133 11.1566C20.3133 16.2137 16.2137 20.3133 11.1566 20.3133C6.09956 20.3133 2 16.2137 2 11.1566C2 6.09956 6.09956 2 11.1566 2C16.2137 2 20.3133 6.09956 20.3133 11.1566Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M17.1001 18.1219L20.7664 21.7882C21.0487 22.0705 21.5064 22.0705 21.7887 21.7882C22.071 21.5059 22.071 21.0482 21.7887 20.7659L18.1224 17.0996C17.809 17.4666 17.4671 17.8085 17.1001 18.1219Z",
    fill: "white"
  }));
}
function ChartSquareIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M12 5.25C12.4142 5.25 12.75 5.58579 12.75 6V18C12.75 18.4142 12.4142 18.75 12 18.75C11.5858 18.75 11.25 18.4142 11.25 18V6C11.25 5.58579 11.5858 5.25 12 5.25Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M7 8.25C7.41421 8.25 7.75 8.58579 7.75 9V18C7.75 18.4142 7.41421 18.75 7 18.75C6.58579 18.75 6.25 18.4142 6.25 18V9C6.25 8.58579 6.58579 8.25 7 8.25Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M17 12.25C17.4142 12.25 17.75 12.5858 17.75 13V18C17.75 18.4142 17.4142 18.75 17 18.75C16.5858 18.75 16.25 18.4142 16.25 18V13C16.25 12.5858 16.5858 12.25 17 12.25Z",
    fill: "white"
  }));
}
function UserIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M3 10.4167C3 7.21907 3 5.62028 3.37752 5.08241C3.75503 4.54454 5.25832 4.02996 8.26491 3.00079L8.83772 2.80472C10.405 2.26824 11.1886 2 12 2C12.8114 2 13.595 2.26824 15.1623 2.80472L15.7351 3.00079C18.7417 4.02996 20.245 4.54454 20.6225 5.08241C21 5.62028 21 7.21907 21 10.4167V11.9914C21 17.6294 16.761 20.3655 14.1014 21.5273C13.38 21.8424 13.0193 22 12 22C10.9807 22 10.62 21.8424 9.89856 21.5273C7.23896 20.3655 3 17.6294 3 11.9914V10.4167Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M14 9C14 10.1046 13.1046 11 12 11C10.8954 11 10 10.1046 10 9C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M12 17C16 17 16 16.1046 16 15C16 13.8954 14.2091 13 12 13C9.79086 13 8 13.8954 8 15C8 16.1046 8 17 12 17Z",
    fill: "white"
  }));
}
function RefreshIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M12.0096 5.25C8.62406 5.25 5.83333 7.79988 5.46058 11.0833H5.00002C4.69658 11.0833 4.42304 11.2662 4.30701 11.5466C4.19099 11.8269 4.25534 12.1496 4.47005 12.364L5.63832 13.5307C5.93113 13.8231 6.40544 13.8231 6.69825 13.5307L7.86651 12.364C8.08122 12.1496 8.14558 11.8269 8.02955 11.5466C7.91353 11.2662 7.63998 11.0833 7.33654 11.0833H6.97332C7.33642 8.63219 9.45215 6.75 12.0096 6.75C13.541 6.75 14.9136 7.42409 15.8479 8.49347C16.1204 8.80539 16.5942 8.83733 16.9061 8.56479C17.2181 8.29226 17.25 7.81846 16.9775 7.50653C15.7702 6.12471 13.9916 5.25 12.0096 5.25Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M18.3618 10.4693C18.069 10.1769 17.5947 10.1769 17.3018 10.4693L16.1336 11.636C15.9189 11.8504 15.8545 12.1731 15.9705 12.4534C16.0866 12.7338 16.3601 12.9167 16.6636 12.9167H17.0268C16.6637 15.3678 14.548 17.25 11.9905 17.25C10.4591 17.25 9.08654 16.5759 8.15222 15.5065C7.87968 15.1946 7.40589 15.1627 7.09396 15.4352C6.78203 15.7077 6.7501 16.1815 7.02263 16.4935C8.22995 17.8753 10.0085 18.75 11.9905 18.75C15.376 18.75 18.1668 16.2001 18.5395 12.9167H19.0001C19.3035 12.9167 19.5771 12.7338 19.6931 12.4534C19.8091 12.1731 19.7448 11.8504 19.53 11.636L18.3618 10.4693Z",
    fill: "white"
  }));
}
function FileIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("g", {
    opacity: "0.2"
  }, /* @__PURE__ */ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 22H10C6.22876 22 4.34315 22 3.17157 20.8284C2 19.6569 2 17.7712 2 14V10C2 6.22876 2 4.34315 3.17157 3.17157C4.34315 2 6.23869 2 10.0298 2C10.6358 2 11.1214 2 11.53 2.01666C11.5166 2.09659 11.5095 2.17813 11.5092 2.26057L11.5 5.09497C11.4999 6.19207 11.4998 7.16164 11.6049 7.94316C11.7188 8.79028 11.9803 9.63726 12.6716 10.3285C13.3628 11.0198 14.2098 11.2813 15.0569 11.3952C15.8385 11.5003 16.808 11.5002 17.9051 11.5001L18 11.5001H21.9574C22 12.0344 22 12.6901 22 13.5629V14C22 17.7712 22 19.6569 20.8284 20.8284C19.6569 22 17.7712 22 14 22Z",
    fill: "white"
  })), /* @__PURE__ */ React.createElement("path", {
    d: "M6 13.75C5.58579 13.75 5.25 14.0858 5.25 14.5C5.25 14.9142 5.58579 15.25 6 15.25H14C14.4142 15.25 14.75 14.9142 14.75 14.5C14.75 14.0858 14.4142 13.75 14 13.75H6Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M6 17.25C5.58579 17.25 5.25 17.5858 5.25 18C5.25 18.4142 5.58579 18.75 6 18.75H11.5C11.9142 18.75 12.25 18.4142 12.25 18C12.25 17.5858 11.9142 17.25 11.5 17.25H6Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M11.5092 2.2601L11.5 5.0945C11.4999 6.1916 11.4998 7.16117 11.6049 7.94269C11.7188 8.78981 11.9803 9.6368 12.6716 10.3281C13.3629 11.0193 14.2098 11.2808 15.057 11.3947C15.8385 11.4998 16.808 11.4997 17.9051 11.4996L21.9574 11.4996C21.9698 11.6552 21.9786 11.821 21.9848 11.9995H22C22 11.732 22 11.5983 21.9901 11.4408C21.9335 10.5463 21.5617 9.52125 21.0315 8.79853C20.9382 8.6713 20.8743 8.59493 20.7467 8.44218C19.9542 7.49359 18.911 6.31193 18 5.49953C17.1892 4.77645 16.0787 3.98536 15.1101 3.3385C14.2781 2.78275 13.862 2.50487 13.2915 2.29834C13.1403 2.24359 12.9408 2.18311 12.7846 2.14466C12.4006 2.05013 12.0268 2.01725 11.5 2.00586L11.5092 2.2601Z",
    fill: "white"
  }));
}
function GearIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2788 2.15224C13.9085 2 13.439 2 12.5 2C11.561 2 11.0915 2 10.7212 2.15224C10.2274 2.35523 9.83509 2.74458 9.63056 3.23463C9.53719 3.45834 9.50065 3.7185 9.48635 4.09799C9.46534 4.65568 9.17716 5.17189 8.69017 5.45093C8.20318 5.72996 7.60864 5.71954 7.11149 5.45876C6.77318 5.2813 6.52789 5.18262 6.28599 5.15102C5.75609 5.08178 5.22018 5.22429 4.79616 5.5472C4.47814 5.78938 4.24339 6.1929 3.7739 6.99993C3.30441 7.80697 3.06967 8.21048 3.01735 8.60491C2.94758 9.1308 3.09118 9.66266 3.41655 10.0835C3.56506 10.2756 3.77377 10.437 4.0977 10.639C4.57391 10.936 4.88032 11.4419 4.88029 12C4.88026 12.5581 4.57386 13.0639 4.0977 13.3608C3.77372 13.5629 3.56497 13.7244 3.41645 13.9165C3.09108 14.3373 2.94749 14.8691 3.01725 15.395C3.06957 15.7894 3.30432 16.193 3.7738 17C4.24329 17.807 4.47804 18.2106 4.79606 18.4527C5.22008 18.7756 5.75599 18.9181 6.28589 18.8489C6.52778 18.8173 6.77305 18.7186 7.11133 18.5412C7.60852 18.2804 8.2031 18.27 8.69012 18.549C9.17714 18.8281 9.46533 19.3443 9.48635 19.9021C9.50065 20.2815 9.53719 20.5417 9.63056 20.7654C9.83509 21.2554 10.2274 21.6448 10.7212 21.8478C11.0915 22 11.561 22 12.5 22C13.439 22 13.9085 22 14.2788 21.8478C14.7726 21.6448 15.1649 21.2554 15.3694 20.7654C15.4628 20.5417 15.4994 20.2815 15.5137 19.902C15.5347 19.3443 15.8228 18.8281 16.3098 18.549C16.7968 18.2699 17.3914 18.2804 17.8886 18.5412C18.2269 18.7186 18.4721 18.8172 18.714 18.8488C19.2439 18.9181 19.7798 18.7756 20.2038 18.4527C20.5219 18.2105 20.7566 17.807 21.2261 16.9999C21.6956 16.1929 21.9303 15.7894 21.9827 15.395C22.0524 14.8691 21.9088 14.3372 21.5835 13.9164C21.4349 13.7243 21.2262 13.5628 20.9022 13.3608C20.4261 13.0639 20.1197 12.558 20.1197 11.9999C20.1197 11.4418 20.4261 10.9361 20.9022 10.6392C21.2263 10.4371 21.435 10.2757 21.5836 10.0835C21.9089 9.66273 22.0525 9.13087 21.9828 8.60497C21.9304 8.21055 21.6957 7.80703 21.2262 7C20.7567 6.19297 20.522 5.78945 20.2039 5.54727C19.7799 5.22436 19.244 5.08185 18.7141 5.15109C18.4722 5.18269 18.2269 5.28136 17.8887 5.4588C17.3915 5.71959 16.7969 5.73002 16.3099 5.45096C15.8229 5.17191 15.5347 4.65566 15.5136 4.09794C15.4993 3.71848 15.4628 3.45833 15.3694 3.23463C15.1649 2.74458 14.7726 2.35523 14.2788 2.15224Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M15.5227 12C15.5227 13.6569 14.1694 15 12.4999 15C10.8304 15 9.47705 13.6569 9.47705 12C9.47705 10.3431 10.8304 9 12.4999 9C14.1694 9 15.5227 10.3431 15.5227 12Z",
    fill: "white"
  }));
}
function TradeIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M3.17157 7.17157C4.01536 6.32778 5.22954 6.09171 7.25179 6.02566L8.75208 6.00188C9.1435 6 9.55885 6 10 6H14C14.4412 6 14.8565 6 15.2479 6.00188L16.7482 6.02566C18.7705 6.09171 19.9846 6.32778 20.8284 7.17157C22 8.34315 22 10.2288 22 14C22 17.7712 22 19.6569 20.8284 20.8284C19.6569 22 17.7712 22 14 22H9.99998C6.22876 22 4.34314 22 3.17157 20.8284C2 19.6569 2 17.7712 2 14C2 10.2288 2 8.34315 3.17157 7.17157Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M12.75 10C12.75 9.58579 12.4142 9.25 12 9.25C11.5858 9.25 11.25 9.58579 11.25 10V10.0102C10.1612 10.2845 9.25 11.143 9.25 12.3333C9.25 13.7903 10.6151 14.75 12 14.75C12.8242 14.75 13.25 15.2826 13.25 15.6667C13.25 16.0507 12.8242 16.5833 12 16.5833C11.1758 16.5833 10.75 16.0507 10.75 15.6667C10.75 15.2525 10.4142 14.9167 10 14.9167C9.58579 14.9167 9.25 15.2525 9.25 15.6667C9.25 16.857 10.1612 17.7155 11.25 17.9898V18C11.25 18.4142 11.5858 18.75 12 18.75C12.4142 18.75 12.75 18.4142 12.75 18V17.9898C13.8388 17.7155 14.75 16.857 14.75 15.6667C14.75 14.2097 13.3849 13.25 12 13.25C11.1758 13.25 10.75 12.7174 10.75 12.3333C10.75 11.9493 11.1758 11.4167 12 11.4167C12.8242 11.4167 13.25 11.9493 13.25 12.3333C13.25 12.7475 13.5858 13.0833 14 13.0833C14.4142 13.0833 14.75 12.7475 14.75 12.3333C14.75 11.143 13.8388 10.2845 12.75 10.0102V10Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M12.0522 1.25H11.9482C11.0497 1.24997 10.3005 1.24995 9.70568 1.32991C9.07789 1.41432 8.51109 1.59999 8.05562 2.05546C7.60015 2.51093 7.41448 3.07773 7.33007 3.70552C7.27275 4.13189 7.25653 5.15147 7.25195 6.02566L8.75224 6.00188C8.75677 5.15523 8.77116 4.24407 8.8167 3.9054C8.87874 3.44393 8.98596 3.24644 9.11628 3.11612C9.24659 2.9858 9.44409 2.87858 9.90555 2.81654C10.3886 2.7516 11.0362 2.75 12.0002 2.75C12.9642 2.75 13.6117 2.7516 14.0948 2.81654C14.5562 2.87858 14.7537 2.9858 14.884 3.11612C15.0144 3.24644 15.1216 3.44393 15.1836 3.9054C15.2292 4.24407 15.2436 5.15523 15.2481 6.00188L16.7484 6.02566C16.7438 5.15147 16.7276 4.13189 16.6702 3.70552C16.5858 3.07773 16.4002 2.51093 15.9447 2.05546C15.4892 1.59999 14.9224 1.41432 14.2946 1.32991C13.6999 1.24995 12.9506 1.24997 12.0522 1.25Z",
    fill: "white"
  }));
}
function ZoomInIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("g", {
    opacity: "0.2"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M11.1566 20.3133C16.2137 20.3133 20.3133 16.2137 20.3133 11.1566C20.3133 6.09956 16.2137 2 11.1566 2C6.09956 2 2 6.09956 2 11.1566C2 16.2137 6.09956 20.3133 11.1566 20.3133Z",
    fill: "white"
  })), /* @__PURE__ */ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1565 8.02441C11.5557 8.02441 11.8793 8.34806 11.8793 8.74731V10.4341H13.5661C13.9653 10.4341 14.289 10.7577 14.289 11.1569C14.289 11.5562 13.9653 11.8798 13.5661 11.8798H11.8793V13.5666C11.8793 13.9658 11.5557 14.2895 11.1565 14.2895C10.7572 14.2895 10.4336 13.9658 10.4336 13.5666V11.8798H8.74682C8.34758 11.8798 8.02393 11.5562 8.02393 11.1569C8.02393 10.7577 8.34758 10.4341 8.74682 10.4341H10.4336V8.74731C10.4336 8.34806 10.7572 8.02441 11.1565 8.02441Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M17.1001 18.1219L20.7664 21.7882C21.0487 22.0705 21.5064 22.0705 21.7887 21.7882C22.071 21.5059 22.071 21.0482 21.7887 20.7659L18.1224 17.0996C17.809 17.4666 17.4671 17.8085 17.1001 18.1219Z",
    fill: "white"
  }));
}
function ZoomOutIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("g", {
    opacity: "0.2"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M11.1566 20.3133C16.2137 20.3133 20.3133 16.2137 20.3133 11.1566C20.3133 6.09956 16.2137 2 11.1566 2C6.09956 2 2 6.09956 2 11.1566C2 16.2137 6.09956 20.3133 11.1566 20.3133Z",
    fill: "white"
  })), /* @__PURE__ */ React.createElement("path", {
    d: "M17.1001 18.1219C17.4671 17.8085 17.809 17.4666 18.1224 17.0996L21.7887 20.7659C22.071 21.0482 22.071 21.5059 21.7887 21.7882C21.5064 22.0705 21.0487 22.0705 20.7664 21.7882L17.1001 18.1219Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02393 11.1565C8.02393 10.7572 8.34758 10.4336 8.74682 10.4336H13.5661C13.9653 10.4336 14.289 10.7572 14.289 11.1565C14.289 11.5557 13.9653 11.8794 13.5661 11.8794H8.74682C8.34758 11.8794 8.02393 11.5557 8.02393 11.1565Z",
    fill: "white"
  }));
}
function ProfileIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M16.807 19.0112C15.4398 19.9504 13.7841 20.5 12 20.5C10.2159 20.5 8.56023 19.9503 7.193 19.0111C6.58915 18.5963 6.33109 17.8062 6.68219 17.1632C7.41001 15.8302 8.90973 15 12 15C15.0903 15 16.59 15.8303 17.3178 17.1632C17.6689 17.8062 17.4108 18.5964 16.807 19.0112Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3432 6 9.00004 7.34315 9.00004 9C9.00004 10.6569 10.3432 12 12 12Z",
    fill: "white"
  }));
}
function ChooseIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M15.5303 15.2803C15.8232 14.9874 15.8232 14.5126 15.5303 14.2197C15.2374 13.9268 14.7626 13.9268 14.4697 14.2197L12 16.6893L9.53033 14.2197C9.23744 13.9268 8.76256 13.9268 8.46967 14.2197C8.17678 14.5126 8.17678 14.9874 8.46967 15.2803L11.4697 18.2803C11.7626 18.5732 12.2374 18.5732 12.5303 18.2803L15.5303 15.2803Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M15.5303 9.21967C15.8232 9.51256 15.8232 9.98744 15.5303 10.2803C15.2374 10.5732 14.7626 10.5732 14.4697 10.2803L12 7.81066L9.53033 10.2803C9.23744 10.5732 8.76256 10.5732 8.46967 10.2803C8.17678 9.98744 8.17678 9.51256 8.46967 9.21967L11.4697 6.21967C11.7626 5.92678 12.2374 5.92678 12.5303 6.21967L15.5303 9.21967Z",
    fill: "white"
  }));
}
function MenuDotsSquareIcon({ className }) {
  return /* @__PURE__ */ React.createElement("svg", {
    className,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M3.46447 20.5355C4.92893 22 7.28595 22 12 22C16.714 22 19.0711 22 20.5355 20.5355C22 19.0711 22 16.714 22 12C22 7.28595 22 4.92893 20.5355 3.46447C19.0711 2 16.714 2 12 2C7.28595 2 4.92893 2 3.46447 3.46447C2 4.92893 2 7.28595 2 12C2 16.714 2 19.0711 3.46447 20.5355Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M16 13C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11C15.4477 11 15 11.4477 15 12C15 12.5523 15.4477 13 16 13Z",
    fill: "white"
  }));
}
function TrashIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M11.5956 21.9996H12.4044C15.1871 21.9996 16.5785 21.9996 17.4831 21.1137C18.3878 20.2278 18.4803 18.7746 18.6654 15.8681L18.9321 11.6802C19.0326 10.1032 19.0828 9.31475 18.6289 8.81509C18.1751 8.31543 17.4087 8.31543 15.876 8.31543H8.12405C6.59127 8.31543 5.82488 8.31543 5.37105 8.81509C4.91722 9.31475 4.96744 10.1032 5.06788 11.6802L5.33459 15.8681C5.5197 18.7746 5.61225 20.2278 6.51689 21.1137C7.42153 21.9996 8.81289 21.9996 11.5956 21.9996Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M3 6.38597C3 5.90152 3.34538 5.50879 3.77143 5.50879L6.43567 5.50832C6.96502 5.49306 7.43202 5.11033 7.61214 4.54412C7.61688 4.52923 7.62232 4.51087 7.64185 4.44424L7.75665 4.05256C7.8269 3.81241 7.8881 3.60318 7.97375 3.41617C8.31209 2.67736 8.93808 2.16432 9.66147 2.03297C9.84457 1.99972 10.0385 1.99986 10.2611 2.00002H13.7391C13.9617 1.99986 14.1556 1.99972 14.3387 2.03297C15.0621 2.16432 15.6881 2.67736 16.0264 3.41617C16.1121 3.60318 16.1733 3.81241 16.2435 4.05256L16.3583 4.44424C16.3778 4.51087 16.3833 4.52923 16.388 4.54412C16.5682 5.11033 17.1278 5.49353 17.6571 5.50879H20.2286C20.6546 5.50879 21 5.90152 21 6.38597C21 6.87043 20.6546 7.26316 20.2286 7.26316H3.77143C3.34538 7.26316 3 6.87043 3 6.38597Z",
    fill: "white"
  }));
}
function DualArrowsUpIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M8.46967 14.9697C8.17678 15.2626 8.17678 15.7374 8.46967 16.0303C8.76256 16.3232 9.23744 16.3232 9.53033 16.0303L12 13.5607L14.4697 16.0303C14.7626 16.3232 15.2374 16.3232 15.5303 16.0303C15.8232 15.7374 15.8232 15.2626 15.5303 14.9697L12.5303 11.9697C12.2374 11.6768 11.7626 11.6768 11.4697 11.9697L8.46967 14.9697Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M8.46967 10.9697C8.17678 11.2626 8.17678 11.7374 8.46967 12.0303C8.76256 12.3232 9.23744 12.3232 9.53033 12.0303L12 9.56066L14.4697 12.0303C14.7626 12.3232 15.2374 12.3232 15.5303 12.0303C15.8232 11.7374 15.8232 11.2626 15.5303 10.9697L12.5303 7.96967C12.2374 7.67678 11.7626 7.67678 11.4697 7.96967L8.46967 10.9697Z",
    fill: "white"
  }));
}
function DualArrowsDownIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M8.46967 9.03033C8.17678 8.73744 8.17678 8.26256 8.46967 7.96967C8.76256 7.67678 9.23744 7.67678 9.53033 7.96967L12 10.4393L14.4697 7.96967C14.7626 7.67678 15.2374 7.67678 15.5303 7.96967C15.8232 8.26256 15.8232 8.73744 15.5303 9.03033L12.5303 12.0303C12.2374 12.3232 11.7626 12.3232 11.4697 12.0303L8.46967 9.03033Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M8.46967 13.0303C8.17678 12.7374 8.17678 12.2626 8.46967 11.9697C8.76256 11.6768 9.23744 11.6768 9.53033 11.9697L12 14.4393L14.4697 11.9697C14.7626 11.6768 15.2374 11.6768 15.5303 11.9697C15.8232 12.2626 15.8232 12.7374 15.5303 13.0303L12.5303 16.0303C12.2374 16.3232 11.7626 16.3232 11.4697 16.0303L8.46967 13.0303Z",
    fill: "white"
  }));
}
function DualArrowsLeftIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M14.9697 15.5303C15.2626 15.8232 15.7374 15.8232 16.0303 15.5303C16.3232 15.2374 16.3232 14.7626 16.0303 14.4697L13.5607 12L16.0303 9.53033C16.3232 9.23744 16.3232 8.76256 16.0303 8.46967C15.7374 8.17678 15.2626 8.17678 14.9697 8.46967L11.9697 11.4697C11.6768 11.7626 11.6768 12.2374 11.9697 12.5303L14.9697 15.5303Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M10.9697 15.5303C11.2626 15.8232 11.7374 15.8232 12.0303 15.5303C12.3232 15.2374 12.3232 14.7626 12.0303 14.4697L9.56066 12L12.0303 9.53033C12.3232 9.23744 12.3232 8.76256 12.0303 8.46967C11.7374 8.17678 11.2626 8.17678 10.9697 8.46967L7.96967 11.4697C7.67678 11.7626 7.67678 12.2374 7.96967 12.5303L10.9697 15.5303Z",
    fill: "white"
  }));
}
function DualArrowsRightIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M9.03033 15.5303C8.73744 15.8232 8.26256 15.8232 7.96967 15.5303C7.67678 15.2374 7.67678 14.7626 7.96967 14.4697L10.4393 12L7.96967 9.53033C7.67678 9.23744 7.67678 8.76256 7.96967 8.46967C8.26256 8.17678 8.73744 8.17678 9.03033 8.46967L12.0303 11.4697C12.3232 11.7626 12.3232 12.2374 12.0303 12.5303L9.03033 15.5303Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M13.0303 15.5303C12.7374 15.8232 12.2626 15.8232 11.9697 15.5303C11.6768 15.2374 11.6768 14.7626 11.9697 14.4697L14.4393 12L11.9697 9.53033C11.6768 9.23744 11.6768 8.76256 11.9697 8.46967C12.2626 8.17678 12.7374 8.17678 13.0303 8.46967L16.0303 11.4697C16.3232 11.7626 16.3232 12.2374 16.0303 12.5303L13.0303 15.5303Z",
    fill: "white"
  }));
}
function MonitorIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M13 15.4C13 13.3258 13 12.2887 13.659 11.6444C14.318 11 15.3787 11 17.5 11C19.6213 11 20.682 11 21.341 11.6444C22 12.2887 22 13.3258 22 15.4V17.6C22 19.6742 22 20.7113 21.341 21.3556C20.682 22 19.6213 22 17.5 22C15.3787 22 14.318 22 13.659 21.3556C13 20.7113 13 19.6742 13 17.6V15.4Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M2 8.6C2 10.6742 2 11.7113 2.65901 12.3556C3.31802 13 4.37868 13 6.5 13C8.62132 13 9.68198 13 10.341 12.3556C11 11.7113 11 10.6742 11 8.6V6.4C11 4.32582 11 3.28873 10.341 2.64437C9.68198 2 8.62132 2 6.5 2C4.37868 2 3.31802 2 2.65901 2.64437C2 3.28873 2 4.32582 2 6.4V8.6Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M13 5.5C13 4.4128 13 3.8692 13.1713 3.44041C13.3996 2.86867 13.8376 2.41443 14.389 2.17761C14.8024 2 15.3266 2 16.375 2H18.625C19.6734 2 20.1976 2 20.611 2.17761C21.1624 2.41443 21.6004 2.86867 21.8287 3.44041C22 3.8692 22 4.4128 22 5.5C22 6.5872 22 7.1308 21.8287 7.55959C21.6004 8.13133 21.1624 8.58557 20.611 8.82239C20.1976 9 19.6734 9 18.625 9H16.375C15.3266 9 14.8024 9 14.389 8.82239C13.8376 8.58557 13.3996 8.13133 13.1713 7.55959C13 7.1308 13 6.5872 13 5.5Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M2 18.5C2 19.5872 2 20.1308 2.17127 20.5596C2.39963 21.1313 2.83765 21.5856 3.38896 21.8224C3.80245 22 4.32663 22 5.375 22H7.625C8.67337 22 9.19755 22 9.61104 21.8224C10.1624 21.5856 10.6004 21.1313 10.8287 20.5596C11 20.1308 11 19.5872 11 18.5C11 17.4128 11 16.8692 10.8287 16.4404C10.6004 15.8687 10.1624 15.4144 9.61104 15.1776C9.19755 15 8.67337 15 7.625 15H5.375C4.32663 15 3.80245 15 3.38896 15.1776C2.83765 15.4144 2.39963 15.8687 2.17127 16.4404C2 16.8692 2 17.4128 2 18.5Z",
    fill: "white"
  }));
}
function DownloadIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M22 15.9998V14.9998C22 12.1714 21.9998 10.7576 21.1211 9.87891C20.2424 9.00023 18.8282 9.00023 15.9998 9.00023H7.99977C5.17135 9.00023 3.75713 9.00023 2.87845 9.87891C2 10.7574 2 12.1706 2 14.9976V14.9998V15.9998C2 18.8282 2 20.2424 2.87868 21.1211C3.75736 21.9998 5.17157 21.9998 8 21.9998H16H16C18.8284 21.9998 20.2426 21.9998 21.1213 21.1211C22 20.2424 22 18.8282 22 15.9998Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.25C11.5858 1.25 11.25 1.58579 11.25 2L11.25 12.9726L9.56943 11.0119C9.29986 10.6974 8.82639 10.661 8.51189 10.9306C8.1974 11.2001 8.16098 11.6736 8.43054 11.9881L11.4305 15.4881C11.573 15.6543 11.781 15.75 12 15.75C12.2189 15.75 12.4269 15.6543 12.5694 15.4881L15.5694 11.9881C15.839 11.6736 15.8026 11.2001 15.4881 10.9306C15.1736 10.661 14.7001 10.6974 14.4305 11.0119L12.75 12.9726L12.75 2C12.75 1.58579 12.4142 1.25 12 1.25Z",
    fill: "white"
  }));
}
function CSVIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M1.25 14C1.25 14.4142 1.58579 14.75 2 14.75C2.41421 14.75 2.75 14.4142 2.75 14H1.25ZM2 10H1.25H2ZM21.25 14C21.25 14.4142 21.5858 14.75 22 14.75C22.4142 14.75 22.75 14.4142 22.75 14H21.25ZM15.3929 4.05365L14.8912 4.61112L15.3929 4.05365ZM19.3517 7.61654L18.85 8.17402L19.3517 7.61654ZM21.654 10.1541L20.9689 10.4592V10.4592L21.654 10.1541ZM2.75 14V10H1.25V14H2.75ZM21.25 13.5629V14H22.75V13.5629H21.25ZM14.8912 4.61112L18.85 8.17402L19.8534 7.05907L15.8947 3.49618L14.8912 4.61112ZM22.75 13.5629C22.75 11.8745 22.7651 10.8055 22.3391 9.84897L20.9689 10.4592C21.2349 11.0565 21.25 11.742 21.25 13.5629H22.75ZM18.85 8.17402C20.2034 9.3921 20.7029 9.86199 20.9689 10.4592L22.3391 9.84897C21.9131 8.89241 21.1084 8.18853 19.8534 7.05907L18.85 8.17402ZM10.0298 2.75C11.6116 2.75 12.2085 2.76158 12.7405 2.96573L13.2779 1.5653C12.4261 1.23842 11.498 1.25 10.0298 1.25V2.75ZM15.8947 3.49618C14.8087 2.51878 14.1297 1.89214 13.2779 1.5653L12.7405 2.96573C13.2727 3.16993 13.7215 3.55836 14.8912 4.61112L15.8947 3.49618ZM2.75 10C2.75 8.09318 2.75159 6.73851 2.88976 5.71085C3.02502 4.70476 3.27869 4.12511 3.7019 3.7019L2.64124 2.64124C1.89288 3.38961 1.56076 4.33855 1.40313 5.51098C1.24841 6.66182 1.25 8.13558 1.25 10H2.75ZM10.0298 1.25C8.15538 1.25 6.67442 1.24842 5.51887 1.40307C4.34232 1.56054 3.39019 1.8923 2.64124 2.64124L3.7019 3.7019C4.12453 3.27928 4.70596 3.02525 5.71785 2.88982C6.75075 2.75158 8.11311 2.75 10.0298 2.75V1.25Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M13 2.5V5C13 7.35702 13 8.53553 13.7322 9.26777C14.4645 10 15.643 10 18 10H22",
    stroke: "white",
    strokeWidth: "1.5"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M19.1361 23.4994C18.7387 23.4994 18.379 23.2641 18.2198 22.9L15.6675 17.0613C15.4708 16.6113 15.8004 16.1074 16.2915 16.1074C16.5634 16.1074 16.8092 16.2691 16.9169 16.5188L19.6223 22.7919H18.767L21.5168 16.4852C21.6168 16.2558 21.8434 16.1074 22.0937 16.1074C22.5471 16.1074 22.8517 16.5724 22.6706 16.9881L20.0952 22.8989C19.9363 23.2636 19.5763 23.4994 19.1784 23.4994H19.1361Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M11.9463 23.6052C11.369 23.6052 10.8164 23.5242 10.2884 23.3623C9.93918 23.2505 9.63771 23.1188 9.38397 22.967C9.16456 22.8358 9.10341 22.5573 9.20746 22.3237C9.35947 21.9825 9.79617 21.8738 10.1325 22.0363C10.2796 22.1074 10.4372 22.1727 10.6052 22.2324C11.0417 22.3872 11.4887 22.4647 11.9463 22.4647C12.3335 22.4647 12.6468 22.4224 12.8861 22.338C13.1255 22.2535 13.3015 22.1408 13.4141 22C13.5268 21.8522 13.5831 21.6868 13.5831 21.5037C13.5831 21.2784 13.5021 21.0989 13.3402 20.9652C13.1783 20.8244 12.9671 20.7152 12.7066 20.6378C12.4532 20.5533 12.1681 20.4759 11.8513 20.4055C11.5415 20.3351 11.2282 20.2541 10.9114 20.1626C10.6017 20.064 10.3165 19.9408 10.0561 19.793C9.80262 19.6381 9.59494 19.434 9.43302 19.1805C9.2711 18.9271 9.19014 18.6032 9.19014 18.209C9.19014 17.8077 9.29574 17.4416 9.50694 17.1108C9.72518 16.7728 10.0525 16.5053 10.489 16.3082C10.9325 16.104 11.4922 16.002 12.1681 16.002C12.6116 16.002 13.0516 16.0583 13.4881 16.1709C13.7493 16.2383 13.9904 16.3234 14.2114 16.4262C14.4626 16.543 14.5533 16.842 14.4491 17.0987C14.3158 17.4272 13.9215 17.5553 13.5912 17.4265C13.4529 17.3725 13.313 17.3271 13.1713 17.2903C12.8193 17.1917 12.4813 17.1424 12.1575 17.1424C11.7773 17.1424 11.4676 17.1882 11.2282 17.2797C10.9959 17.3712 10.8234 17.4909 10.7108 17.6388C10.6052 17.7866 10.5524 17.9556 10.5524 18.1456C10.5524 18.3709 10.6298 18.554 10.7847 18.6948C10.9466 18.8285 11.1543 18.9341 11.4077 19.0116C11.6682 19.089 11.9569 19.1664 12.2737 19.2439C12.5905 19.3143 12.9037 19.3952 13.2135 19.4868C13.5303 19.5783 13.8154 19.698 14.0689 19.8458C14.3293 19.9936 14.537 20.1943 14.6919 20.4477C14.8538 20.7012 14.9348 21.0215 14.9348 21.4087C14.9348 21.8029 14.8257 22.169 14.6074 22.5069C14.3962 22.8378 14.0689 23.1053 13.6253 23.3095C13.1818 23.5066 12.6221 23.6052 11.9463 23.6052Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M5.41404 23.6052C4.85084 23.6052 4.32636 23.5136 3.8406 23.3306C3.36188 23.1405 2.943 22.8765 2.58396 22.5386C2.23196 22.1936 1.9574 21.7888 1.76028 21.3242C1.56316 20.8596 1.4646 20.3527 1.4646 19.8036C1.4646 19.2544 1.56316 18.7476 1.76028 18.2829C1.9574 17.8183 2.23548 17.417 2.59452 17.0791C2.95356 16.7341 3.37244 16.4701 3.85116 16.2871C4.32988 16.097 4.85436 16.002 5.4246 16.002C6.03004 16.002 6.58268 16.1076 7.08252 16.3188C7.39565 16.4466 7.67838 16.6146 7.93072 16.8226C8.18616 17.0332 8.16078 17.4152 7.91963 17.642C7.6678 17.8788 7.27559 17.8562 6.99027 17.661C6.85488 17.5684 6.71315 17.4906 6.56508 17.4276C6.2342 17.2797 5.87516 17.2058 5.48796 17.2058C5.10076 17.2058 4.74524 17.2692 4.4214 17.3959C4.1046 17.5226 3.82652 17.7021 3.58716 17.9344C3.35484 18.1668 3.1718 18.4413 3.03804 18.7581C2.91132 19.0749 2.84796 19.4234 2.84796 19.8036C2.84796 20.1837 2.91132 20.5322 3.03804 20.849C3.1718 21.1658 3.35484 21.4404 3.58716 21.6727C3.82652 21.905 4.1046 22.0845 4.4214 22.2112C4.74524 22.338 5.10076 22.4013 5.48796 22.4013C5.87516 22.4013 6.2342 22.3309 6.56508 22.1901C6.71287 22.1241 6.85435 22.0433 6.9895 21.9478C7.27412 21.7466 7.67077 21.723 7.92317 21.9634C8.16218 22.191 8.18443 22.5718 7.92906 22.7809C7.67713 22.9872 7.39496 23.1563 7.08252 23.2884C6.58268 23.4996 6.02652 23.6052 5.41404 23.6052Z",
    fill: "white"
  }));
}
function UploadIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M22 15.9998V14.9998C22 12.1714 21.9998 10.7576 21.1211 9.87891C20.2424 9.00023 18.8282 9.00023 15.9998 9.00023H7.99977C5.17135 9.00023 3.75713 9.00023 2.87845 9.87891C2 10.7574 2 12.1706 2 14.9976V14.9998V15.9998C2 18.8282 2 20.2424 2.87868 21.1211C3.75736 21.9998 5.17157 21.9998 8 21.9998H16H16C18.8284 21.9998 20.2426 21.9998 21.1213 21.1211C22 20.2424 22 18.8282 22 15.9998Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15.75C12.4142 15.75 12.75 15.4142 12.75 15L12.75 4.02744L14.4306 5.98809C14.7001 6.30259 15.1736 6.33901 15.4881 6.06944C15.8026 5.79988 15.839 5.3264 15.5695 5.01191L12.5695 1.51191C12.427 1.34567 12.219 1.25 12 1.25C11.7811 1.25 11.5731 1.34567 11.4306 1.51191L8.43057 5.01191C8.161 5.3264 8.19743 5.79988 8.51192 6.06944C8.82641 6.33901 9.29989 6.30259 9.56946 5.98809L11.25 4.02744L11.25 15C11.25 15.4142 11.5858 15.75 12 15.75Z",
    fill: "white"
  }));
}
function EditIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M20.8482 8.71306C22.3839 7.17735 22.3839 4.68748 20.8482 3.15178C19.3125 1.61607 16.8226 1.61607 15.2869 3.15178L14.3999 4.03882C14.412 4.0755 14.4246 4.11268 14.4377 4.15035C14.7628 5.0875 15.3763 6.31601 16.5303 7.47002C17.6843 8.62403 18.9128 9.23749 19.85 9.56262C19.8875 9.57563 19.9245 9.58817 19.961 9.60026L20.8482 8.71306Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M14.4386 4.00098L14.4004 4.03917C14.4125 4.07585 14.4251 4.11304 14.4382 4.15071C14.7633 5.08785 15.3768 6.31636 16.5308 7.47037C17.6848 8.62439 18.9133 9.23784 19.8505 9.56297C19.8876 9.57587 19.9243 9.58831 19.9606 9.6003L11.4001 18.1608C10.823 18.7379 10.5343 19.0265 10.2162 19.2747C9.84082 19.5674 9.43469 19.8184 9.00498 20.0232C8.6407 20.1968 8.25351 20.3259 7.47918 20.584L3.39584 21.9451C3.01478 22.0721 2.59466 21.973 2.31063 21.6889C2.0266 21.4049 1.92743 20.9848 2.05445 20.6037L3.41556 16.5204C3.67368 15.7461 3.80273 15.3589 3.97634 14.9946C4.18114 14.5649 4.43213 14.1588 4.7249 13.7834C4.97307 13.4652 5.26165 13.1767 5.83874 12.5996L14.4386 4.00098Z",
    fill: "white"
  }));
}
function ShareIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2622 7.33333C13.2622 6.04467 14.3116 5 15.6061 5C16.9006 5 17.95 6.04467 17.95 7.33333C17.95 8.622 16.9006 9.66667 15.6061 9.66667C14.9524 9.66667 14.3617 9.40017 13.937 8.97143L10.6922 11.1807C10.7222 11.3297 10.7379 11.4837 10.7379 11.641C10.7379 11.9525 10.6764 12.2503 10.5648 12.5225L14.1227 14.8601C14.5265 14.5312 15.0432 14.3333 15.6061 14.3333C16.9006 14.3333 17.95 15.378 17.95 16.6667C17.95 17.9553 16.9006 19 15.6061 19C14.3116 19 13.2622 17.9553 13.2622 16.6667C13.2622 16.3291 13.3344 16.0079 13.4643 15.7178L9.9351 13.3991C9.52342 13.7569 8.98417 13.9744 8.39399 13.9744C7.09947 13.9744 6.05005 12.9297 6.05005 11.641C6.05005 10.3524 7.09947 9.30769 8.39399 9.30769C9.13838 9.30769 9.80102 9.65308 10.2301 10.1906L13.3748 8.0495C13.3016 7.82352 13.2622 7.58272 13.2622 7.33333Z",
    fill: "white"
  }));
}
function CloseIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M8.96967 8.96967C9.26256 8.67678 9.73744 8.67678 10.0303 8.96967L12 10.9394L13.9697 8.96969C14.2626 8.6768 14.7374 8.6768 15.0303 8.96969C15.3232 9.26258 15.3232 9.73746 15.0303 10.0304L13.0607 12L15.0303 13.9696C15.3232 14.2625 15.3232 14.7374 15.0303 15.0303C14.7374 15.3232 14.2625 15.3232 13.9696 15.0303L12 13.0607L10.0304 15.0303C9.73746 15.3232 9.26258 15.3232 8.96969 15.0303C8.6768 14.7374 8.6768 14.2626 8.96969 13.9697L10.9394 12L8.96967 10.0303C8.67678 9.73744 8.67678 9.26256 8.96967 8.96967Z",
    fill: "white"
  }));
}
function QuestionMarkIcon({ className }) {
  return /* @__PURE__ */ React.createElement("svg", {
    className,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M12 7.75C11.3787 7.75 10.875 8.25368 10.875 8.875C10.875 9.28921 10.5392 9.625 10.125 9.625C9.71079 9.625 9.375 9.28921 9.375 8.875C9.375 7.42525 10.5503 6.25 12 6.25C13.4497 6.25 14.625 7.42525 14.625 8.875C14.625 9.58584 14.3415 10.232 13.883 10.704C13.7907 10.7989 13.7027 10.8869 13.6187 10.9708C13.4029 11.1864 13.2138 11.3753 13.0479 11.5885C12.8289 11.8699 12.75 12.0768 12.75 12.25V13C12.75 13.4142 12.4142 13.75 12 13.75C11.5858 13.75 11.25 13.4142 11.25 13V12.25C11.25 11.5948 11.555 11.0644 11.8642 10.6672C12.0929 10.3733 12.3804 10.0863 12.6138 9.85346C12.6842 9.78321 12.7496 9.71789 12.807 9.65877C13.0046 9.45543 13.125 9.18004 13.125 8.875C13.125 8.25368 12.6213 7.75 12 7.75Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z",
    fill: "white"
  }));
}
function BaseInfoIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V11C12.75 10.5858 12.4142 10.25 12 10.25C11.5858 10.25 11.25 10.5858 11.25 11V17C11.25 17.4142 11.5858 17.75 12 17.75Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M12 7C12.5523 7 13 7.44771 13 8C13 8.55229 12.5523 9 12 9C11.4477 9 11 8.55229 11 8C11 7.44771 11.4477 7 12 7Z",
    fill: "white"
  }));
}
function CheckIcon({ className }) {
  return /* @__PURE__ */ React.createElement("svg", {
    className,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
    fill: "currentColor"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M16.0303 8.96967C16.3232 9.26256 16.3232 9.73744 16.0303 10.0303L11.0303 15.0303C10.7374 15.3232 10.2626 15.3232 9.96967 15.0303L7.96967 13.0303C7.67678 12.7374 7.67678 12.2626 7.96967 11.9697C8.26256 11.6768 8.73744 11.6768 9.03033 11.9697L10.5 13.4393L12.7348 11.2045L14.9697 8.96967C15.2626 8.67678 15.7374 8.67678 16.0303 8.96967Z",
    fill: "currentColor"
  }));
}
function BaseAlertIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M12 7C11.5858 7 11.25 7.33579 11.25 7.75L11.25 13.75C11.25 14.1642 11.5858 14.5 12 14.5C12.4142 14.5 12.75 14.1642 12.75 13.75L12.75 7.75C12.75 7.33579 12.4142 7 12 7Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M12 17.75C11.4477 17.75 11 17.3023 11 16.75C11 16.1977 11.4477 15.75 12 15.75C12.5523 15.75 13 16.1977 13 16.75C13 17.3023 12.5523 17.75 12 17.75Z",
    fill: "white"
  }));
}
function CopyIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M6.59961 11.3974C6.59961 8.67119 6.59961 7.3081 7.44314 6.46118C8.28667 5.61426 9.64432 5.61426 12.3596 5.61426H15.2396C17.9549 5.61426 19.3125 5.61426 20.1561 6.46118C20.9996 7.3081 20.9996 8.6712 20.9996 11.3974V16.2167C20.9996 18.9429 20.9996 20.306 20.1561 21.1529C19.3125 21.9998 17.9549 21.9998 15.2396 21.9998H12.3596C9.64432 21.9998 8.28667 21.9998 7.44314 21.1529C6.59961 20.306 6.59961 18.9429 6.59961 16.2167V11.3974Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M4.17157 3.17157C3 4.34315 3 6.22876 3 10V12C3 15.7712 3 17.6569 4.17157 18.8284C4.78913 19.446 5.6051 19.738 6.79105 19.8761C6.59961 19.0353 6.59961 17.8796 6.59961 16.2167V11.3974C6.59961 8.6712 6.59961 7.3081 7.44314 6.46118C8.28667 5.61426 9.64432 5.61426 12.3596 5.61426H15.2396C16.8915 5.61426 18.0409 5.61426 18.8777 5.80494C18.7403 4.61146 18.4484 3.79154 17.8284 3.17157C16.6569 2 14.7712 2 11 2C7.22876 2 5.34315 2 4.17157 3.17157Z",
    fill: "white"
  }));
}
function Filter2Icon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.69981 3.89941H18.3001L9.13394 13.0655C8.99021 12.6916 8.7598 12.3706 8.43363 12.0874C8.22857 11.9094 7.94217 11.7482 7.36938 11.4257L4.74761 9.94983C3.8939 9.46925 3.46705 9.22896 3.2334 8.84179C2.99976 8.45462 2.99976 7.98759 2.99976 7.05351V6.43266C2.99976 5.23848 2.99976 4.64138 3.39517 4.2704C3.79058 3.89941 4.42699 3.89941 5.69981 3.89941Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M21 7.05351V6.43266C21 5.23848 21 4.64138 20.6046 4.2704C20.2091 3.89941 19.5727 3.89941 18.2999 3.89941L9.13379 13.0655C9.17823 13.1812 9.21439 13.3019 9.24253 13.4281C9.29973 13.6846 9.29973 13.9848 9.29973 14.5853L9.29973 16.9879C9.29973 17.8065 9.29973 18.2158 9.52647 18.5349C9.75321 18.854 10.1559 19.0114 10.9613 19.3262C12.6521 19.9872 13.4975 20.3177 14.0987 19.9417C14.6998 19.5657 14.6998 18.7064 14.6998 16.9879V14.5853C14.6998 13.9848 14.6998 13.6846 14.757 13.4281C14.8762 12.8938 15.1391 12.4581 15.5661 12.0874C15.7712 11.9094 16.0576 11.7482 16.6303 11.4257L19.2521 9.94983C20.1058 9.46925 20.5327 9.22896 20.7663 8.84179C21 8.45462 21 7.98759 21 7.05351Z",
    fill: "white"
  }));
}
function ChooseSmallIcon({ className }) {
  return /* @__PURE__ */ React.createElement("svg", {
    className,
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M10.5303 10.2803C10.8232 9.98744 10.8232 9.51256 10.5303 9.21967C10.2374 8.92678 9.76256 8.92678 9.46967 9.21967L7 11.6893L4.53033 9.21967C4.23744 8.92678 3.76256 8.92678 3.46967 9.21967C3.17678 9.51256 3.17678 9.98744 3.46967 10.2803L6.46967 13.2803C6.76256 13.5732 7.23744 13.5732 7.53033 13.2803L10.5303 10.2803Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M10.5303 4.21967C10.8232 4.51256 10.8232 4.98744 10.5303 5.28033C10.2374 5.57322 9.76256 5.57322 9.46967 5.28033L7 2.81066L4.53033 5.28033C4.23744 5.57322 3.76256 5.57322 3.46967 5.28033C3.17678 4.98744 3.17678 4.51256 3.46967 4.21967L6.46967 1.21967C6.76256 0.926776 7.23744 0.926776 7.53033 1.21967L10.5303 4.21967Z",
    fill: "white"
  }));
}
function ArrowUpSmall({ className }) {
  return /* @__PURE__ */ React.createElement("svg", {
    className,
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M7 11.6663L7 2.33301M7 2.33301L10.5 5.83301M7 2.33301L3.5 5.83301",
    stroke: "white",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
function ArrowDownSmall({ className }) {
  return /* @__PURE__ */ React.createElement("svg", {
    className,
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M7 2.33301L7 11.6663M7 11.6663L10.5 8.16634M7 11.6663L3.5 8.16634",
    stroke: "white",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
function QuestionSmallIcon({ className }) {
  return /* @__PURE__ */ React.createElement("svg", {
    className,
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("g", {
    clipPath: "url(#clip0_286_3579)"
  }, /* @__PURE__ */ React.createElement("path", {
    opacity: "0.2",
    d: "M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M7 4.11628C6.52661 4.11628 6.14286 4.49111 6.14286 4.95349C6.14286 5.26174 5.88702 5.51163 5.57143 5.51163C5.25584 5.51163 5 5.26174 5 4.95349C5 3.87461 5.89543 3 7 3C8.10457 3 9 3.87461 9 4.95349C9 5.48248 8.78397 5.96333 8.43463 6.31458C8.36434 6.38525 8.29729 6.45069 8.23332 6.51312L8.23331 6.51312C8.06887 6.67361 7.9248 6.8142 7.7984 6.97283C7.63152 7.18227 7.57143 7.3362 7.57143 7.46512V8.02326C7.57143 8.33151 7.31559 8.5814 7 8.5814C6.68441 8.5814 6.42857 8.33151 6.42857 8.02326V7.46512C6.42857 6.97753 6.66096 6.58284 6.89651 6.28722C7.07079 6.0685 7.28986 5.85495 7.46764 5.68165C7.52127 5.62937 7.57114 5.58075 7.6149 5.53676C7.7654 5.38544 7.85714 5.1805 7.85714 4.95349C7.85714 4.49111 7.47339 4.11628 7 4.11628Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M7 11C7.42079 11 7.7619 10.6668 7.7619 10.2558C7.7619 9.84481 7.42079 9.51163 7 9.51163C6.57921 9.51163 6.2381 9.84481 6.2381 10.2558C6.2381 10.6668 6.57921 11 7 11Z",
    fill: "white"
  })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", {
    id: "clip0_286_3579"
  }, /* @__PURE__ */ React.createElement("rect", {
    width: "14",
    height: "14",
    fill: "white"
  }))));
}
function CopySmallIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("g", {
    clipPath: "url(#clip0_2059_5903)"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M4.47998 7.08227C4.47998 5.59153 4.47998 4.84615 4.93924 4.38304C5.39849 3.91992 6.13766 3.91992 7.61598 3.91992H9.18398C10.6623 3.91992 11.4015 3.91992 11.8607 4.38304C12.32 4.84615 12.32 5.59153 12.32 7.08227V9.71757C12.32 11.2083 12.32 11.9537 11.8607 12.4168C11.4015 12.8799 10.6623 12.8799 9.18398 12.8799H7.61598C6.13766 12.8799 5.39849 12.8799 4.93924 12.4168C4.47998 11.9537 4.47998 11.2083 4.47998 9.71757V7.08227Z",
    stroke: "white",
    strokeWidth: "1.5"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M9.51993 3.92012V2.70129C9.51993 1.82803 8.81791 1.12012 7.95193 1.12012H5.86127C3.89017 1.12012 2.90462 1.12012 2.29227 1.73761C1.67993 2.35509 1.67993 3.34892 1.67993 5.33659V8.49894C1.67993 9.3722 2.38195 10.0801 3.24793 10.0801H4.47993",
    stroke: "white",
    strokeWidth: "1.5"
  })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", {
    id: "clip0_2059_5903"
  }, /* @__PURE__ */ React.createElement("rect", {
    width: "14",
    height: "14",
    fill: "white"
  }))));
}
function DropdownArrow({ className }) {
  return /* @__PURE__ */ React.createElement("svg", {
    className,
    width: "24",
    height: "25",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M15.5303 11.5303C15.8232 11.2374 15.8232 10.7626 15.5303 10.4697C15.2374 10.1768 14.7626 10.1768 14.4697 10.4697L12 12.9393L9.53033 10.4697C9.23744 10.1768 8.76256 10.1768 8.46967 10.4697C8.17678 10.7626 8.17678 11.2374 8.46967 11.5303L11.4697 14.5303C11.7626 14.8232 12.2374 14.8232 12.5303 14.5303L15.5303 11.5303Z",
    fill: "white"
  }));
}

// src/Icons/StatusIcons.tsx
import {
  IconAlertCircle,
  IconAlertTriangle,
  IconCheck as IconCheck2,
  IconInfoSquareRounded
} from "@tabler/icons-react";
import clsx11 from "clsx";
function StatusIconContainer({ Icon: Icon2, className, iconClassName: iconClassName2 }) {
  return /* @__PURE__ */ React.createElement("div", {
    className: clsx11("mx-auto flex items-center justify-center h-12 w-12 rounded-full animate-scale-in-center", className)
  }, /* @__PURE__ */ React.createElement(Icon2, {
    className: clsx11("h-6 w-6", iconClassName2),
    "aria-hidden": "true"
  }));
}
function AlertIcon({ className, iconClassName: iconClassName2 }) {
  return /* @__PURE__ */ React.createElement(StatusIconContainer, {
    Icon: IconAlertTriangle,
    className: clsx11(className, "bg-red-100/60 dark:bg-red-900/30"),
    iconClassName: clsx11(iconClassName2, "text-red-600 dark:text-red-300")
  });
}
function InfoIcon({ className, iconClassName: iconClassName2 }) {
  return /* @__PURE__ */ React.createElement(StatusIconContainer, {
    Icon: IconInfoSquareRounded,
    className: clsx11("bg-sky-100/60 dark:bg-sky-900/30", className),
    iconClassName: clsx11("text-sky-600 dark:text-sky-300", iconClassName2)
  });
}
function SuccessIcon({ className, iconClassName: iconClassName2 }) {
  return /* @__PURE__ */ React.createElement(StatusIconContainer, {
    Icon: IconCheck2,
    className: clsx11("bg-emerald-100/60 dark:bg-emerald-900/30", className),
    iconClassName: clsx11("text-emerald-600 dark:text-emerald-300", iconClassName2)
  });
}
function WarningIcon({ className, iconClassName: iconClassName2 }) {
  return /* @__PURE__ */ React.createElement(StatusIconContainer, {
    Icon: IconAlertCircle,
    className: clsx11(className, "bg-amber-100/60 dark:bg-amber-900/30"),
    iconClassName: clsx11(iconClassName2, "text-amber-600 dark:text-amber-300")
  });
}

// src/Table/index.tsx
import * as React7 from "react";
var Table = React7.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React7.createElement("div", {
    className: "relative w-full overflow-auto"
  }, /* @__PURE__ */ React7.createElement("table", __spreadValues({
    ref,
    className: cn("w-full caption-bottom text-sm", className)
  }, props)));
});
Table.displayName = "Table";
var TableHeader = React7.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React7.createElement("thead", __spreadValues({
    ref,
    className: cn("[&_tr]:border-b", className)
  }, props));
});
TableHeader.displayName = "TableHeader";
var TableBody = React7.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React7.createElement("tbody", __spreadValues({
    ref,
    className: cn("[&_tr:last-child]:border-0", className)
  }, props));
});
TableBody.displayName = "TableBody";
var TableFooter = React7.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React7.createElement("tfoot", __spreadValues({
    ref,
    className: cn("bg-muted font-medium text-muted-foreground", className)
  }, props));
});
TableFooter.displayName = "TableFooter";
var TableRow = React7.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React7.createElement("tr", __spreadValues({
    ref,
    className: cn("border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted", className)
  }, props));
});
TableRow.displayName = "TableRow";
var TableHead = React7.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React7.createElement("th", __spreadValues({
    ref,
    className: cn("h-10 px-2 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]", className)
  }, props));
});
TableHead.displayName = "TableHead";
var TableCell = React7.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React7.createElement("td", __spreadValues({
    ref,
    className: cn("p-2 align-middle [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]", className)
  }, props));
});
TableCell.displayName = "TableCell";
var TableCaption = React7.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React7.createElement("caption", __spreadValues({
    ref,
    className: cn("mt-4 text-sm text-muted-foreground", className)
  }, props));
});
TableCaption.displayName = "TableCaption";

// src/TextInput/TextInput.tsx
import clsx12 from "clsx";
import { forwardRef as forwardRef6 } from "react";
var TextInput = forwardRef6((_a, ref) => {
  var _b = _a, {
    label,
    helpLabel,
    error,
    errorLabel,
    optional,
    prefix,
    suffix,
    className,
    labelClassName,
    containerClassName,
    type = "text",
    suffixClassName,
    children
  } = _b, props = __objRest(_b, [
    "label",
    "helpLabel",
    "error",
    "errorLabel",
    "optional",
    "prefix",
    "suffix",
    "className",
    "labelClassName",
    "containerClassName",
    "type",
    "suffixClassName",
    "children"
  ]);
  const { name } = props;
  const hasLeading = prefix || !!children;
  const hasTrailing = suffix;
  const hasLabel = label && label.length > 0;
  return /* @__PURE__ */ React.createElement("div", {
    className: cn(containerClassName, "group")
  }, /* @__PURE__ */ React.createElement("div", {
    className: clsx12({
      "mt-1": !!label,
      flex: hasLeading || hasTrailing,
      relative: hasLeading || hasTrailing || hasLabel || !!children
    })
  }, hasLabel && /* @__PURE__ */ React.createElement(FormLabel, {
    className: cn(labelClassName, "text-[10px] leading-3 opacity-40 absolute top-[6px] z-[2]", {
      "left-[37px]": hasLeading,
      "left-[13px]": !hasLeading
    }),
    label,
    optional,
    name
  }), hasLeading && /* @__PURE__ */ React.createElement("div", {
    className: "absolute mt-[10px] z-10 pl-2"
  }, children, prefix), /* @__PURE__ */ React.createElement("input", __spreadProps(__spreadValues({}, props), {
    ref,
    type,
    className: clsx12(className, "block w-full pb-3 text-sm leading-[22px] control-gradient h-11", {
      "ring-destructive focus:outline-none": error,
      "pl-[36px]": hasLeading,
      "pr-[32px]": hasTrailing,
      "!pt-[18px]": hasLabel,
      "!pt-3": !hasLabel
    })
  })), hasTrailing && /* @__PURE__ */ React.createElement("div", {
    className: clsx12("absolute -ml-[30px] mt-[11px] left-full z-10", suffixClassName)
  }, suffix && /* @__PURE__ */ React.createElement("span", {
    className: "text-gray-500 sm:text-sm"
  }, suffix))), /* @__PURE__ */ React.createElement(FormHelpLabel, {
    helpLabel,
    error,
    errorLabel
  }));
});
TextInput.displayName = "TextInput";

// src/TextInput/TextInputArea.tsx
import { IconAlertCircle as IconAlertCircle2 } from "@tabler/icons-react";
import clsx13 from "clsx";
import { forwardRef as forwardRef7 } from "react";
var TextInputArea = forwardRef7((_a, ref) => {
  var _b = _a, { label, helpLabel, error, errorLabel, optional, className, containerClassName } = _b, props = __objRest(_b, ["label", "helpLabel", "error", "errorLabel", "optional", "className", "containerClassName"]);
  const { name } = props;
  return /* @__PURE__ */ React.createElement("div", {
    className: containerClassName
  }, /* @__PURE__ */ React.createElement(FormLabel, {
    label,
    optional,
    name
  }), /* @__PURE__ */ React.createElement("div", {
    className: clsx13("mt-1", {
      relative: error
    })
  }, /* @__PURE__ */ React.createElement("textarea", __spreadProps(__spreadValues({}, props), {
    ref,
    className: clsx13("shadow-sm block w-full sm:text-sm rounded-md bg-transparent text-foreground disabled:opacity-60", {
      "focus:ring-tertiary focus:border-tertiary border-input": !error,
      "border-destructive text-destructive placeholder-destructive focus:outline-none focus:ring-destructive focus:border-destructive": error
    }, className)
  })), error && /* @__PURE__ */ React.createElement("div", {
    className: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none gap-x-1"
  }, error && /* @__PURE__ */ React.createElement(IconAlertCircle2, {
    className: "h-5 w-5 text-destructive",
    "aria-hidden": "true"
  }))), /* @__PURE__ */ React.createElement(FormHelpLabel, {
    helpLabel,
    error,
    errorLabel
  }));
});
TextInputArea.displayName = "TextInputArea";

// src/Tooltip/index.tsx
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { forwardRef as forwardRef8 } from "react";
var TooltipProvider = TooltipPrimitive.Provider;
var BaseTooltip = TooltipPrimitive.Root;
var TooltipTrigger = TooltipPrimitive.Trigger;
var TooltipContent = forwardRef8((_a, ref) => {
  var _b = _a, { className, sideOffset = 4 } = _b, props = __objRest(_b, ["className", "sideOffset"]);
  return /* @__PURE__ */ React.createElement(TooltipPrimitive.Content, __spreadValues({
    ref,
    sideOffset,
    className: cn("z-50 max-w-sm overflow-hidden rounded-md bg-foreground px-3 py-1.5 text-left text-xs leading-relaxed text-background whitespace-normal animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className)
  }, props));
});
TooltipContent.displayName = TooltipPrimitive.Content.displayName;
function Tooltip({ content, children }) {
  return /* @__PURE__ */ React.createElement(TooltipProvider, null, /* @__PURE__ */ React.createElement(BaseTooltip, {
    delayDuration: 300
  }, /* @__PURE__ */ React.createElement(TooltipTrigger, {
    asChild: true
  }, children), /* @__PURE__ */ React.createElement(TooltipContent, null, content)));
}

// src/DataTable/DataTableFacetedFilter.tsx
import { IconCheck as IconCheck3, IconCirclePlus } from "@tabler/icons-react";
import * as React12 from "react";
import { useMemo as useMemo3 } from "react";

// src/Command/index.tsx
import { IconSearch } from "@tabler/icons-react";
import { Command as CommandPrimitive } from "cmdk";
import * as React9 from "react";

// src/Dialog/AlertDialog.tsx
import { useTranslation as useTranslation3 } from "@sg/i18n";

// src/Dialog/BaseDialog.tsx
import * as DialogPrimitive from "@radix-ui/react-dialog";
import i18n from "@sg/i18n";
import * as React8 from "react";
import { IconX } from "@tabler/icons-react";
"use client";
var Dialog = DialogPrimitive.Root;
var DialogTrigger = DialogPrimitive.Trigger;
var DialogPortal = (_a) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React8.createElement(DialogPrimitive.Portal, __spreadValues({
    className: cn(className)
  }, props));
};
DialogPortal.displayName = DialogPrimitive.Portal.displayName;
var DialogOverlay = React8.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React8.createElement(DialogPrimitive.Overlay, __spreadValues({
    ref,
    className: cn("bg-background/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 backdrop-blur-sm", className)
  }, props));
});
DialogOverlay.displayName = DialogPrimitive.Overlay.displayName;
var DialogContent = React8.forwardRef((_a, ref) => {
  var _b = _a, { className, children, closeButton, loading } = _b, props = __objRest(_b, ["className", "children", "closeButton", "loading"]);
  return /* @__PURE__ */ React8.createElement(DialogPortal, null, /* @__PURE__ */ React8.createElement(DialogOverlay, null), /* @__PURE__ */ React8.createElement("div", {
    className: "relative"
  }, /* @__PURE__ */ React8.createElement(DialogPrimitive.Content, __spreadValues({
    ref,
    className: cn("bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border p-6 shadow-lg duration-200 sm:rounded-lg md:w-full overflow-auto", className, {
      "overflow-hidden": loading
    })
  }, props), loading && /* @__PURE__ */ React8.createElement("div", {
    className: "w-full h-full flex items-center justify-center absolute bg-black/[.40] rounded-lg",
    style: { zIndex: 1, pointerEvents: "auto" }
  }, /* @__PURE__ */ React8.createElement(Spinner, null)), children, closeButton && /* @__PURE__ */ React8.createElement(DialogPrimitive.Close, {
    className: "ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute right-4 top-4 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none"
  }, /* @__PURE__ */ React8.createElement(IconX, {
    className: "h-4 w-4"
  }), /* @__PURE__ */ React8.createElement("span", {
    className: "sr-only"
  }, "Close")))));
});
DialogContent.displayName = DialogPrimitive.Content.displayName;
var DialogCloser = React8.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React8.createElement(DialogPrimitive.Close, __spreadValues({
    ref,
    className: cn("focus:outline-none", className)
  }, props));
});
DialogCloser.displayName = DialogPrimitive.Close.displayName;
var DialogHeader = (_a) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React8.createElement("div", __spreadValues({
    className: cn("flex flex-col space-y-1.5 text-center sm:text-left", className)
  }, props));
};
DialogHeader.displayName = "DialogHeader";
var DialogFooter = (_a) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React8.createElement("div", __spreadValues({
    className: cn("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", className)
  }, props));
};
DialogFooter.displayName = "DialogFooter";
var DialogTitle = React8.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React8.createElement(DialogPrimitive.Title, __spreadValues({
    ref,
    className: cn("text-lg font-semibold leading-none tracking-tight", className)
  }, props));
});
DialogTitle.displayName = DialogPrimitive.Title.displayName;
var DialogDescription = React8.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React8.createElement(DialogPrimitive.Description, __spreadValues({
    ref,
    className: cn("text-muted-foreground text-sm", className)
  }, props));
});
DialogDescription.displayName = DialogPrimitive.Description.displayName;
function useDialog() {
  const [open, setOpen] = React8.useState(true);
  return {
    open,
    trigger: () => {
      setOpen(true);
    },
    onOpenChange: (result) => {
      setOpen(result);
    }
  };
}
function DialogActions({
  classes,
  closeLabel = i18n.t("close"),
  variant,
  primaryLabel,
  primaryDisabled,
  onPrimary,
  onClose
}) {
  return /* @__PURE__ */ React8.createElement("div", {
    className: "flex items-center justify-end gap-2 pt-4"
  }, /* @__PURE__ */ React8.createElement(DialogCloser, {
    asChild: true
  }, /* @__PURE__ */ React8.createElement(Button, {
    className: classes == null ? void 0 : classes.closeButton,
    variant: !!onPrimary ? "outline" : variant,
    onClick: onClose
  }, closeLabel)), onPrimary && /* @__PURE__ */ React8.createElement(DialogCloser, {
    asChild: true
  }, /* @__PURE__ */ React8.createElement(Button, {
    className: classes == null ? void 0 : classes.primaryButton,
    variant,
    disabled: primaryDisabled,
    onClick: onPrimary
  }, primaryLabel)));
}

// src/Dialog/AlertDialog.tsx
function AlertDialog(_a) {
  var _b = _a, { title, description, children, actions } = _b, props = __objRest(_b, ["title", "description", "children", "actions"]);
  const { t } = useTranslation3();
  return /* @__PURE__ */ React.createElement(Dialog, __spreadValues({}, props), /* @__PURE__ */ React.createElement(DialogContent, null, /* @__PURE__ */ React.createElement(DialogHeader, null, /* @__PURE__ */ React.createElement(DialogTitle, null, title || t("alert"), " "), /* @__PURE__ */ React.createElement(DialogDescription, null, description), children && /* @__PURE__ */ React.createElement("div", {
    className: "py-4"
  }, children), /* @__PURE__ */ React.createElement(DialogActions, __spreadValues({
    variant: "destructive",
    closeLabel: t("close")
  }, actions)))));
}

// src/Dialog/InfoDialog.tsx
import { useTranslation as useTranslation4 } from "@sg/i18n";
function InfoDialog(_a) {
  var _b = _a, {
    title,
    description,
    children,
    actions,
    loading
  } = _b, props = __objRest(_b, [
    "title",
    "description",
    "children",
    "actions",
    "loading"
  ]);
  const { t } = useTranslation4();
  return /* @__PURE__ */ React.createElement(Dialog, __spreadValues({}, props), /* @__PURE__ */ React.createElement(DialogContent, {
    className: "overflow-y-scroll max-h-screen",
    loading
  }, /* @__PURE__ */ React.createElement(DialogHeader, null, /* @__PURE__ */ React.createElement(DialogTitle, null, title || t("info"), " "), /* @__PURE__ */ React.createElement(DialogDescription, null, description), children && /* @__PURE__ */ React.createElement("div", {
    className: "py-4"
  }, children), /* @__PURE__ */ React.createElement(DialogActions, __spreadValues({
    variant: "default",
    closeLabel: t("close")
  }, actions)))));
}

// src/Command/index.tsx
var Command = React9.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React9.createElement(CommandPrimitive, __spreadValues({
    ref,
    className: cn("flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground", className)
  }, props));
});
Command.displayName = CommandPrimitive.displayName;
var CommandInput = React9.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React9.createElement("div", {
    className: "flex items-center border-b px-3 py-1",
    "cmdk-input-wrapper": ""
  }, /* @__PURE__ */ React9.createElement(IconSearch, {
    className: "mr-2 h-4 w-4 shrink-0 opacity-50"
  }), /* @__PURE__ */ React9.createElement(CommandPrimitive.Input, __spreadValues({
    ref,
    className: cn("flex h-8 w-full rounded-md bg-transparent py-2 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50", className)
  }, props)));
});
CommandInput.displayName = CommandPrimitive.Input.displayName;
var CommandList = React9.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React9.createElement(CommandPrimitive.List, __spreadValues({
    ref,
    className: cn("max-h-[300px] overflow-y-auto overflow-x-hidden", className)
  }, props));
});
CommandList.displayName = CommandPrimitive.List.displayName;
var CommandEmpty = React9.forwardRef((props, ref) => /* @__PURE__ */ React9.createElement(CommandPrimitive.Empty, __spreadValues({
  ref,
  className: "py-6 text-center text-sm"
}, props)));
CommandEmpty.displayName = CommandPrimitive.Empty.displayName;
var CommandGroup = React9.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React9.createElement(CommandPrimitive.Group, __spreadValues({
    ref,
    className: cn("overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground", className)
  }, props));
});
CommandGroup.displayName = CommandPrimitive.Group.displayName;
var CommandSeparator = React9.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React9.createElement(CommandPrimitive.Separator, __spreadValues({
    ref,
    className: cn("-mx-1 h-px bg-border", className)
  }, props));
});
CommandSeparator.displayName = CommandPrimitive.Separator.displayName;
var CommandItem = React9.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React9.createElement(CommandPrimitive.Item, __spreadValues({
    ref,
    className: cn("relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none aria-selected:bg-accent aria-selected:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50", className)
  }, props));
});
CommandItem.displayName = CommandPrimitive.Item.displayName;
var CommandShortcut = (_a) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React9.createElement("span", __spreadValues({
    className: cn("ml-auto text-xs tracking-widest text-muted-foreground", className)
  }, props));
};
CommandShortcut.displayName = "CommandShortcut";

// src/Popover/index.tsx
import clsx14 from "clsx";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import * as React10 from "react";
var Popover = PopoverPrimitive.Root;
var PopoverTrigger = PopoverPrimitive.Trigger;
var PopoverContent = React10.forwardRef((_a, ref) => {
  var _b = _a, { className, align = "center", sideOffset = 4 } = _b, props = __objRest(_b, ["className", "align", "sideOffset"]);
  return /* @__PURE__ */ React10.createElement(PopoverPrimitive.Portal, null, /* @__PURE__ */ React10.createElement(PopoverPrimitive.Content, __spreadValues({
    ref,
    align,
    sideOffset,
    className: cn("z-50 min-w-[18rem] rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className)
  }, props)));
});
PopoverContent.displayName = PopoverPrimitive.Content.displayName;
function ButtonPopover({ Icon: Icon2, className, iconClassName: iconClassName2, children }) {
  return /* @__PURE__ */ React10.createElement(Popover, null, /* @__PURE__ */ React10.createElement(PopoverTrigger, {
    asChild: true
  }, /* @__PURE__ */ React10.createElement("div", null, /* @__PURE__ */ React10.createElement(Icon2, {
    className: clsx14("text-tertiary transition ease-in-out delay-150 hover:scale-[1.2] duration-300 cursor-pointer", iconClassName2)
  }))), /* @__PURE__ */ React10.createElement(PopoverContent, null, /* @__PURE__ */ React10.createElement("div", {
    className
  }, children)));
}

// src/Separator/index.tsx
import * as SeparatorPrimitive from "@radix-ui/react-separator";
import * as React11 from "react";
var Separator = React11.forwardRef((_a, ref) => {
  var _b = _a, { className, orientation = "horizontal", decorative = true } = _b, props = __objRest(_b, ["className", "orientation", "decorative"]);
  return /* @__PURE__ */ React11.createElement(SeparatorPrimitive.Root, __spreadValues({
    ref,
    decorative,
    orientation,
    className: cn("bg-border shrink-0", orientation === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]", className)
  }, props));
});
Separator.displayName = SeparatorPrimitive.Root.displayName;

// src/DataTable/DataTableFacetedFilter.tsx
function DataTableFacetedFilter({
  column,
  title,
  options,
  onFilterChange,
  sortComparator
}) {
  const [, setUpdated] = React12.useState(0);
  const facets = column == null ? void 0 : column.getFacetedUniqueValues();
  const selectedValues = new Set(column == null ? void 0 : column.getFilterValue());
  const items = useMemo3(() => {
    if (sortComparator) {
      return options.sort((a, b) => sortComparator(a.value, b.value));
    }
    return options;
  }, [options, sortComparator]);
  return /* @__PURE__ */ React12.createElement(Popover, null, /* @__PURE__ */ React12.createElement(PopoverTrigger, {
    asChild: true
  }, /* @__PURE__ */ React12.createElement(Button, {
    variant: "raised"
  }, /* @__PURE__ */ React12.createElement(IconCirclePlus, {
    className: "mr-2 h-4 w-4"
  }), title, (selectedValues == null ? void 0 : selectedValues.size) > 0 && /* @__PURE__ */ React12.createElement(React12.Fragment, null, /* @__PURE__ */ React12.createElement(Separator, {
    orientation: "vertical",
    className: "mx-2 h-4"
  }), /* @__PURE__ */ React12.createElement(Badge, {
    variant: "secondary",
    className: "rounded-sm px-1 font-normal lg:hidden"
  }, selectedValues.size), /* @__PURE__ */ React12.createElement("div", {
    className: "hidden space-x-1 lg:flex"
  }, selectedValues.size > 2 ? /* @__PURE__ */ React12.createElement(Badge, {
    variant: "secondary",
    className: "rounded-sm px-1 font-normal"
  }, selectedValues.size, " selected") : options.filter((option) => selectedValues.has(option.value)).map((option) => /* @__PURE__ */ React12.createElement(Badge, {
    variant: "secondary",
    key: option.value,
    className: "rounded-sm px-1 font-normal"
  }, option.label)))))), /* @__PURE__ */ React12.createElement(PopoverContent, {
    className: "w-[200px] p-0",
    align: "start"
  }, /* @__PURE__ */ React12.createElement(Command, null, /* @__PURE__ */ React12.createElement(CommandInput, {
    placeholder: title
  }), /* @__PURE__ */ React12.createElement(CommandList, null, /* @__PURE__ */ React12.createElement(CommandEmpty, null, "No results found."), /* @__PURE__ */ React12.createElement(CommandGroup, null, items.map((option) => {
    const isSelected = selectedValues.has(option.value);
    return /* @__PURE__ */ React12.createElement(CommandItem, {
      key: option.value,
      onSelect: () => {
        if (isSelected) {
          selectedValues.delete(option.value);
        } else {
          selectedValues.add(option.value);
        }
        const filterValues = Array.from(selectedValues);
        column == null ? void 0 : column.setFilterValue(filterValues.length ? filterValues : void 0);
        onFilterChange();
        setUpdated(Date.now());
      }
    }, /* @__PURE__ */ React12.createElement("div", {
      className: cn("mr-2 flex h-4 w-4 items-center justify-center rounded-sm border border-primary", isSelected ? "bg-primary text-primary-foreground" : "opacity-50 [&_svg]:invisible")
    }, /* @__PURE__ */ React12.createElement(IconCheck3, {
      className: cn("h-4 w-4")
    })), option.icon && /* @__PURE__ */ React12.createElement(option.icon, {
      className: "mr-2 h-4 w-4 text-muted-foreground"
    }), /* @__PURE__ */ React12.createElement("span", null, option.label), (facets == null ? void 0 : facets.get(option.value)) && /* @__PURE__ */ React12.createElement("span", {
      className: "ml-auto flex h-4 w-4 items-center justify-center font-mono text-xs"
    }, facets.get(option.value)));
  })), selectedValues.size > 0 && /* @__PURE__ */ React12.createElement(React12.Fragment, null, /* @__PURE__ */ React12.createElement(CommandSeparator, null), /* @__PURE__ */ React12.createElement(CommandGroup, null, /* @__PURE__ */ React12.createElement(CommandItem, {
    onSelect: () => {
      column == null ? void 0 : column.setFilterValue(void 0);
      onFilterChange();
      setUpdated(Date.now());
    },
    className: "justify-center text-center"
  }, "Clear filters")))))));
}

// src/DataTable/DataTableHeaderAction.tsx
function DataGridHeaderAction({ label, Icon: Icon2, disabled, loading, hide: hide2, onClick }) {
  const btnProps = {
    onClick,
    disabled: disabled || loading
  };
  if (hide2)
    return /* @__PURE__ */ React.createElement(React.Fragment, null);
  if (!Icon2)
    return /* @__PURE__ */ React.createElement(Button, __spreadValues({
      className: "h-11"
    }, btnProps), label);
  return /* @__PURE__ */ React.createElement(Tooltip, {
    content: label
  }, /* @__PURE__ */ React.createElement(Button, __spreadValues({
    size: "icon",
    variant: "raised"
  }, btnProps), loading && /* @__PURE__ */ React.createElement(Spinner, {
    className: "!mx-[2px]",
    size: "xs"
  }), !loading && /* @__PURE__ */ React.createElement(Icon2, {
    className: "foreground-secondary h-5 w-5"
  })));
}

// src/DataTable/DataTablePagination.tsx
import { useTranslation as useTranslation5 } from "@sg/i18n";
import clsx16 from "clsx";

// src/SelectMenu/index.tsx
import { useEffect as useEffect2, useState as useState4 } from "react";

// ../../node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function expandPaddingObject(padding) {
  return __spreadValues({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }, padding);
}
function getSideObjectFromPadding(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  return __spreadProps(__spreadValues({}, rect), {
    top: rect.y,
    left: rect.x,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
async function detectOverflow(middlewareArguments, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform,
    rects,
    elements,
    strategy
  } = middlewareArguments;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding = 0
  } = options;
  const paddingObject = getSideObjectFromPadding(padding);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform.getClippingRect({
    element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const elementClientRect = rectToClientRect(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: elementContext === "floating" ? __spreadProps(__spreadValues({}, rects.floating), {
      x,
      y
    }) : rects.reference,
    offsetParent: await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating)),
    strategy
  }) : rects[elementContext]);
  return {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
}
var max = Math.max;
var size = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "size",
    options,
    async fn(middlewareArguments) {
      const {
        placement,
        rects,
        platform,
        elements
      } = middlewareArguments;
      const _a = options, {
        apply = () => {
        }
      } = _a, detectOverflowOptions = __objRest(_a, [
        "apply"
      ]);
      const overflow = await detectOverflow(middlewareArguments, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      let heightSide;
      let widthSide;
      if (side === "top" || side === "bottom") {
        heightSide = side;
        widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
      } else {
        widthSide = side;
        heightSide = alignment === "end" ? "top" : "bottom";
      }
      const xMin = max(overflow.left, 0);
      const xMax = max(overflow.right, 0);
      const yMin = max(overflow.top, 0);
      const yMax = max(overflow.bottom, 0);
      const dimensions = {
        availableHeight: rects.floating.height - (["left", "right"].includes(placement) ? 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max(overflow.top, overflow.bottom)) : overflow[heightSide]),
        availableWidth: rects.floating.width - (["top", "bottom"].includes(placement) ? 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right)) : overflow[widthSide])
      };
      await apply(__spreadValues(__spreadValues({}, middlewareArguments), dimensions));
      const nextDimensions = await platform.getDimensions(elements.floating);
      if (rects.floating.width !== nextDimensions.width || rects.floating.height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};

// src/SelectMenu/index.tsx
import { Float } from "@headlessui-float/react";
import { Combobox } from "@headlessui/react";
import clsx15 from "clsx";
function ComboBoxContent({
  open,
  displayValue,
  displayIcon,
  inputClassName,
  filteredOptions,
  disabled,
  readOnly,
  multi,
  query,
  setQuery,
  label,
  above
}) {
  return /* @__PURE__ */ React.createElement("div", {
    className: clsx15("mt-1", disabled && "opacity-60")
  }, /* @__PURE__ */ React.createElement(Float, {
    as: "div",
    show: !!open,
    portal: true,
    flip: true,
    shift: 8,
    offset: 4,
    placement: above === false ? "bottom-start" : "top-start",
    zIndex: 50,
    leave: "transition ease-in duration-100",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0",
    onHide: () => setQuery(""),
    middleware: [
      size({
        apply({ rects, elements }) {
          Object.assign(elements.floating.style, {
            width: `${rects.reference.width}px`
          });
        }
      })
    ]
  }, /* @__PURE__ */ React.createElement("div", {
    className: "relative w-full cursor-default overflow-hidden pb-3 text-sm leading-[22px] text-white focus:ring-transparent focus:border-white/40 border-1 border-transparent ring-0 ring-transparent rounded-xl shadow-inner bg-gradient disabled:opacity-30 h-11"
  }, label, /* @__PURE__ */ React.createElement("div", {
    className: "relative"
  }, displayIcon && /* @__PURE__ */ React.createElement("div", {
    className: "absolute inset-y-0 left-0 flex items-center justify-center pl-2"
  }, displayIcon), /* @__PURE__ */ React.createElement(Combobox.Input, {
    className: clsx15("w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-foreground bg-transparent rounded-xl h-11 focus:ring-transparent", { "!pl-9": !!displayIcon }, inputClassName),
    displayValue,
    onChange: (event) => setQuery(event.target.value)
  })), !readOnly && /* @__PURE__ */ React.createElement(Combobox.Button, {
    className: "absolute inset-y-0 right-0 flex items-center pr-2"
  }, /* @__PURE__ */ React.createElement(DropdownArrow, {
    className: cn("transition ease-in-out delay-50", {
      "rotate-180 transform": open
    })
  }))), /* @__PURE__ */ React.createElement(Combobox.Options, {
    static: true,
    className: "max-h-60 overflow-auto rounded-xl py-1 text-base focus:outline-none sm:text-sm bg-gradient"
  }, filteredOptions.length === 0 && query !== "" ? /* @__PURE__ */ React.createElement("div", {
    className: "relative cursor-default select-none py-2 px-4 text-gray-700"
  }, "Nothing found.") : filteredOptions.map((option) => /* @__PURE__ */ React.createElement(Combobox.Option, {
    key: option.value,
    className: cn("relative select-none py-1 pr-4 cursor-pointer disabled:cursor-not-allowed disabled:opacity-60 disabled:pointer-events-none", {
      "pl-4": !multi,
      "pl-11": multi,
      hidden: option.disabled && !readOnly
    }),
    value: option,
    disabled: option.disabled
  }, ({ selected, active }) => /* @__PURE__ */ React.createElement(React.Fragment, null, option.secondaryLabel && /* @__PURE__ */ React.createElement("span", {
    className: cn("block truncate font-nomral text-[10px] text-white leading-3 hover:opacity-100 transition ease-in-out duration-300", {
      "opacity-40": !active && !option.disabled,
      "pointer-events-none opacity-20": option.disabled
    })
  }, option.secondaryLabel), /* @__PURE__ */ React.createElement("span", {
    className: cn("block truncate hover:opacity-100 transition ease-in-out duration-300", {
      "opacity-40": !active && !option.disabled,
      "pointer-events-none opacity-20": option.disabled
    })
  }, /* @__PURE__ */ React.createElement("div", {
    className: "flex items-center gap-2"
  }, option.icon, option.label)), multi && /* @__PURE__ */ React.createElement("span", {
    className: "absolute inset-y-0 left-0 flex items-center pl-3 pr-1"
  }, selected && /* @__PURE__ */ React.createElement(CheckboxOnIcon, {
    "aria-hidden": "true"
  }), !selected && /* @__PURE__ */ React.createElement(CheckboxOffIcon, {
    "aria-hidden": "true"
  }))))))));
}
function SelectMenu({
  onChange = () => {
  },
  className,
  inputClassName,
  selected,
  disabled,
  readOnly,
  loading,
  formLabelClassName,
  options,
  label,
  labelClassName,
  helpLabel,
  helpLabelClassName,
  error,
  errorLabel,
  above
}) {
  const [selectedItem, setSelectedItem] = useState4();
  const [query, setQuery] = useState4("");
  const filteredOptions = query === "" ? options : options.filter((a) => a.label.toLowerCase().includes(query.toLowerCase()));
  useEffect2(() => {
    if (selected) {
      setSelectedItem(options.find((item) => item.value === selected));
    } else if (selected === null) {
      setSelectedItem(null);
    }
  }, [options, selected]);
  return /* @__PURE__ */ React.createElement("div", {
    className: clsx15("flex-col space-y-1", className)
  }, loading && /* @__PURE__ */ React.createElement(Skeleton, {
    containerClassName: "mt-1",
    className: "!h-11 w-full !rounded-xl"
  }), !loading && /* @__PURE__ */ React.createElement(Combobox, {
    disabled: disabled || readOnly,
    value: selectedItem,
    onChange: (result) => {
      setSelectedItem(result);
      onChange(result);
    }
  }, ({ open }) => /* @__PURE__ */ React.createElement(ComboBoxContent, {
    open,
    displayIcon: selectedItem == null ? void 0 : selectedItem.icon,
    displayValue: (option) => option ? option.label : "",
    disabled: disabled || readOnly,
    readOnly,
    inputClassName: cn(inputClassName, !!label && "pt-[14px]"),
    filteredOptions,
    query,
    setQuery,
    above,
    label: label && /* @__PURE__ */ React.createElement("div", {
      className: "absolute left-[11px] top-[6px]"
    }, /* @__PURE__ */ React.createElement(FormLabel, {
      className: clsx15(cn(formLabelClassName, "font-medium text-[10px] leading-3 z-[12] opacity-40"), labelClassName),
      label
    }))
  })), /* @__PURE__ */ React.createElement(FormHelpLabel, {
    className: helpLabelClassName,
    helpLabel,
    error,
    errorLabel
  }));
}
function MultiSelectMenu({
  onChange = () => {
  },
  className,
  inputClassName,
  selected = [],
  disabled,
  readOnly,
  loading,
  formLabelClassName,
  options,
  label,
  helpLabel,
  helpLabelClassName,
  error,
  errorLabel,
  above
}) {
  const [selectedItem, setSelectedItem] = useState4();
  const [query, setQuery] = useState4("");
  const filteredOptions = query === "" ? options : options.filter((a) => a.label.toLowerCase().includes(query.toLowerCase()));
  useEffect2(() => {
    if (selected || selected === null) {
      if (selected.length === 0 && (selectedItem == null ? void 0 : selectedItem.length) === 0) {
        return;
      }
      setSelectedItem(options.filter((item) => selected.includes(item.value)));
    }
  }, [options, selected]);
  return /* @__PURE__ */ React.createElement("div", {
    className: clsx15("flex-col space-y-1", className)
  }, loading && /* @__PURE__ */ React.createElement(Skeleton, {
    containerClassName: "mt-1",
    className: "!h-11 w-full !rounded-xl"
  }), !loading && /* @__PURE__ */ React.createElement(Combobox, {
    multiple: true,
    disabled: disabled || readOnly,
    value: selectedItem,
    onChange: (result) => {
      setSelectedItem(result);
      onChange(result);
    }
  }, ({ open }) => /* @__PURE__ */ React.createElement(ComboBoxContent, {
    open,
    displayValue: (options2) => {
      var _a;
      return ((_a = options2 == null ? void 0 : options2.map((o) => o.label)) == null ? void 0 : _a.join(", ")) || "";
    },
    disabled: disabled || readOnly,
    readOnly,
    inputClassName: cn(inputClassName, !!label && "pt-[14px]"),
    filteredOptions,
    query,
    setQuery,
    multi: true,
    above,
    label: label && /* @__PURE__ */ React.createElement("div", {
      className: "absolute left-[11px] top-[6px]"
    }, /* @__PURE__ */ React.createElement(FormLabel, {
      className: clsx15(formLabelClassName, "absolute h-3 font-medium text-[10px] leading-3 z-[12] opacity-40"),
      label
    }))
  })), /* @__PURE__ */ React.createElement(FormHelpLabel, {
    className: helpLabelClassName,
    helpLabel,
    error,
    errorLabel
  }));
}
function makeOptions(items, labelField = "name", valueField = "id") {
  return (items == null ? void 0 : items.map((i) => ({
    label: i[labelField],
    value: i[valueField]
  }))) || [];
}

// src/DataTable/DataTablePagination.tsx
function DataTablePagination({ table, className }) {
  const { t } = useTranslation5();
  return /* @__PURE__ */ React.createElement("div", {
    className: clsx16("flex items-center justify-end p-2", className)
  }, /* @__PURE__ */ React.createElement("div", {
    className: "flex items-center space-x-6 lg:space-x-8"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "flex items-center space-x-2"
  }, /* @__PURE__ */ React.createElement(Button, {
    variant: "raised",
    size: "icon",
    onClick: () => table.setPageIndex(0),
    disabled: !table.getCanPreviousPage()
  }, /* @__PURE__ */ React.createElement("span", {
    className: "sr-only"
  }, "Go to first page"), /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M14.9697 15.5303C15.2626 15.8232 15.7374 15.8232 16.0303 15.5303C16.3232 15.2374 16.3232 14.7626 16.0303 14.4697L13.5607 12L16.0303 9.53033C16.3232 9.23744 16.3232 8.76256 16.0303 8.46967C15.7374 8.17678 15.2626 8.17678 14.9697 8.46967L11.9697 11.4697C11.6768 11.7626 11.6768 12.2374 11.9697 12.5303L14.9697 15.5303Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M10.9697 15.5303C11.2626 15.8232 11.7374 15.8232 12.0303 15.5303C12.3232 15.2374 12.3232 14.7626 12.0303 14.4697L9.56066 12L12.0303 9.53033C12.3232 9.23744 12.3232 8.76256 12.0303 8.46967C11.7374 8.17678 11.2626 8.17678 10.9697 8.46967L7.96967 11.4697C7.67678 11.7626 7.67678 12.2374 7.96967 12.5303L10.9697 15.5303Z",
    fill: "white"
  }))), /* @__PURE__ */ React.createElement(Button, {
    variant: "raised",
    size: "icon",
    onClick: () => table.previousPage(),
    disabled: !table.getCanPreviousPage()
  }, /* @__PURE__ */ React.createElement("span", {
    className: "sr-only"
  }, "Go to previous page"), /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M12.9697 8.46967C13.2626 8.17678 13.7374 8.17678 14.0303 8.46967C14.3232 8.76256 14.3232 9.23744 14.0303 9.53033L11.5607 12L14.0303 14.4697C14.3232 14.7626 14.3232 15.2374 14.0303 15.5303C13.7374 15.8232 13.2626 15.8232 12.9697 15.5303L9.96967 12.5303C9.67678 12.2374 9.67678 11.7626 9.96967 11.4697L12.9697 8.46967Z",
    fill: "white"
  }))), /* @__PURE__ */ React.createElement("div", {
    className: "flex px-4 items-center justify-center text-xs"
  }, table.getState().pagination.pageIndex + 1, " of ", table.getPageCount() || 1), /* @__PURE__ */ React.createElement(Button, {
    variant: "raised",
    size: "icon",
    onClick: () => table.nextPage(),
    disabled: !table.getCanNextPage()
  }, /* @__PURE__ */ React.createElement("span", {
    className: "sr-only"
  }, "Go to next page"), /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M11.0303 8.46967C10.7374 8.17678 10.2626 8.17678 9.96967 8.46967C9.67678 8.76256 9.67678 9.23744 9.96967 9.53033L12.4393 12L9.96967 14.4697C9.67678 14.7626 9.67678 15.2374 9.96967 15.5303C10.2626 15.8232 10.7374 15.8232 11.0303 15.5303L14.0303 12.5303C14.3232 12.2374 14.3232 11.7626 14.0303 11.4697L11.0303 8.46967Z",
    fill: "white"
  }))), /* @__PURE__ */ React.createElement(Button, {
    variant: "raised",
    size: "icon",
    onClick: () => table.setPageIndex(table.getPageCount() - 1),
    disabled: !table.getCanNextPage()
  }, /* @__PURE__ */ React.createElement("span", {
    className: "sr-only"
  }, "Go to last page"), /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M9.03033 15.5303C8.73744 15.8232 8.26256 15.8232 7.96967 15.5303C7.67678 15.2374 7.67678 14.7626 7.96967 14.4697L10.4393 12L7.96967 9.53033C7.67678 9.23744 7.67678 8.76256 7.96967 8.46967C8.26256 8.17678 8.73744 8.17678 9.03033 8.46967L12.0303 11.4697C12.3232 11.7626 12.3232 12.2374 12.0303 12.5303L9.03033 15.5303Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M13.0303 15.5303C12.7374 15.8232 12.2626 15.8232 11.9697 15.5303C11.6768 15.2374 11.6768 14.7626 11.9697 14.4697L14.4393 12L11.9697 9.53033C11.6768 9.23744 11.6768 8.76256 11.9697 8.46967C12.2626 8.17678 12.7374 8.17678 13.0303 8.46967L16.0303 11.4697C16.3232 11.7626 16.3232 12.2374 16.0303 12.5303L13.0303 15.5303Z",
    fill: "white"
  }))), /* @__PURE__ */ React.createElement("div", {
    className: "flex items-center space-x-2 pl-8"
  }, /* @__PURE__ */ React.createElement(SelectMenu, {
    className: "w-[100px]",
    above: true,
    label: t("rows"),
    options: [10, 20, 30, 40, 50].map((r) => ({ label: `${r}`, value: r })),
    selected: table.getState().pagination.pageSize,
    onChange: async ({ value }) => {
      table.setPageSize(Number(value));
    }
  })))));
}

// src/DataTable/index.tsx
"use client";
var IGNORED_COLS = ["select", "actions", "expand"];
var LOADING_COUNT = 10;
function floatAccessor(value) {
  return parseFloat(value) || 0;
}
function getValue(value) {
  return value === null ? "N/A" : value;
}
function onExportCsv(filename, rows) {
  const rowData = rows.flatMap((row) => {
    const result = [{}];
    row.getAllCells().forEach((c) => {
      if (IGNORED_COLS.includes(c.column.id))
        return;
      result[0][c.column.id] = getValue(c.renderValue());
    });
    row.subRows.forEach((sr, idx) => {
      result.push({});
      sr.getAllCells().forEach((c) => {
        if (IGNORED_COLS.includes(c.column.id))
          return;
        result[idx + 1][c.column.id] = getValue(c.renderValue());
      });
    });
    return result;
  });
  const csv = json2csv(rowData);
  downloadFile(new Blob([csv], { type: "text-csv" }), `${filename}-${new Date().toISOString()}.csv`);
}
function DataTableRowExpandButton({ row }) {
  if (row.getCanExpand()) {
    return /* @__PURE__ */ React.createElement("button", __spreadValues({}, {
      type: "button",
      onClick: row.getToggleExpandedHandler(),
      style: { cursor: "pointer" }
    }), /* @__PURE__ */ React.createElement(ArrowRightIcon, {
      className: clsx17(row.getIsExpanded() ? "rotate-90" : "", "shrink-0 animate duration-150 ease-in-out")
    }));
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null);
}
function DataTableOverlay({ children }) {
  return /* @__PURE__ */ React.createElement("div", {
    className: "w-full h-full flex items-center justify-center p-10 absolute"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "p-4 bg-card rounded-lg border border-solid border-border shadow",
    style: { zIndex: 1 }
  }, children));
}
function DataTableLoadingSkeleton() {
  return /* @__PURE__ */ React.createElement(TableRow, null, /* @__PURE__ */ React.createElement(TableCell, {
    colSpan: 1e3
  }, Array(...Array(10)).map((_, i) => /* @__PURE__ */ React.createElement(Skeleton, {
    key: `loading-${i}`,
    className: clsx17("h-[21px]", {
      "mb-1": i === 0,
      "mt-1": i + 1 >= LOADING_COUNT,
      "my-1": i !== 0 && i + 1 < LOADING_COUNT
    })
  }))));
}
function filterFn(row, id, value) {
  return value.includes(row.getValue(id));
}
var RemoteDataTable = forwardRef13(function RemoteDataTable2(_a, ref) {
  var _b = _a, { query, actions = [], filter, error } = _b, props = __objRest(_b, ["query", "actions", "filter", "error"]);
  const { t } = useTranslation6();
  const { data, isLoading, isRefetching, isError, refetch } = query;
  const tableRef = useRef(null);
  const resolvedData = useMemo4(() => {
    return filter ? data == null ? void 0 : data.filter(filter) : data;
  }, [filter, data]);
  useUpdateEffect(() => {
    var _a2;
    (_a2 = tableRef.current) == null ? void 0 : _a2.resetPageIndex();
  }, [!!filter]);
  useImperativeHandle(ref, () => tableRef.current, []);
  return /* @__PURE__ */ React.createElement("div", {
    className: "relative"
  }, (isError || error) && /* @__PURE__ */ React.createElement(DataTableOverlay, null, /* @__PURE__ */ React.createElement(AlertError, {
    message: "There was an error loading the data."
  })), /* @__PURE__ */ React.createElement(DataTable, __spreadProps(__spreadValues({
    ref: tableRef,
    loading: isLoading,
    actions: [
      {
        label: t("refresh"),
        Icon: RefreshIcon,
        loading: isRefetching || isLoading,
        onClick: () => refetch()
      },
      ...actions
    ]
  }, props), {
    data: resolvedData || []
  })));
});
var DataTable = forwardRef13(function DataTable2({
  id,
  loading,
  actions = [],
  actionElements,
  filterOptions,
  options,
  columns,
  columnPinning = {},
  columnVisibility = {},
  initialSortingState = [],
  initialPageSize = 20,
  rowClassName,
  getSubRows,
  pagination = true,
  onRowContextMenu,
  onRowClick,
  onCellClick,
  title,
  search = true,
  data = [],
  toolbar,
  border = true,
  header = true
}, ref) {
  var _b;
  const { t } = useTranslation6();
  const prevId = usePrevious(id);
  const [sorting, setSorting] = useState5(initialSortingState);
  const [columnFilters, setColumnFilters] = useState5([]);
  const [baseColumnVisibility, setColumnVisibility] = useState5({ id: false });
  const [rowSelection, setRowSelection] = useState5({});
  const [globalFilter, setGlobalFilter] = useState5("");
  const [expanded, setExpanded] = useState5({});
  const _a = options || {}, { initialState, state } = _a, rest = __objRest(_a, ["initialState", "state"]);
  const table = useReactTable(__spreadValues({
    data,
    columns,
    getSubRows,
    onExpandedChange: setExpanded,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    onSortingChange: setSorting,
    getSortedRowModel: getSortedRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
    onColumnFiltersChange: setColumnFilters,
    getFilteredRowModel: getFilteredRowModel(),
    onColumnVisibilityChange: setColumnVisibility,
    onRowSelectionChange: setRowSelection,
    manualPagination: !pagination,
    paginateExpandedRows: false,
    autoResetAll: false,
    initialState: __spreadProps(__spreadValues({}, initialState), {
      pagination: {
        pageSize: initialPageSize
      }
    }),
    state: __spreadValues({
      expanded,
      sorting,
      columnFilters,
      columnPinning,
      columnVisibility: __spreadValues(__spreadValues({}, baseColumnVisibility), columnVisibility),
      rowSelection
    }, state)
  }, rest));
  useImperativeHandle(ref, () => table, [table]);
  useEffect3(() => {
    if (prevId && id && id !== prevId) {
      setGlobalFilter("");
    }
  }, [id, prevId]);
  const filterOptionItems = useMemo4(() => {
    return ((filterOptions == null ? void 0 : filterOptions.map(({ accessorKey, title: title2, sortComparator, hide: hide2 }) => {
      const column = columns.find((c) => c.accessorKey === accessorKey);
      if (!column || hide2)
        return null;
      const uniqueRows = uniqBy(data, accessorKey);
      const options2 = [];
      uniqueRows.forEach((r) => {
        const value = get(r, accessorKey);
        const accessorFn = column.accessorFn;
        if (!value)
          return;
        const formattedValue = accessorFn ? accessorFn(r) : value;
        options2.push({
          label: formattedValue,
          value: formattedValue
        });
      });
      return /* @__PURE__ */ React.createElement(DataTableFacetedFilter, {
        key: accessorKey,
        column: table.getColumn(accessorKey),
        title: title2,
        onFilterChange: () => {
          table.setPageIndex(0);
        },
        options: options2,
        sortComparator
      });
    })) || []).filter((x) => x);
  }, [columns, data, filterOptions, table]);
  return /* @__PURE__ */ React.createElement("div", null, header && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
    className: "flex sm:flex-row flex-col items-start sm:items-center justify-between gap-2 pb-4"
  }, /* @__PURE__ */ React.createElement("div", null, title && /* @__PURE__ */ React.createElement("h3", {
    className: "text-lg sm:text-[28px] sm:leading-[34px] sm:pl-4 text-white"
  }, title)), /* @__PURE__ */ React.createElement("div", {
    className: "flex sm:flex-row flex-col items-center justify-between mobile-w-full sm:justify-start gap-2"
  }, search ? /* @__PURE__ */ React.createElement(TextInput, {
    prefix: /* @__PURE__ */ React.createElement(SearchIcon, null),
    placeholder: t("search_placeholder"),
    value: globalFilter,
    onChange: (event) => {
      setGlobalFilter(event.target.value);
      table.setGlobalFilter(event.target.value);
      table.setPageIndex(0);
    },
    suffix: /* @__PURE__ */ React.createElement("div", {
      className: cn("flex items-center justify-center h-[22px]", {
        invisible: !globalFilter
      })
    }, /* @__PURE__ */ React.createElement("button", {
      type: "button",
      className: "bg-transparent",
      onClick: (e) => {
        e.stopPropagation();
        e.preventDefault();
        setGlobalFilter("");
        table.setGlobalFilter("");
        table.setPageIndex(0);
      }
    }, /* @__PURE__ */ React.createElement(IconX2, {
      className: "w-4 h-4 foreground-muted"
    }))),
    className: "max-w-sm py-[5px] text-xs"
  }) : /* @__PURE__ */ React.createElement("div", null), filterOptionItems, actionElements), /* @__PURE__ */ React.createElement("div", {
    className: "mobile-w-full flex flex-row items-center sm:justify-start justify-end gap-2"
  }, /* @__PURE__ */ React.createElement(DataGridHeaderAction, {
    disabled: loading,
    label: t("export_csv"),
    Icon: DownloadIcon,
    onClick: () => {
      onExportCsv("export", table.getPrePaginationRowModel().rows);
    }
  }), actions.map((action) => /* @__PURE__ */ React.createElement(DataGridHeaderAction, __spreadValues({
    key: action.label
  }, action))))), toolbar), /* @__PURE__ */ React.createElement("div", {
    className: cn("rounded-md", {
      border: !!border
    })
  }, /* @__PURE__ */ React.createElement(Table, null, /* @__PURE__ */ React.createElement(TableHeader, {
    className: "flex sm:table-header-group"
  }, table.getHeaderGroups().map((headerGroup) => /* @__PURE__ */ React.createElement(TableRow, {
    className: cn("sm:w-[unset] w-full", {
      "!border-0": !border
    }),
    key: headerGroup.id
  }, headerGroup.headers.map((header2, idx) => {
    const meta = header2.column.columnDef.meta;
    const content = header2.isPlaceholder ? null : flexRender(header2.column.columnDef.header, header2.getContext());
    return /* @__PURE__ */ React.createElement(TableHead, {
      key: header2.id,
      className: cn("h-[30px] text-[10px] leading-3 text-center", {
        "border-solid border-line": !!border,
        "border-l": idx !== 0 && !!border,
        "border-r": headerGroup.headers.length - 1 < idx && border,
        "text-center": meta == null ? void 0 : meta.center,
        "whitespace-nowrap": meta == null ? void 0 : meta.grow
      }, meta == null ? void 0 : meta.tableHeaderClassName, header2.subHeaders.length === 0 && (meta == null ? void 0 : meta.childTableHeaderClassName)),
      colSpan: header2.colSpan
    }, /* @__PURE__ */ React.createElement("div", {
      className: cn("flex items-center justify-center gap-1 relative", meta == null ? void 0 : meta.tableHeaderContainerClassName)
    }, (meta == null ? void 0 : meta.tooltip) ? /* @__PURE__ */ React.createElement(Tooltip, {
      content: meta.tooltip
    }, /* @__PURE__ */ React.createElement("div", {
      className: "flex items-center gap-1"
    }, content, /* @__PURE__ */ React.createElement(QuestionSmallIcon, {
      className: "opacity-80"
    }))) : content, (meta == null ? void 0 : meta.subheading) && /* @__PURE__ */ React.createElement("div", {
      className: "text-[7px] top-[10px] absolute"
    }, meta.subheading)));
  })))), /* @__PURE__ */ React.createElement(TableBody, null, loading && /* @__PURE__ */ React.createElement(DataTableLoadingSkeleton, null), !loading && /* @__PURE__ */ React.createElement(React.Fragment, null, ((_b = table.getRowModel().rows) == null ? void 0 : _b.length) ? table.getRowModel().rows.map((row) => {
    return /* @__PURE__ */ React.createElement(Fragment2, {
      key: row.id
    }, /* @__PURE__ */ React.createElement(TableRow, {
      className: cn("sm:table-row flex flex-wrap", {
        "border-0": !border
      }, rowClassName),
      onContextMenu: (e) => {
        e.preventDefault();
        e.stopPropagation();
        onRowContextMenu == null ? void 0 : onRowContextMenu(row);
      },
      onClick: () => {
        onRowClick == null ? void 0 : onRowClick(row);
      },
      "data-state": row.getIsSelected() && "selected"
    }, row.getVisibleCells().map((cell) => {
      var _a2, _b2, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
      return /* @__PURE__ */ React.createElement(TableCell, {
        className: cn("text-[10px] px-2 py-0.5 w-full sm:w-[unset] sm:table-cell flex", {
          "border-solid border-line": !!border,
          "border-l": (_b2 = (_a2 = cell.column.columnDef) == null ? void 0 : _a2.meta) == null ? void 0 : _b2.borderLeft,
          "border-r": (_d = (_c = cell.column.columnDef) == null ? void 0 : _c.meta) == null ? void 0 : _d.borderRight,
          "rounded-l-lg": (_f = (_e = cell.column.columnDef) == null ? void 0 : _e.meta) == null ? void 0 : _f.roundedLeft,
          "rounded-r-lg": (_h = (_g = cell.column.columnDef) == null ? void 0 : _g.meta) == null ? void 0 : _h.roundedRight,
          "text-center": (_j = (_i = cell.column.columnDef) == null ? void 0 : _i.meta) == null ? void 0 : _j.center,
          "whitespace-nowrap": (_l = (_k = cell.column.columnDef) == null ? void 0 : _k.meta) == null ? void 0 : _l.grow
        }, (_n = (_m = cell.column.columnDef) == null ? void 0 : _m.meta) == null ? void 0 : _n.cellClassName),
        key: cell.id,
        onClick: () => {
          onCellClick == null ? void 0 : onCellClick(cell);
        }
      }, flexRender(cell.column.columnDef.cell, cell.getContext()));
    })));
  }) : /* @__PURE__ */ React.createElement(TableRow, null, /* @__PURE__ */ React.createElement(TableCell, {
    colSpan: 1e3,
    className: "h-24 text-center"
  }, globalFilter ? "No Results" : "No data")))))), pagination && /* @__PURE__ */ React.createElement(DataTablePagination, {
    className: clsx17({ invisible: loading }),
    table
  }));
});

// src/DataTable/DataTableColumnHeader.tsx
function DataTableColumnHeader({
  column,
  title,
  className,
  minimal
}) {
  var _a;
  if (!column.getCanSort() || minimal) {
    return /* @__PURE__ */ React.createElement("div", {
      className: cn("text-[10px] whitespace-nowrap", className)
    }, title);
  }
  const wrap = (_a = column.columnDef.meta) == null ? void 0 : _a.wrap;
  return /* @__PURE__ */ React.createElement("div", {
    className: cn("flex items-center space-x-2", className)
  }, /* @__PURE__ */ React.createElement(Button, {
    variant: "ghost",
    size: "xs",
    className: "-ml-3 h-4 hover:bg-[unset] pr-0",
    onClick: () => {
      if (column.getIsSorted() === "asc") {
        column.toggleSorting(true);
      } else {
        column.toggleSorting(false);
      }
    }
  }, /* @__PURE__ */ React.createElement("span", {
    className: cn("text-[10px] leading-[12px]", {
      "whitespace-nowrap": !wrap,
      "whitespace-break-spaces": wrap
    })
  }, title), column.getIsSorted() === "desc" ? /* @__PURE__ */ React.createElement(ArrowDownSmall, {
    className: "ml-2"
  }) : column.getIsSorted() === "asc" ? /* @__PURE__ */ React.createElement(ArrowUpSmall, {
    className: "ml-2"
  }) : /* @__PURE__ */ React.createElement(React.Fragment, null)));
}

// src/DataTable/DataTableRenderers.tsx
import i18n3, { useTranslation as useTranslation7 } from "@sg/i18n";
import { decimalFormatter, fmtLocalDateTime, fmtUTCDate, fmtUTCDateTime, getDisplayPriceDecimals } from "@sg/utils";
import { IconCopy } from "@tabler/icons-react";
import clsx18 from "clsx";
import { truncate } from "lodash";
import { Link as Link2, generatePath } from "react-router-dom";

// src/DropdownMenu/index.tsx
import { IconCheck as IconCheck4, IconChevronRight, IconCircleDotFilled } from "@tabler/icons-react";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import * as React13 from "react";
var DropdownMenu = DropdownMenuPrimitive.Root;
var DropdownMenuTrigger = DropdownMenuPrimitive.Trigger;
var DropdownMenuGroup = DropdownMenuPrimitive.Group;
var DropdownMenuPortal = DropdownMenuPrimitive.Portal;
var DropdownMenuSub = DropdownMenuPrimitive.Sub;
var DropdownMenuRadioGroup = DropdownMenuPrimitive.RadioGroup;
var DropdownMenuSubTrigger = React13.forwardRef((_a, ref) => {
  var _b = _a, { className, inset, children } = _b, props = __objRest(_b, ["className", "inset", "children"]);
  return /* @__PURE__ */ React13.createElement(DropdownMenuPrimitive.SubTrigger, __spreadValues({
    ref,
    className: cn("focus:bg-accent data-[state=open]:bg-accent flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none", inset && "pl-8", className)
  }, props), children, /* @__PURE__ */ React13.createElement(IconChevronRight, {
    className: "ml-auto h-4 w-4"
  }));
});
DropdownMenuSubTrigger.displayName = DropdownMenuPrimitive.SubTrigger.displayName;
var DropdownMenuSubContent = React13.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React13.createElement(DropdownMenuPrimitive.SubContent, __spreadValues({
    ref,
    className: cn("bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-[8rem] overflow-hidden rounded-md border p-1 shadow-lg", className)
  }, props));
});
DropdownMenuSubContent.displayName = DropdownMenuPrimitive.SubContent.displayName;
var DropdownMenuContent = React13.forwardRef((_a, ref) => {
  var _b = _a, { className, sideOffset = 4 } = _b, props = __objRest(_b, ["className", "sideOffset"]);
  return /* @__PURE__ */ React13.createElement(DropdownMenuPrimitive.Portal, null, /* @__PURE__ */ React13.createElement(DropdownMenuPrimitive.Content, __spreadValues({
    ref,
    sideOffset,
    className: cn("bg-popover text-popover-foreground z-50 min-w-[8rem] overflow-hidden rounded-md border p-1 shadow-md", "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className)
  }, props)));
});
DropdownMenuContent.displayName = DropdownMenuPrimitive.Content.displayName;
var DropdownMenuItem = React13.forwardRef((_a, ref) => {
  var _b = _a, { className, inset } = _b, props = __objRest(_b, ["className", "inset"]);
  return /* @__PURE__ */ React13.createElement(DropdownMenuPrimitive.Item, __spreadValues({
    ref,
    className: cn("focus:bg-accent focus:text-accent-foreground relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors data-[disabled]:pointer-events-none data-[disabled]:opacity-50", inset && "pl-8", className)
  }, props));
});
DropdownMenuItem.displayName = DropdownMenuPrimitive.Item.displayName;
var DropdownMenuCheckboxItem = React13.forwardRef((_a, ref) => {
  var _b = _a, { className, children, checked } = _b, props = __objRest(_b, ["className", "children", "checked"]);
  return /* @__PURE__ */ React13.createElement(DropdownMenuPrimitive.CheckboxItem, __spreadValues({
    ref,
    className: cn("focus:bg-accent focus:text-accent-foreground relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors data-[disabled]:pointer-events-none data-[disabled]:opacity-50", className),
    checked
  }, props), /* @__PURE__ */ React13.createElement("span", {
    className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center"
  }, /* @__PURE__ */ React13.createElement(DropdownMenuPrimitive.ItemIndicator, null, /* @__PURE__ */ React13.createElement(IconCheck4, {
    className: "h-4 w-4"
  }))), children);
});
DropdownMenuCheckboxItem.displayName = DropdownMenuPrimitive.CheckboxItem.displayName;
var DropdownMenuRadioItem = React13.forwardRef((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ React13.createElement(DropdownMenuPrimitive.RadioItem, __spreadValues({
    ref,
    className: cn("focus:bg-accent focus:text-accent-foreground relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors data-[disabled]:pointer-events-none data-[disabled]:opacity-50", className)
  }, props), /* @__PURE__ */ React13.createElement("span", {
    className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center"
  }, /* @__PURE__ */ React13.createElement(DropdownMenuPrimitive.ItemIndicator, null, /* @__PURE__ */ React13.createElement(IconCircleDotFilled, {
    className: "h-4 w-4 fill-current"
  }))), children);
});
DropdownMenuRadioItem.displayName = DropdownMenuPrimitive.RadioItem.displayName;
var DropdownMenuLabel = React13.forwardRef((_a, ref) => {
  var _b = _a, { className, inset } = _b, props = __objRest(_b, ["className", "inset"]);
  return /* @__PURE__ */ React13.createElement(DropdownMenuPrimitive.Label, __spreadValues({
    ref,
    className: cn("px-2 py-1.5 text-sm font-semibold", inset && "pl-8", className)
  }, props));
});
DropdownMenuLabel.displayName = DropdownMenuPrimitive.Label.displayName;
var DropdownMenuSeparator = React13.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React13.createElement(DropdownMenuPrimitive.Separator, __spreadValues({
    ref,
    className: cn("bg-muted -mx-1 my-1 h-px", className)
  }, props));
});
DropdownMenuSeparator.displayName = DropdownMenuPrimitive.Separator.displayName;
var DropdownMenuShortcut = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ React13.createElement("span", __spreadValues({
    className: cn("ml-auto text-xs tracking-widest opacity-60", className)
  }, props));
};
DropdownMenuShortcut.displayName = "DropdownMenuShortcut";

// src/Notification/Notification.tsx
import { Transition } from "@headlessui/react";
import i18n2 from "@sg/i18n";
import { IconX as IconX3 } from "@tabler/icons-react";
import { Fragment as Fragment3 } from "react";
import toaster from "react-hot-toast";
import { Link } from "react-router-dom";
var DEFAULT_DURATION = 7500;
var WARN_DURATION = 15e3;
function NotificationMessage({ t, message = "", title, Icon: Icon2, children }) {
  return /* @__PURE__ */ React.createElement(Transition, {
    show: t.visible,
    as: Fragment3,
    enter: "transform ease-out duration-300 transition",
    enterFrom: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
    enterTo: "translate-y-0 opacity-100 sm:translate-x-0",
    leave: "transition ease-in duration-100",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "max-w-sm w-full bg-[#3D424A] shadow-lg rounded-xl overflow-hidden backdrop-blur-[6px]",
    onMouseDown: (event) => event.preventDefault()
  }, /* @__PURE__ */ React.createElement("div", {
    className: "p-4"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "flex items-center gap-4"
  }, Icon2 && /* @__PURE__ */ React.createElement("div", {
    className: "flex-shrink-0"
  }, /* @__PURE__ */ React.createElement(Icon2, {
    className: "h-10 w-10",
    "aria-hidden": "true"
  })), /* @__PURE__ */ React.createElement("div", {
    className: "flex flex-col gap1"
  }, /* @__PURE__ */ React.createElement("p", {
    className: "text-2xl leading-[28px] font-medium text-white"
  }, title), /* @__PURE__ */ React.createElement("p", {
    className: "text-base leading-5 text-white"
  }, message), children), /* @__PURE__ */ React.createElement("div", {
    className: "ml-4 flex-shrink-0 flex -mt-16"
  }, /* @__PURE__ */ React.createElement("button", {
    type: "button",
    className: "rounded-md inline-flex foreground-muted hover:text-foreground focus:outline-none focus:ring-2 dark:ring-offset-black focus:ring-offset-2 focus:ring-primary",
    onClick: () => {
      toaster.dismiss(t.id);
    }
  }, /* @__PURE__ */ React.createElement("span", {
    className: "sr-only"
  }, "Close"), /* @__PURE__ */ React.createElement(IconX3, {
    className: "h-5 w-5",
    "aria-hidden": "true"
  })))))));
}
var notify = {
  info: (message = "", title = "Info") => toaster.custom((t) => /* @__PURE__ */ React.createElement(NotificationMessage, {
    t,
    message,
    title,
    Icon: NotificationInfoIcon
  }), {
    duration: DEFAULT_DURATION
  }),
  success: (message = "", title = "Success") => toaster.custom((t) => /* @__PURE__ */ React.createElement(NotificationMessage, {
    t,
    message,
    title,
    Icon: NotificatioSuccessIcon
  }), {
    duration: DEFAULT_DURATION
  }),
  warn: (message = "", title = "Warning") => toaster.custom((t) => /* @__PURE__ */ React.createElement(NotificationMessage, {
    t,
    message,
    title,
    Icon: NotificationAlertIcon
  }), {
    duration: WARN_DURATION
  }),
  alert: (message = "", title = "Error") => toaster.custom((t) => /* @__PURE__ */ React.createElement(NotificationMessage, {
    t,
    message,
    title,
    Icon: NotificationErrorIcon
  }), {
    duration: WARN_DURATION
  }),
  custom: (content = /* @__PURE__ */ React.createElement(React.Fragment, null), title = "Info") => toaster.custom((t) => /* @__PURE__ */ React.createElement(NotificationMessage, {
    t,
    title
  }, content), {
    duration: DEFAULT_DURATION
  }),
  newResource: (resourceUrl, resource, customMessage) => notify.custom(/* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Link, {
    className: "text-tertiary font-medium underline text-sm",
    to: resourceUrl,
    onClick: dismissNotifications
  }, `${i18n2.t("resource_view", { resource })}`)), customMessage || i18n2.t("resource_created", { resource }))
};
function dismissNotifications() {
  toaster.dismiss();
}
function NotificationAlertIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "72",
    height: "72",
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M66 36C66 52.5685 52.5685 66 36 66C19.4315 66 6 52.5685 6 36C6 19.4315 19.4315 6 36 6C52.5685 6 66 19.4315 66 36Z",
    fill: "#F97316"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M36 21C34.7574 21 33.75 22.0074 33.75 23.25L33.75 41.25C33.75 42.4926 34.7574 43.5 36 43.5C37.2426 43.5 38.25 42.4926 38.25 41.25L38.25 23.25C38.25 22.0074 37.2426 21 36 21Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M36 53.25C34.3431 53.25 33 51.9069 33 50.25C33 48.5931 34.3431 47.25 36 47.25C37.6569 47.25 39 48.5931 39 50.25C39 51.9069 37.6569 53.25 36 53.25Z",
    fill: "white"
  }));
}
function NotificatioSuccessIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "72",
    height: "72",
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M66 36C66 52.5685 52.5685 66 36 66C19.4315 66 6 52.5685 6 36C6 19.4315 19.4315 6 36 6C52.5685 6 66 19.4315 66 36Z",
    fill: "#2FCB2F"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M48.091 26.909C48.9697 27.7877 48.9697 29.2123 48.091 30.091L33.091 45.091C32.2123 45.9697 30.7877 45.9697 29.909 45.091L23.909 39.091C23.0303 38.2123 23.0303 36.7877 23.909 35.909C24.7877 35.0303 26.2123 35.0303 27.091 35.909L31.5 40.318L38.2045 33.6135L44.909 26.909C45.7877 26.0303 47.2123 26.0303 48.091 26.909Z",
    fill: "white"
  }));
}
function NotificationErrorIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "72",
    height: "72",
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M66 36C66 52.5685 52.5685 66 36 66C19.4315 66 6 52.5685 6 36C6 19.4315 19.4315 6 36 6C52.5685 6 66 19.4315 66 36Z",
    fill: "#CE0000"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M26.909 26.909C27.7877 26.0303 29.2123 26.0303 30.091 26.909L36 32.8181L41.909 26.9091C42.7877 26.0304 44.2123 26.0304 45.091 26.9091C45.9697 27.7878 45.9697 29.2124 45.091 30.0911L39.182 36L45.0909 41.9089C45.9696 42.7876 45.9696 44.2123 45.0909 45.0909C44.2122 45.9696 42.7876 45.9696 41.9089 45.0909L36 39.182L30.0911 45.091C29.2124 45.9697 27.7878 45.9697 26.9091 45.091C26.0304 44.2123 26.0304 42.7877 26.9091 41.909L32.818 36L26.909 30.091C26.0303 29.2123 26.0303 27.7877 26.909 26.909Z",
    fill: "white"
  }));
}
function NotificationInfoIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "72",
    height: "72",
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M66 36C66 52.5685 52.5685 66 36 66C19.4315 66 6 52.5685 6 36C6 19.4315 19.4315 6 36 6C52.5685 6 66 19.4315 66 36Z",
    fill: "#1A73E8"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M36 53.25C37.2426 53.25 38.25 52.2426 38.25 51V33C38.25 31.7574 37.2426 30.75 36 30.75C34.7574 30.75 33.75 31.7574 33.75 33V51C33.75 52.2426 34.7574 53.25 36 53.25Z",
    fill: "white"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M36 21C37.6569 21 39 22.3431 39 24C39 25.6569 37.6569 27 36 27C34.3431 27 33 25.6569 33 24C33 22.3431 34.3431 21 36 21Z",
    fill: "white"
  }));
}

// src/Notification/NotificationProvider.tsx
import { Toaster } from "react-hot-toast";

// src/DataTable/DataTableRenderers.tsx
async function copyToClipboard(content) {
  if ("clipboard" in navigator) {
    await navigator.clipboard.writeText(content);
  } else {
    document.execCommand("copy", true, content);
  }
  notify.info(i18n3.t("copied_clipboard", { content: truncate(content, { length: 20 }) }), i18n3.t("copied"));
}
var iconClassName = "w-3 h-3 text-info";
function GridCopyTextRenderer({
  Icon: Icon2,
  value
}) {
  return /* @__PURE__ */ React.createElement("button", {
    type: "button",
    className: "bg-transparent",
    onClick: (e) => {
      e.stopPropagation();
      e.preventDefault();
      copyToClipboard(value);
    }
  }, Icon2 ? /* @__PURE__ */ React.createElement(Icon2, {
    className: iconClassName
  }) : /* @__PURE__ */ React.createElement(IconCopy, {
    className: "w-3 h-3 text-info"
  }));
}
function GridBooleanRenderer({ value }) {
  if (!value)
    return null;
  return /* @__PURE__ */ React.createElement("div", {
    className: "flex items-center justify-center"
  }, /* @__PURE__ */ React.createElement(CheckIcon, {
    className: "text-emerald-600"
  }));
}
function GridDateRenderer({ className, value }) {
  if (!value)
    return null;
  return /* @__PURE__ */ React.createElement("span", {
    className: cn("text-[9px]", className)
  }, fmtUTCDate(value));
}
function GridUTCRenderer({ value }) {
  if (!value)
    return null;
  return /* @__PURE__ */ React.createElement("span", {
    className: "text-[9px]"
  }, `${value} UTC`);
}
function GridLocalTimeRenderer({ value, className }) {
  if (!value)
    return null;
  return /* @__PURE__ */ React.createElement("span", {
    className: cn("text-[9px]", className)
  }, fmtLocalDateTime(`${value}z`));
}
function GridDateTimeRenderer({ value, className }) {
  if (!value)
    return null;
  return /* @__PURE__ */ React.createElement("span", {
    className: cn("text-[9px]", className)
  }, fmtUTCDateTime(value));
}
function GridNumberRenderer({
  value,
  calculated,
  suffix,
  hideSuffix,
  fallback,
  decimals,
  minimumDecimals,
  className
}) {
  if (value == 0)
    return /* @__PURE__ */ React.createElement("span", {
      className: "font-mono"
    }, "0", suffix ? ` ${suffix}` : "");
  if (!value && fallback)
    return /* @__PURE__ */ React.createElement("span", {
      className: "font-mono"
    }, fallback);
  if (!value)
    return null;
  const displayDecimals = decimals != null ? decimals : getDisplayPriceDecimals(typeof suffix === "string" ? suffix : void 0);
  const minDecimals = minimumDecimals != null ? minimumDecimals : displayDecimals;
  return /* @__PURE__ */ React.createElement("span", {
    className: cn("font-mono", className)
  }, /* @__PURE__ */ React.createElement("span", {
    className: cn(calculated && "italic")
  }, decimalFormatter(value, minDecimals, displayDecimals)), suffix && !hideSuffix ? ` ${suffix}` : "");
}
function GridAccountingNumberRenderer({
  value,
  calculated,
  colorizedPositive,
  colorizeNegative,
  suffix,
  fallback,
  ignoreZero,
  defaultDecimals,
  className
}) {
  if (value == 0 && !ignoreZero)
    return /* @__PURE__ */ React.createElement("span", {
      className: "font-mono"
    }, "0", suffix ? ` ${suffix}` : "");
  if (!value && fallback)
    return /* @__PURE__ */ React.createElement("span", {
      className: "font-mono"
    }, fallback);
  if (!value)
    return null;
  const parsedValue = parseFloat(value);
  const decimals = suffix === "USD" ? 2 : defaultDecimals;
  return /* @__PURE__ */ React.createElement("span", {
    className: cn("font-mono", {
      "text-destructive": parsedValue < 0 || colorizeNegative,
      "text-constructive": parsedValue > 0 && colorizedPositive
    }, className)
  }, parsedValue < 0 ? "(" : "", /* @__PURE__ */ React.createElement("span", {
    className: cn(calculated && "italic")
  }, decimalFormatter(Math.abs(parsedValue), 0, decimals)), parsedValue < 0 ? ")" : "", suffix ? ` ${suffix}` : "");
}
function GridCurrencyNumberRenderer({
  value,
  calculated,
  suffix,
  hideSuffix,
  fallback,
  ignoreZero,
  defaultDecimals,
  className
}) {
  if (value == 0 && !ignoreZero)
    return /* @__PURE__ */ React.createElement("span", {
      className: cn("font-mono", className)
    }, "0", suffix ? ` ${suffix}` : "");
  if (!value && fallback)
    return /* @__PURE__ */ React.createElement("span", {
      className: cn("font-mono", className)
    }, fallback);
  if (!value)
    return null;
  return /* @__PURE__ */ React.createElement(GridNumberRenderer, {
    value,
    suffix,
    fallback,
    decimals: suffix === "USD" ? 2 : defaultDecimals,
    calculated,
    hideSuffix,
    className
  });
}
function GridPathRenderer({
  value,
  path,
  params,
  disabled,
  className
}) {
  return disabled ? /* @__PURE__ */ React.createElement(React.Fragment, null, value) : /* @__PURE__ */ React.createElement(Link2, {
    className: cn("text-tertiary font-medium underline", className),
    to: generatePath(path, params)
  }, value);
}
function GridActionCopyID({ label, value }) {
  const { t } = useTranslation7();
  return /* @__PURE__ */ React.createElement(DropdownMenuItem, {
    onClick: () => copyToClipboard(value)
  }, label || t("copy_id"));
}
function GridActionsRenderer({
  actions = [],
  defaultOpen,
  children,
  open,
  onOpenChange,
  disableModal = false,
  side,
  sideOffset,
  alignOffset,
  ignoreOutsideInteraction
}) {
  return /* @__PURE__ */ React.createElement("div", {
    className: "flex items-center justify-center"
  }, /* @__PURE__ */ React.createElement(DropdownMenu, {
    defaultOpen,
    open,
    onOpenChange,
    modal: !disableModal
  }, /* @__PURE__ */ React.createElement(DropdownMenuTrigger, null, /* @__PURE__ */ React.createElement(MenuDotsSquareIcon, {
    className: "hover:opacity-60 transition duration-300 ease-in-out"
  })), /* @__PURE__ */ React.createElement(DropdownMenuPortal, null, /* @__PURE__ */ React.createElement(DropdownMenuContent, {
    side,
    sideOffset,
    align: "end",
    alignOffset,
    onFocusOutside: (event) => {
      if (ignoreOutsideInteraction) {
        event.preventDefault();
      }
    },
    onInteractOutside: (event) => {
      if (ignoreOutsideInteraction) {
        event.preventDefault();
      }
    }
  }, actions.map(({ Icon: Icon2, blank, disabled, hide: hide2, loading, color = "default", onClick }, idx) => {
    if (hide2)
      return /* @__PURE__ */ React.createElement(React.Fragment, null);
    return /* @__PURE__ */ React.createElement(DropdownMenuItem, {
      key: `action-${idx}`
    }, loading && /* @__PURE__ */ React.createElement(Spinner, {
      className: "ml-[5px] mt-0.5",
      size: "xs"
    }), !loading && /* @__PURE__ */ React.createElement(Icon2, {
      onClick: () => onClick(),
      className: clsx18("transition ease-in-out delay-150 hover:scale-[1.2] duration-300 cursor-pointer w-5 h-5", {
        "opacity-60 pointer-events-none": !!disabled && typeof disabled === "function" ? disabled : disabled,
        "text-tertiary": color === "default",
        "text-constructive": color === "create",
        "text-destructive": color === "delete",
        hidden: (!!disabled && typeof disabled === "function" ? disabled : disabled) && blank
      })
    }));
  }), children))));
}

// src/DescriptionList/DescriptionList.tsx
function DescriptionList({ children }) {
  return /* @__PURE__ */ React.createElement("div", {
    className: "px-4 py-5 sm:px-6 min-w-[300px]"
  }, /* @__PURE__ */ React.createElement("dl", {
    className: "grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2"
  }, children));
}

// src/DescriptionList/DescriptionListItem.tsx
import clsx19 from "clsx";
function DescriptionListItem({ className, loading, label, children }) {
  return /* @__PURE__ */ React.createElement("div", {
    className: "sm:col-span-1"
  }, /* @__PURE__ */ React.createElement("dt", {
    className: "text-sm font-medium text-gray-500"
  }, label), /* @__PURE__ */ React.createElement("dd", {
    className: clsx19("mt-1 text-sm text-foreground", className)
  }, loading ? /* @__PURE__ */ React.createElement("div", {
    className: "h-5 mt-2"
  }, /* @__PURE__ */ React.createElement(Skeleton, {
    className: "w-[120px] h-4"
  })) : children));
}

// src/Disclosure/index.tsx
import { Disclosure as HDisclosure } from "@headlessui/react";
import { IconChevronUp } from "@tabler/icons-react";
import clsx20 from "clsx";
function DisclosureItem(_a) {
  var _b = _a, { title, children } = _b, props = __objRest(_b, ["title", "children"]);
  return /* @__PURE__ */ React.createElement(HDisclosure, __spreadValues({}, props), ({ open }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(HDisclosure.Button, {
    className: "flex w-full justify-between rounded-lg p-2 text-left text-sm font-medium text-foreground hover:bg-black/5 hover:dark:bg-white/5 focus:outline-none focus-visible:ring focus-visible:ring-tertiary focus-visible:ring-opacity-75"
  }, /* @__PURE__ */ React.createElement("span", null, title), /* @__PURE__ */ React.createElement(IconChevronUp, {
    className: clsx20("h-5 w-5 text-foreground transition ease-in-out delay-50", {
      "rotate-180 transform": open
    })
  })), /* @__PURE__ */ React.createElement(HDisclosure.Panel, {
    className: "px-4 pt-3 pb-2 text-sm text-gray-500"
  }, children)));
}
function Disclosure({ className, children }) {
  return /* @__PURE__ */ React.createElement("div", {
    className: clsx20("w-full", className)
  }, /* @__PURE__ */ React.createElement("div", {
    className: "mx-auto w-full rounded-2xl border-2 border-solid border-border p-2"
  }, children));
}

// src/Drawer/BaseDrawer.tsx
import { Dialog as Dialog2, Transition as Transition2 } from "@headlessui/react";
import i18n4, { useTranslation as useTranslation8 } from "@sg/i18n";
import { IconX as IconX4 } from "@tabler/icons-react";
import clsx21 from "clsx";
import { Fragment as Fragment4, useRef as useRef2 } from "react";
function BaseDrawer({
  title,
  subtitle,
  open,
  loading,
  children,
  actions,
  onSubmit,
  onClose,
  hidePrimary = false,
  primaryLabel = i18n4.t("create"),
  primaryDisabled,
  closeLabel = i18n4.t("cancel"),
  closeDisabled,
  variant = "default"
}) {
  const formRef = useRef2(null);
  const { t } = useTranslation8();
  const onCloseDrawer = () => {
    if (loading)
      return;
    onClose(false);
  };
  return /* @__PURE__ */ React.createElement(Transition2.Root, {
    show: open,
    as: Fragment4
  }, /* @__PURE__ */ React.createElement(Dialog2, {
    as: "div",
    className: "relative z-[41]",
    onClose: onCloseDrawer
  }, /* @__PURE__ */ React.createElement("div", {
    className: "fixed inset-0"
  }), /* @__PURE__ */ React.createElement("div", {
    className: "fixed inset-0 bg-black/30 backdrop-blur-sm",
    "aria-hidden": "true"
  }), /* @__PURE__ */ React.createElement("div", {
    className: "fixed inset-0 overflow-hidden"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "absolute inset-0 overflow-hidden"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10"
  }, /* @__PURE__ */ React.createElement(Transition2.Child, {
    as: Fragment4,
    enter: "transform transition ease-in-out duration-500 sm:duration-700",
    enterFrom: "translate-x-full",
    enterTo: "translate-x-0",
    leave: "transform transition ease-in-out duration-500 sm:duration-700",
    leaveFrom: "translate-x-0",
    leaveTo: "translate-x-full"
  }, /* @__PURE__ */ React.createElement(Dialog2.Panel, {
    className: "pointer-events-auto w-screen max-w-2xl border-l border-border"
  }, /* @__PURE__ */ React.createElement("form", {
    ref: formRef,
    onSubmit,
    className: clsx21("h-full", {
      "pointer-events-none": loading
    })
  }, /* @__PURE__ */ React.createElement("div", {
    className: "relative flex h-full flex-col divide-y divide-border bg-popover"
  }, loading && /* @__PURE__ */ React.createElement("div", {
    className: "absolute inset-0 z-10 flex items-center justify-center bg-gray-800/40"
  }, /* @__PURE__ */ React.createElement(Spinner, {
    size: "xl"
  })), /* @__PURE__ */ React.createElement("div", {
    className: "flex min-h-0 flex-1 flex-col overflow-y-auto pb-6"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "px-4 py-6 sm:px-6"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "flex items-start justify-between space-x-3"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "space-y-1"
  }, /* @__PURE__ */ React.createElement(Dialog2.Title, {
    className: "text-base font-medium text-foreground"
  }, title), /* @__PURE__ */ React.createElement("p", {
    className: "text-sm text-gray-500"
  }, subtitle)), /* @__PURE__ */ React.createElement("div", {
    className: "flex h-7 items-center"
  }, /* @__PURE__ */ React.createElement("button", {
    type: "button",
    className: "foreground-muted hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-tertiary focus:ring-offset-2 rounded-md bg-transparent dark:ring-offset-background",
    onClick: onCloseDrawer
  }, /* @__PURE__ */ React.createElement("span", {
    className: "sr-only"
  }, t("close_panel")), /* @__PURE__ */ React.createElement(IconX4, {
    className: "h-6 w-6",
    "aria-hidden": "true"
  }))))), /* @__PURE__ */ React.createElement("div", {
    className: "relative mt-6 flex-1 px-4 sm:px-6 space-y-4"
  }, children)), /* @__PURE__ */ React.createElement("div", {
    className: "flex flex-shrink-0 justify-end px-4 py-4 space-x-3"
  }, actions, /* @__PURE__ */ React.createElement(Button, {
    variant: "raised",
    type: "button",
    disabled: closeDisabled,
    onClick: () => {
      setTimeout(() => {
        onCloseDrawer();
      }, 300);
    }
  }, closeLabel), !hidePrimary && /* @__PURE__ */ React.createElement(Button, {
    disabled: primaryDisabled,
    variant,
    type: "submit"
  }, primaryLabel)))))))))));
}

// src/Drawer/CreateDrawer.tsx
import { useTranslation as useTranslation9 } from "@sg/i18n";
function CreateDrawer(props) {
  const { t } = useTranslation9();
  return /* @__PURE__ */ React.createElement(BaseDrawer, __spreadValues({
    primaryLabel: t("create"),
    closeLabel: t("cancel")
  }, props));
}

// src/Drawer/DeleteDrawer.tsx
import { useTranslation as useTranslation10 } from "@sg/i18n";
function DeleteDrawer(props) {
  const { t } = useTranslation10();
  return /* @__PURE__ */ React.createElement(BaseDrawer, __spreadValues({
    variant: "destructive",
    primaryLabel: t("delete"),
    closeLabel: t("cancel")
  }, props));
}

// src/Drawer/EditDrawer.tsx
import { useTranslation as useTranslation11 } from "@sg/i18n";
function EditDrawer(props) {
  const { t } = useTranslation11();
  return /* @__PURE__ */ React.createElement(BaseDrawer, __spreadValues({
    variant: "tertiary",
    primaryLabel: t("save"),
    closeLabel: t("cancel")
  }, props));
}

// src/FileUploader/index.tsx
import { useTranslation as useTranslation12 } from "@sg/i18n";
import { IconDownload, IconEdit, IconPaperclip, IconUpload } from "@tabler/icons-react";
import clsx22 from "clsx";
import { useCallback as useCallback2, useState as useState6 } from "react";
import { useDropzone } from "react-dropzone";
function FileUploaderButton({ loading, disabled, onChange }) {
  const { t } = useTranslation12();
  const onDrop = useCallback2((files) => {
    onChange({ value: files[0] });
  }, [onChange]);
  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  return /* @__PURE__ */ React.createElement("div", __spreadValues({
    className: clsx22("ml-4 flex-shrink-0", {
      "pointer-events-none opacity-60": disabled || loading
    })
  }, getRootProps()), /* @__PURE__ */ React.createElement("input", __spreadValues({}, getInputProps())), /* @__PURE__ */ React.createElement("button", {
    type: "button",
    className: "flex gap-x-2 items-center font-medium text-tertiary hover:text-tertiary/80 dark:hover:text-white"
  }, !loading && /* @__PURE__ */ React.createElement(IconUpload, {
    className: "flex-shrink-0 h-5 w-5",
    "aria-hidden": "true"
  }), loading && /* @__PURE__ */ React.createElement(Spinner, {
    className: "mr-1",
    size: "xs"
  }), t("upload")));
}
function ResourceField({
  canEditName,
  resource,
  hasFile,
  onSave
}) {
  const { t } = useTranslation12();
  const [editingResource, setEditingResource] = useState6(false);
  const [newResourceName, setNewResourceName] = useState6(resource);
  const error = !(newResourceName == null ? void 0 : newResourceName.trim());
  return /* @__PURE__ */ React.createElement("div", {
    className: "flex items-center gap-1"
  }, !editingResource && /* @__PURE__ */ React.createElement("div", {
    className: "ml-2 text-foreground"
  }, resource), editingResource && /* @__PURE__ */ React.createElement("div", {
    className: cn("flex gap-1 justify-center ml-2 mb-1", {
      "items-center": !error,
      "items-start": error
    })
  }, /* @__PURE__ */ React.createElement(TextInput, {
    value: newResourceName,
    onChange: (e) => {
      setNewResourceName(e.target.value);
    },
    error,
    errorLabel: t("error_empty_name")
  }), /* @__PURE__ */ React.createElement(Button, {
    disabled: newResourceName.length === 0,
    variant: "tertiary",
    onClick: () => {
      setEditingResource(false);
      onSave == null ? void 0 : onSave(newResourceName);
    }
  }, "Save")), hasFile && canEditName && /* @__PURE__ */ React.createElement(React.Fragment, null, !editingResource && /* @__PURE__ */ React.createElement("button", {
    type: "button",
    onClick: () => {
      setEditingResource(true);
    }
  }, /* @__PURE__ */ React.createElement(IconEdit, {
    className: "w-4 h-4 text-tertiary"
  }))));
}
function FileUploader({
  loading = false,
  optional = false,
  canEditName,
  disabled,
  resource,
  fileName,
  helpText,
  hideUpload,
  onResourceNameChange,
  onChange,
  onDownload,
  error,
  errorLabel
}) {
  const { t } = useTranslation12();
  const [file, setFile] = useState6();
  const hasFile = fileName || !!file;
  return /* @__PURE__ */ React.createElement("li", {
    className: "pl-3 pr-4 py-3 flex items-center justify-between text-sm"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "w-0 flex-1 flex items-center"
  }, /* @__PURE__ */ React.createElement(IconPaperclip, {
    className: "flex-shrink-0 h-5 w-5 text-gray-400",
    "aria-hidden": "true"
  }), /* @__PURE__ */ React.createElement("div", {
    className: "flex-col flex-1"
  }, /* @__PURE__ */ React.createElement(ResourceField, {
    resource,
    canEditName,
    hasFile: !!hasFile,
    onSave: onResourceNameChange
  }), loading && /* @__PURE__ */ React.createElement(Skeleton, {
    className: "ml-2 w-24 !h-[10px]"
  }), !loading && /* @__PURE__ */ React.createElement(React.Fragment, null, error && /* @__PURE__ */ React.createElement("div", {
    className: "ml-2 text-[10px] leading-[10px] text-destructive"
  }, errorLabel), !error && !hasFile && /* @__PURE__ */ React.createElement("div", {
    className: "ml-2 foreground-secondary text-[10px] leading-[10px]"
  }, `${helpText != null ? helpText : t("upload_prompt")} ${optional ? `(${t("optional")})` : ""}`), !error && hasFile && /* @__PURE__ */ React.createElement(Tooltip, {
    content: /* @__PURE__ */ React.createElement("div", {
      className: "max-w-[300px] break-all"
    }, fileName || (file == null ? void 0 : file.name))
  }, /* @__PURE__ */ React.createElement("div", {
    className: "ml-2 foreground-secondary text-[10px] leading-[10px] max-w-[400px] truncate"
  }, fileName || (file == null ? void 0 : file.name)))))), hasFile && !!onDownload && /* @__PURE__ */ React.createElement("button", {
    type: "button",
    onClick: onDownload,
    className: clsx22("font-medium text-tertiary hover:text-tertiary/80 dark:hover:text-white pr-4", {
      "border-r border-border border-solid": !hideUpload,
      "pointer-events-none opacity-60": loading
    })
  }, !loading && /* @__PURE__ */ React.createElement(IconDownload, {
    className: "flex-shrink-0 h-5 w-5",
    "aria-hidden": "true"
  }), loading && /* @__PURE__ */ React.createElement(Spinner, {
    className: "mr-1",
    size: "xs"
  })), !hideUpload && /* @__PURE__ */ React.createElement(FileUploaderButton, {
    disabled,
    loading,
    onChange: (event) => {
      setFile(event.value);
      onChange(event);
    }
  }));
}

// src/Label/index.tsx
import * as LabelPrimitive from "@radix-ui/react-label";
import { cva as cva3 } from "class-variance-authority";
import * as React14 from "react";
var labelVariants = cva3("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70");
var Label2 = React14.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React14.createElement(LabelPrimitive.Root, __spreadValues({
    ref,
    className: cn(labelVariants(), className)
  }, props));
});
Label2.displayName = LabelPrimitive.Root.displayName;

// src/Logo/index.tsx
function Logo({ className }) {
  return /* @__PURE__ */ React.createElement(React.Fragment, null);
}

// src/MultiFileUploader/index.tsx
import { useTranslation as useTranslation13 } from "@sg/i18n";
import { IconUpload as IconUpload2 } from "@tabler/icons-react";
import clsx23 from "clsx";
import { useCallback as useCallback3 } from "react";
import { useDropzone as useDropzone2 } from "react-dropzone";
function MultiFileUploaderButton({ loading, disabled, onChange }) {
  const { t } = useTranslation13();
  const onDrop = useCallback3((files) => {
    onChange({ value: files });
  }, [onChange]);
  const { getRootProps, getInputProps } = useDropzone2({ onDrop, multiple: true });
  return /* @__PURE__ */ React.createElement("div", __spreadValues({
    className: clsx23("ml-4 flex-shrink-0", {
      "pointer-events-none opacity-60": disabled || loading
    })
  }, getRootProps()), /* @__PURE__ */ React.createElement("input", __spreadValues({}, getInputProps())), /* @__PURE__ */ React.createElement("button", {
    type: "button",
    className: "flex gap-x-2 items-center font-medium text-tertiary hover:text-tertiary/80 dark:hover:text-white"
  }, !loading && /* @__PURE__ */ React.createElement(IconUpload2, {
    className: "flex-shrink-0 h-5 w-5",
    "aria-hidden": "true"
  }), loading && /* @__PURE__ */ React.createElement(Spinner, {
    className: "mr-1",
    size: "xs"
  }), t("upload_multiple")));
}

// src/Select/index.tsx
import * as SelectPrimitive from "@radix-ui/react-select";
import { IconCheck as IconCheck5, IconSelector } from "@tabler/icons-react";
import * as React15 from "react";
"use client";
var Select = SelectPrimitive.Root;
var SelectGroup = SelectPrimitive.Group;
var SelectValue = SelectPrimitive.Value;
var SelectTrigger = React15.forwardRef((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ React15.createElement(SelectPrimitive.Trigger, __spreadValues({
    ref,
    className: cn("flex h-9 w-full items-center justify-between rounded-xl bg-black bg-gradient px-3 py-2 text-sm shadow-inner placeholder:text-muted-foreground focus:outline-none focus:ring-0 disabled:cursor-not-allowed disabled:opacity-50", className)
  }, props), children, /* @__PURE__ */ React15.createElement(SelectPrimitive.Icon, {
    asChild: true
  }, /* @__PURE__ */ React15.createElement(IconSelector, {
    className: "h-4 w-4 opacity-50"
  })));
});
SelectTrigger.displayName = SelectPrimitive.Trigger.displayName;
var SelectContent = React15.forwardRef((_a, ref) => {
  var _b = _a, { className, children, position = "popper" } = _b, props = __objRest(_b, ["className", "children", "position"]);
  return /* @__PURE__ */ React15.createElement(SelectPrimitive.Portal, null, /* @__PURE__ */ React15.createElement(SelectPrimitive.Content, __spreadValues({
    ref,
    className: cn("relative z-50 min-w-[8rem] overflow-hidden rounded-xl border bg-gradient text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", position === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1", className),
    position,
    side: "top"
  }, props), /* @__PURE__ */ React15.createElement(SelectPrimitive.Viewport, {
    className: cn("p-1", position === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]")
  }, children)));
});
SelectContent.displayName = SelectPrimitive.Content.displayName;
var SelectLabel = React15.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React15.createElement(SelectPrimitive.Label, __spreadValues({
    ref,
    className: cn("px-2 py-1.5 text-sm font-semibold", className)
  }, props));
});
SelectLabel.displayName = SelectPrimitive.Label.displayName;
var SelectItem = React15.forwardRef((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ React15.createElement(SelectPrimitive.Item, __spreadValues({
    ref,
    className: cn("relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-2 pr-8 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50", className)
  }, props), /* @__PURE__ */ React15.createElement("span", {
    className: "absolute right-2 flex h-3.5 w-3.5 items-center justify-center"
  }, /* @__PURE__ */ React15.createElement(SelectPrimitive.ItemIndicator, null, /* @__PURE__ */ React15.createElement(IconCheck5, {
    className: "h-4 w-4"
  }))), /* @__PURE__ */ React15.createElement(SelectPrimitive.ItemText, null, children));
});
SelectItem.displayName = SelectPrimitive.Item.displayName;
var SelectSeparator = React15.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React15.createElement(SelectPrimitive.Separator, __spreadValues({
    ref,
    className: cn("-mx-1 my-1 h-px bg-muted", className)
  }, props));
});
SelectSeparator.displayName = SelectPrimitive.Separator.displayName;

// src/Steps/index.tsx
import clsx24 from "clsx";
import { Fragment as Fragment5 } from "react";
function StepSkeleton() {
  return /* @__PURE__ */ React.createElement("li", {
    className: "md:flex-1"
  }, /* @__PURE__ */ React.createElement("a", {
    className: "group pl-4 py-2 flex flex-col border-l-4 border-gray-200 hover:border-gray-300 md:pl-0 md:pt-4 md:pb-0 md:border-l-0 md:border-t-4"
  }, /* @__PURE__ */ React.createElement(Skeleton, {
    className: "w-28 my-2"
  }), /* @__PURE__ */ React.createElement(Skeleton, {
    className: "w-4"
  })));
}
function StepIcon({ index, active, complete }) {
  return /* @__PURE__ */ React.createElement("div", {
    className: clsx24("w-11 h-11 rounded-[60px] flex items-center justify-center", {
      "bg-[#18202D] hover:bg-[#242C3B]": !active
    }),
    style: { background: active ? "linear-gradient(125.73deg, #67F767 1.26%, #00CC00 72.2%)" : void 0 }
  }, complete ? /* @__PURE__ */ React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M16.0303 8.96967C16.3232 9.26256 16.3232 9.73744 16.0303 10.0303L11.0303 15.0303C10.7374 15.3232 10.2626 15.3232 9.96967 15.0303L7.96967 13.0303C7.67678 12.7374 7.67678 12.2626 7.96967 11.9697C8.26256 11.6768 8.73744 11.6768 9.03033 11.9697L10.5 13.4393L12.7348 11.2045L14.9697 8.96967C15.2626 8.67678 15.7374 8.67678 16.0303 8.96967Z",
    fill: "white"
  })) : /* @__PURE__ */ React.createElement("span", {
    className: clsx24("text-white", {
      "opacity-20": !active
    })
  }, index + 1));
}
function Steps({ selectedId, loading, items, onClick = () => {
} }) {
  return /* @__PURE__ */ React.createElement("nav", {
    "aria-label": "Progress"
  }, /* @__PURE__ */ React.createElement("ol", {
    role: "list",
    className: "space-y-4 md:flex md:space-y-0 md:space-x-4"
  }, loading && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StepSkeleton, null), /* @__PURE__ */ React.createElement(StepSkeleton, null), /* @__PURE__ */ React.createElement(StepSkeleton, null), /* @__PURE__ */ React.createElement(StepSkeleton, null)), !loading && items.map((step, stepIdx) => {
    const { id, name, status } = step;
    const next = items[stepIdx + 1];
    const activeBorder = status === "current" /* current */ || status === "complete" /* complete */;
    const selected = selectedId === id;
    const classes = {
      "group pl-4 py-2 flex flex-col items-center justify-center gap-3": true
    };
    return /* @__PURE__ */ React.createElement(Fragment5, {
      key: step.name
    }, /* @__PURE__ */ React.createElement("li", {
      className: "md:flex-1 cursor-pointer"
    }, status === "complete" /* complete */ && /* @__PURE__ */ React.createElement("a", {
      onClick: () => onClick(id, name, stepIdx),
      className: clsx24(classes)
    }, /* @__PURE__ */ React.createElement(StepIcon, {
      index: stepIdx,
      complete: true,
      active: true
    }), /* @__PURE__ */ React.createElement("span", {
      className: "text-base leading-5 text-white text-center w-[128px]"
    }, name)), status === "followUp" /* followUp */ && /* @__PURE__ */ React.createElement("a", {
      onClick: () => onClick(id, name, stepIdx),
      className: clsx24(classes)
    }, /* @__PURE__ */ React.createElement(StepIcon, {
      index: stepIdx,
      active: true
    }), /* @__PURE__ */ React.createElement("span", {
      className: "text-base leading-5 text-white text-center w-[128px]"
    }, name)), status === "current" /* current */ && /* @__PURE__ */ React.createElement("a", {
      onClick: () => onClick(id, name, stepIdx),
      className: clsx24(classes),
      "aria-current": "step"
    }, /* @__PURE__ */ React.createElement(StepIcon, {
      index: stepIdx,
      active: true
    }), /* @__PURE__ */ React.createElement("span", {
      className: "text-base leading-5 text-white text-center w-[128px]"
    }, name)), status === "upcoming" /* upcoming */ && /* @__PURE__ */ React.createElement("a", {
      onClick: () => onClick(id, name, stepIdx),
      className: clsx24(classes)
    }, /* @__PURE__ */ React.createElement(StepIcon, {
      index: stepIdx,
      active: selected
    }), /* @__PURE__ */ React.createElement("span", {
      className: "text-base leading-5 text-white text-center w-[128px]"
    }, name))), !!next && /* @__PURE__ */ React.createElement("div", {
      className: "flex items-center justify-center w-full md:ml-0 ml-2"
    }, /* @__PURE__ */ React.createElement("div", {
      className: clsx24("md:w-full border border-1 border-dashed h-6 w-[1px] md:h-[1px]", {
        "border-[#00CC00]": activeBorder,
        "border-[#242C3B]": !activeBorder
      })
    })));
  })));
}

// src/Switch/index.tsx
import * as SwitchPrimitives from "@radix-ui/react-switch";
import * as React16 from "react";
var Switch = React16.forwardRef((_a, ref) => {
  var _b = _a, { className, label } = _b, props = __objRest(_b, ["className", "label"]);
  return /* @__PURE__ */ React16.createElement("div", {
    className: "flex items-center space-x-2"
  }, label && /* @__PURE__ */ React16.createElement(Label2, {
    htmlFor: props.id
  }, label), /* @__PURE__ */ React16.createElement(SwitchPrimitives.Root, __spreadProps(__spreadValues({
    className: cn("peer inline-flex h-[20px] w-[36px] shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input", className)
  }, props), {
    ref
  }), /* @__PURE__ */ React16.createElement(SwitchPrimitives.Thumb, {
    className: cn("pointer-events-none block h-4 w-4 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0")
  })));
});
Switch.displayName = SwitchPrimitives.Root.displayName;

// src/Tabs/index.tsx
import * as TabsPrimitive from "@radix-ui/react-tabs";
import React17 from "react";
var TabsCore = TabsPrimitive.Root;
var TabsList = React17.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React17.createElement(TabsPrimitive.List, __spreadValues({
    ref,
    className: cn("inline-flex h-11 items-center justify-center rounded-xl bg-gradient p-1", className)
  }, props));
});
TabsList.displayName = TabsPrimitive.List.displayName;
var TabsTrigger = React17.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React17.createElement(TabsPrimitive.Trigger, __spreadValues({
    ref,
    className: cn("inline-flex items-center justify-center whitespace-nowrap h-full px-3 py-1 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:text-white/100 data-[state=inactive]:hover:text-white/50 text-white/30", className)
  }, props));
});
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;
var TabsContent = React17.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React17.createElement(TabsPrimitive.Content, __spreadValues({
    ref,
    className: cn("mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2", className)
  }, props));
});
TabsContent.displayName = TabsPrimitive.Content.displayName;
function Tabs({ items, disabled, selected, onChange }) {
  var _a;
  return /* @__PURE__ */ React17.createElement("div", {
    className: "h-11"
  }, /* @__PURE__ */ React17.createElement("div", {
    className: "sm:hidden"
  }, /* @__PURE__ */ React17.createElement("label", {
    htmlFor: "tabs",
    className: "sr-only"
  }, "Select a tab"), /* @__PURE__ */ React17.createElement("select", {
    id: "tabs",
    name: "tabs",
    className: "block w-full pl-3 pr-10 py-2 text-base border-input focus:outline-none focus:ring-tertiary focus:border-tertiary dark:focus:ring-tertiary dark:focus:border-tertiary sm:text-sm rounded-md bg-transparent text-foreground",
    value: selected || void 0,
    onChange: (e) => {
      onChange == null ? void 0 : onChange(e.target.value);
    }
  }, items.map(({ label, value }) => /* @__PURE__ */ React17.createElement("option", {
    key: `mobile-${value}`,
    value
  }, label)))), /* @__PURE__ */ React17.createElement(TabsCore, {
    defaultValue: (_a = items[0]) == null ? void 0 : _a.value,
    value: selected || void 0,
    onValueChange: onChange
  }, /* @__PURE__ */ React17.createElement(TabsList, {
    className: cn("hidden sm:inline-block", {
      "pointer-events-none opacity-20": disabled
    })
  }, items.map(({ label, value, disabled: disabled2 }) => /* @__PURE__ */ React17.createElement(TabsTrigger, {
    disabled: disabled2,
    value,
    key: value
  }, label))), items.map(({ content, value }) => /* @__PURE__ */ React17.createElement(TabsContent, {
    value,
    key: value
  }, content))));
}
export {
  Actions,
  Alert,
  AlertDescription,
  AlertDialog,
  AlertError,
  AlertIcon,
  AlertInfo,
  AlertSuccess,
  AlertTitle,
  AlertWarning,
  ArrowDownIcon,
  ArrowDownSmall,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowUpIcon,
  ArrowUpSmall,
  Avatar,
  Badge,
  BaseAlert,
  BaseAlertIcon,
  BaseDrawer,
  BaseInfoIcon,
  Button,
  ButtonGroup,
  ButtonGroupControlled,
  ButtonPopover,
  CSVIcon,
  Card,
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  ChartSquareIcon,
  CheckIcon,
  Checkbox,
  CheckboxOffIcon,
  CheckboxOnIcon,
  ChooseIcon,
  ChooseSmallIcon,
  CloseIcon,
  CopyIcon,
  CopySmallIcon,
  CreateDrawer,
  DataGridHeaderAction,
  DataTable,
  DataTableColumnHeader,
  DataTableRowExpandButton,
  DeleteDrawer,
  DescriptionList,
  DescriptionListItem,
  Dialog,
  DialogActions,
  DialogCloser,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogPrimitive,
  DialogTitle,
  DialogTrigger,
  Disclosure,
  DisclosureItem,
  DownloadIcon,
  DropdownArrow,
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
  DualArrowsDownIcon,
  DualArrowsLeftIcon,
  DualArrowsRightIcon,
  DualArrowsUpIcon,
  EditDrawer,
  EditIcon,
  EyeClosedIcon,
  EyeIcon,
  FileIcon,
  FileUploader,
  FileUploaderButton,
  Filter2Icon,
  FolderOpenIcon,
  FormHelpLabel,
  FormLabel,
  GearIcon,
  GridAccountingNumberRenderer,
  GridActionCopyID,
  GridActionsRenderer,
  GridBooleanRenderer,
  GridCopyTextRenderer,
  GridCurrencyNumberRenderer,
  GridDateRenderer,
  GridDateTimeRenderer,
  GridLocalTimeRenderer,
  GridNumberRenderer,
  GridPathRenderer,
  GridUTCRenderer,
  InfoDialog,
  InfoIcon,
  Label2 as Label,
  Logo,
  MenuDotsSquareIcon,
  MonitorIcon,
  MultiFileUploaderButton,
  MultiSelectMenu,
  NotificationMessage,
  Toaster as NotificationProvider,
  Popover,
  PopoverContent,
  PopoverTrigger,
  ProfileIcon,
  Progress,
  QuestionMarkIcon,
  QuestionSmallIcon,
  RefreshIcon,
  RemoteDataTable,
  SearchIcon,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectMenu,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
  Separator,
  SettingsIcon,
  ShareIcon,
  Size,
  Skeleton,
  SkeletonAvatar,
  SkeletonTextInput,
  SkeletonTextInputArea,
  Spinner,
  Steps,
  SuccessIcon,
  Switch,
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
  Tabs,
  TextInput,
  TextInputArea,
  Tooltip,
  TradeIcon,
  TrashIcon,
  UploadIcon,
  UserIcon,
  WarningIcon,
  ZoomInIcon,
  ZoomOutIcon,
  badgeVariants,
  buttonVariants,
  cn,
  copyToClipboard,
  dismissNotifications,
  filterFn,
  floatAccessor,
  makeOptions,
  notify,
  onExportCsv,
  useDialog
};
